export default [{
	"name": "东城区",
	"adcode": 110101,
	"center": [116.418757, 39.917544]
}, {
	"name": "西城区",
	"adcode": 110102,
	"center": [116.366794, 39.915309]
}, {
	"name": "朝阳区",
	"adcode": 110105,
	"center": [116.486409, 39.921489]
}, {
	"name": "丰台区",
	"adcode": 110106,
	"center": [116.286968, 39.863642]
}, {
	"name": "石景山区",
	"adcode": 110107,
	"center": [116.195445, 39.914601]
}, {
	"name": "海淀区",
	"adcode": 110108,
	"center": [116.310316, 39.956074]
}, {
	"name": "门头沟区",
	"adcode": 110109,
	"center": [116.105381, 39.937183]
}, {
	"name": "房山区",
	"adcode": 110111,
	"center": [116.139157, 39.735535]
}, {
	"name": "通州区",
	"adcode": 110112,
	"center": [116.658603, 39.902486]
}, {
	"name": "顺义区",
	"adcode": 110113,
	"center": [116.653525, 40.128936]
}, {
	"name": "昌平区",
	"adcode": 110114,
	"center": [116.235906, 40.218085]
}, {
	"name": "大兴区",
	"adcode": 110115,
	"center": [116.338033, 39.728908]
}, {
	"name": "怀柔区",
	"adcode": 110116,
	"center": [116.637122, 40.324272]
}, {
	"name": "平谷区",
	"adcode": 110117,
	"center": [117.112335, 40.144783]
}, {
	"name": "密云区",
	"adcode": 110118,
	"center": [116.843352, 40.377362]
}, {
	"name": "延庆区",
	"adcode": 110119,
	"center": [115.985006, 40.465325]
}, {
	"name": "和平区",
	"adcode": 120101,
	"center": [117.195907, 39.118327]
}, {
	"name": "河东区",
	"adcode": 120102,
	"center": [117.226568, 39.122125]
}, {
	"name": "河西区",
	"adcode": 120103,
	"center": [117.217536, 39.101897]
}, {
	"name": "南开区",
	"adcode": 120104,
	"center": [117.164143, 39.120474]
}, {
	"name": "河北区",
	"adcode": 120105,
	"center": [117.201569, 39.156632]
}, {
	"name": "红桥区",
	"adcode": 120106,
	"center": [117.163301, 39.175066]
}, {
	"name": "东丽区",
	"adcode": 120110,
	"center": [117.313967, 39.087764]
}, {
	"name": "西青区",
	"adcode": 120111,
	"center": [117.012247, 39.139446]
}, {
	"name": "津南区",
	"adcode": 120112,
	"center": [117.382549, 38.989577]
}, {
	"name": "北辰区",
	"adcode": 120113,
	"center": [117.13482, 39.225555]
}, {
	"name": "武清区",
	"adcode": 120114,
	"center": [117.057959, 39.376925]
}, {
	"name": "宝坻区",
	"adcode": 120115,
	"center": [117.308094, 39.716965]
}, {
	"name": "滨海新区",
	"adcode": 120116,
	"center": [117.654173, 39.032846]
}, {
	"name": "宁河区",
	"adcode": 120117,
	"center": [117.82828, 39.328886]
}, {
	"name": "静海区",
	"adcode": 120118,
	"center": [116.925304, 38.935671]
}, {
	"name": "蓟州区",
	"adcode": 120119,
	"center": [117.407449, 40.045342]
}, {
	"name": "长安区",
	"adcode": 130102,
	"center": [114.548151, 38.047501]
}, {
	"name": "桥西区",
	"adcode": 130104,
	"center": [114.462931, 38.028383]
}, {
	"name": "新华区",
	"adcode": 130105,
	"center": [114.465974, 38.067142]
}, {
	"name": "井陉矿区",
	"adcode": 130107,
	"center": [114.058178, 38.069748]
}, {
	"name": "裕华区",
	"adcode": 130108,
	"center": [114.533257, 38.027696]
}, {
	"name": "藁城区",
	"adcode": 130109,
	"center": [114.849647, 38.033767]
}, {
	"name": "鹿泉区",
	"adcode": 130110,
	"center": [114.321023, 38.093994]
}, {
	"name": "栾城区",
	"adcode": 130111,
	"center": [114.654281, 37.886911]
}, {
	"name": "井陉县",
	"adcode": 130121,
	"center": [114.144488, 38.033614]
}, {
	"name": "正定县",
	"adcode": 130123,
	"center": [114.569887, 38.147835]
}, {
	"name": "行唐县",
	"adcode": 130125,
	"center": [114.552734, 38.437422]
}, {
	"name": "灵寿县",
	"adcode": 130126,
	"center": [114.37946, 38.306546]
}, {
	"name": "高邑县",
	"adcode": 130127,
	"center": [114.610699, 37.605714]
}, {
	"name": "深泽县",
	"adcode": 130128,
	"center": [115.200207, 38.18454]
}, {
	"name": "赞皇县",
	"adcode": 130129,
	"center": [114.387756, 37.660199]
}, {
	"name": "无极县",
	"adcode": 130130,
	"center": [114.977845, 38.176376]
}, {
	"name": "平山县",
	"adcode": 130131,
	"center": [114.184144, 38.259311]
}, {
	"name": "元氏县",
	"adcode": 130132,
	"center": [114.52618, 37.762514]
}, {
	"name": "赵县",
	"adcode": 130133,
	"center": [114.775362, 37.754341]
}, {
	"name": "辛集市",
	"adcode": 130181,
	"center": [115.217451, 37.92904]
}, {
	"name": "晋州市",
	"adcode": 130183,
	"center": [115.044886, 38.027478]
}, {
	"name": "新乐市",
	"adcode": 130184,
	"center": [114.68578, 38.344768]
}, {
	"name": "路南区",
	"adcode": 130202,
	"center": [118.210821, 39.615162]
}, {
	"name": "路北区",
	"adcode": 130203,
	"center": [118.174736, 39.628538]
}, {
	"name": "古冶区",
	"adcode": 130204,
	"center": [118.45429, 39.715736]
}, {
	"name": "开平区",
	"adcode": 130205,
	"center": [118.264425, 39.676171]
}, {
	"name": "丰南区",
	"adcode": 130207,
	"center": [118.110793, 39.56303]
}, {
	"name": "丰润区",
	"adcode": 130208,
	"center": [118.155779, 39.831363]
}, {
	"name": "曹妃甸区",
	"adcode": 130209,
	"center": [118.446585, 39.278277]
}, {
	"name": "滦南县",
	"adcode": 130224,
	"center": [118.681552, 39.506201]
}, {
	"name": "乐亭县",
	"adcode": 130225,
	"center": [118.905341, 39.42813]
}, {
	"name": "迁西县",
	"adcode": 130227,
	"center": [118.305139, 40.146238]
}, {
	"name": "玉田县",
	"adcode": 130229,
	"center": [117.753665, 39.887323]
}, {
	"name": "遵化市",
	"adcode": 130281,
	"center": [117.965875, 40.188616]
}, {
	"name": "迁安市",
	"adcode": 130283,
	"center": [118.701933, 40.012108]
}, {
	"name": "滦州市",
	"adcode": 130284,
	"center": [118.699546, 39.74485]
}, {
	"name": "海港区",
	"adcode": 130302,
	"center": [119.596224, 39.943458]
}, {
	"name": "山海关区",
	"adcode": 130303,
	"center": [119.753591, 39.998023]
}, {
	"name": "北戴河区",
	"adcode": 130304,
	"center": [119.486286, 39.825121]
}, {
	"name": "抚宁区",
	"adcode": 130306,
	"center": [119.240651, 39.887053]
}, {
	"name": "青龙满族自治县",
	"adcode": 130321,
	"center": [118.954555, 40.406023]
}, {
	"name": "昌黎县",
	"adcode": 130322,
	"center": [119.164541, 39.709729]
}, {
	"name": "卢龙县",
	"adcode": 130324,
	"center": [118.881809, 39.891639]
}, {
	"name": "邯山区",
	"adcode": 130402,
	"center": [114.484989, 36.603196]
}, {
	"name": "丛台区",
	"adcode": 130403,
	"center": [114.494703, 36.611082]
}, {
	"name": "复兴区",
	"adcode": 130404,
	"center": [114.458242, 36.615484]
}, {
	"name": "峰峰矿区",
	"adcode": 130406,
	"center": [114.209936, 36.420487]
}, {
	"name": "肥乡区",
	"adcode": 130407,
	"center": [114.805154, 36.555778]
}, {
	"name": "永年区",
	"adcode": 130408,
	"center": [114.496162, 36.776413]
}, {
	"name": "临漳县",
	"adcode": 130423,
	"center": [114.610703, 36.337604]
}, {
	"name": "成安县",
	"adcode": 130424,
	"center": [114.680356, 36.443832]
}, {
	"name": "大名县",
	"adcode": 130425,
	"center": [115.152586, 36.283316]
}, {
	"name": "涉县",
	"adcode": 130426,
	"center": [113.673297, 36.563143]
}, {
	"name": "磁县",
	"adcode": 130427,
	"center": [114.38208, 36.367673]
}, {
	"name": "邱县",
	"adcode": 130430,
	"center": [115.168584, 36.81325]
}, {
	"name": "鸡泽县",
	"adcode": 130431,
	"center": [114.878517, 36.914908]
}, {
	"name": "广平县",
	"adcode": 130432,
	"center": [114.950859, 36.483603]
}, {
	"name": "馆陶县",
	"adcode": 130433,
	"center": [115.289057, 36.539461]
}, {
	"name": "魏县",
	"adcode": 130434,
	"center": [114.93411, 36.354248]
}, {
	"name": "曲周县",
	"adcode": 130435,
	"center": [114.957588, 36.773398]
}, {
	"name": "武安市",
	"adcode": 130481,
	"center": [114.194581, 36.696115]
}, {
	"name": "襄都区",
	"adcode": 130502,
	"center": [114.507131, 37.064125]
}, {
	"name": "信都区",
	"adcode": 130503,
	"center": [114.473687, 37.068009]
}, {
	"name": "任泽区",
	"adcode": 130505,
	"center": [114.684469, 37.129952]
}, {
	"name": "南和区",
	"adcode": 130506,
	"center": [114.691377, 37.003812]
}, {
	"name": "临城县",
	"adcode": 130522,
	"center": [114.506873, 37.444009]
}, {
	"name": "内丘县",
	"adcode": 130523,
	"center": [114.511523, 37.287663]
}, {
	"name": "柏乡县",
	"adcode": 130524,
	"center": [114.693382, 37.483596]
}, {
	"name": "隆尧县",
	"adcode": 130525,
	"center": [114.776348, 37.350925]
}, {
	"name": "宁晋县",
	"adcode": 130528,
	"center": [114.921027, 37.618956]
}, {
	"name": "巨鹿县",
	"adcode": 130529,
	"center": [115.038782, 37.21768]
}, {
	"name": "新河县",
	"adcode": 130530,
	"center": [115.247537, 37.526216]
}, {
	"name": "广宗县",
	"adcode": 130531,
	"center": [115.142797, 37.075548]
}, {
	"name": "平乡县",
	"adcode": 130532,
	"center": [115.029218, 37.069404]
}, {
	"name": "威县",
	"adcode": 130533,
	"center": [115.272749, 36.983272]
}, {
	"name": "清河县",
	"adcode": 130534,
	"center": [115.668999, 37.059991]
}, {
	"name": "临西县",
	"adcode": 130535,
	"center": [115.498684, 36.8642]
}, {
	"name": "南宫市",
	"adcode": 130581,
	"center": [115.398102, 37.359668]
}, {
	"name": "沙河市",
	"adcode": 130582,
	"center": [114.504902, 36.861903]
}, {
	"name": "竞秀区",
	"adcode": 130602,
	"center": [115.470659, 38.88662]
}, {
	"name": "莲池区",
	"adcode": 130606,
	"center": [115.500934, 38.865005]
}, {
	"name": "满城区",
	"adcode": 130607,
	"center": [115.32442, 38.95138]
}, {
	"name": "清苑区",
	"adcode": 130608,
	"center": [115.492221, 38.771012]
}, {
	"name": "徐水区",
	"adcode": 130609,
	"center": [115.64941, 39.020395]
}, {
	"name": "涞水县",
	"adcode": 130623,
	"center": [115.711985, 39.393148]
}, {
	"name": "阜平县",
	"adcode": 130624,
	"center": [114.198801, 38.847276]
}, {
	"name": "定兴县",
	"adcode": 130626,
	"center": [115.796895, 39.266195]
}, {
	"name": "唐县",
	"adcode": 130627,
	"center": [114.981241, 38.748542]
}, {
	"name": "高阳县",
	"adcode": 130628,
	"center": [115.778878, 38.690092]
}, {
	"name": "容城县",
	"adcode": 130629,
	"center": [115.866247, 39.05282]
}, {
	"name": "涞源县",
	"adcode": 130630,
	"center": [114.692567, 39.35755]
}, {
	"name": "望都县",
	"adcode": 130631,
	"center": [115.154009, 38.707448]
}, {
	"name": "安新县",
	"adcode": 130632,
	"center": [115.931979, 38.929912]
}, {
	"name": "易县",
	"adcode": 130633,
	"center": [115.501146, 39.35297]
}, {
	"name": "曲阳县",
	"adcode": 130634,
	"center": [114.704055, 38.619992]
}, {
	"name": "蠡县",
	"adcode": 130635,
	"center": [115.583631, 38.496429]
}, {
	"name": "顺平县",
	"adcode": 130636,
	"center": [115.132749, 38.845127]
}, {
	"name": "博野县",
	"adcode": 130637,
	"center": [115.461798, 38.458271]
}, {
	"name": "雄县",
	"adcode": 130638,
	"center": [116.107474, 38.990819]
}, {
	"name": "涿州市",
	"adcode": 130681,
	"center": [115.973409, 39.485765]
}, {
	"name": "定州市",
	"adcode": 130682,
	"center": [114.991389, 38.517602]
}, {
	"name": "安国市",
	"adcode": 130683,
	"center": [115.33141, 38.421367]
}, {
	"name": "高碑店市",
	"adcode": 130684,
	"center": [115.882704, 39.327689]
}, {
	"name": "桥东区",
	"adcode": 130702,
	"center": [114.885658, 40.813875]
}, {
	"name": "桥西区",
	"adcode": 130703,
	"center": [114.882127, 40.824385]
}, {
	"name": "宣化区",
	"adcode": 130705,
	"center": [115.0632, 40.609368]
}, {
	"name": "下花园区",
	"adcode": 130706,
	"center": [115.281002, 40.488645]
}, {
	"name": "万全区",
	"adcode": 130708,
	"center": [114.736131, 40.765136]
}, {
	"name": "崇礼区",
	"adcode": 130709,
	"center": [115.281652, 40.971302]
}, {
	"name": "张北县",
	"adcode": 130722,
	"center": [114.715951, 41.151713]
}, {
	"name": "康保县",
	"adcode": 130723,
	"center": [114.615809, 41.850046]
}, {
	"name": "沽源县",
	"adcode": 130724,
	"center": [115.684836, 41.667419]
}, {
	"name": "尚义县",
	"adcode": 130725,
	"center": [113.977713, 41.080091]
}, {
	"name": "蔚县",
	"adcode": 130726,
	"center": [114.582695, 39.837181]
}, {
	"name": "阳原县",
	"adcode": 130727,
	"center": [114.167343, 40.113419]
}, {
	"name": "怀安县",
	"adcode": 130728,
	"center": [114.422364, 40.671274]
}, {
	"name": "怀来县",
	"adcode": 130730,
	"center": [115.520846, 40.405405]
}, {
	"name": "涿鹿县",
	"adcode": 130731,
	"center": [115.219246, 40.378701]
}, {
	"name": "赤城县",
	"adcode": 130732,
	"center": [115.832708, 40.912081]
}, {
	"name": "双桥区",
	"adcode": 130802,
	"center": [117.939152, 40.976204]
}, {
	"name": "双滦区",
	"adcode": 130803,
	"center": [117.797485, 40.959756]
}, {
	"name": "鹰手营子矿区",
	"adcode": 130804,
	"center": [117.661154, 40.546956]
}, {
	"name": "承德县",
	"adcode": 130821,
	"center": [118.172496, 40.768637]
}, {
	"name": "兴隆县",
	"adcode": 130822,
	"center": [117.507098, 40.418525]
}, {
	"name": "滦平县",
	"adcode": 130824,
	"center": [117.337124, 40.936644]
}, {
	"name": "隆化县",
	"adcode": 130825,
	"center": [117.736343, 41.316667]
}, {
	"name": "丰宁满族自治县",
	"adcode": 130826,
	"center": [116.65121, 41.209903]
}, {
	"name": "宽城满族自治县",
	"adcode": 130827,
	"center": [118.488642, 40.607981]
}, {
	"name": "围场满族蒙古族自治县",
	"adcode": 130828,
	"center": [117.764086, 41.949404]
}, {
	"name": "平泉市",
	"adcode": 130881,
	"center": [118.690238, 41.00561]
}, {
	"name": "新华区",
	"adcode": 130902,
	"center": [116.873049, 38.308273]
}, {
	"name": "运河区",
	"adcode": 130903,
	"center": [116.840063, 38.307405]
}, {
	"name": "沧县",
	"adcode": 130921,
	"center": [117.007478, 38.219856]
}, {
	"name": "青县",
	"adcode": 130922,
	"center": [116.838384, 38.569646]
}, {
	"name": "东光县",
	"adcode": 130923,
	"center": [116.542062, 37.88655]
}, {
	"name": "海兴县",
	"adcode": 130924,
	"center": [117.496606, 38.141582]
}, {
	"name": "盐山县",
	"adcode": 130925,
	"center": [117.229814, 38.056141]
}, {
	"name": "肃宁县",
	"adcode": 130926,
	"center": [115.835856, 38.427102]
}, {
	"name": "南皮县",
	"adcode": 130927,
	"center": [116.709171, 38.042439]
}, {
	"name": "吴桥县",
	"adcode": 130928,
	"center": [116.391512, 37.628182]
}, {
	"name": "献县",
	"adcode": 130929,
	"center": [116.123844, 38.189661]
}, {
	"name": "孟村回族自治县",
	"adcode": 130930,
	"center": [117.105104, 38.057953]
}, {
	"name": "泊头市",
	"adcode": 130981,
	"center": [116.570163, 38.073479]
}, {
	"name": "任丘市",
	"adcode": 130982,
	"center": [116.106764, 38.706513]
}, {
	"name": "黄骅市",
	"adcode": 130983,
	"center": [117.343803, 38.369238]
}, {
	"name": "河间市",
	"adcode": 130984,
	"center": [116.089452, 38.44149]
}, {
	"name": "安次区",
	"adcode": 131002,
	"center": [116.694544, 39.502569]
}, {
	"name": "广阳区",
	"adcode": 131003,
	"center": [116.713708, 39.521931]
}, {
	"name": "固安县",
	"adcode": 131022,
	"center": [116.299894, 39.436468]
}, {
	"name": "永清县",
	"adcode": 131023,
	"center": [116.498089, 39.319717]
}, {
	"name": "香河县",
	"adcode": 131024,
	"center": [117.007161, 39.757212]
}, {
	"name": "大城县",
	"adcode": 131025,
	"center": [116.640735, 38.699215]
}, {
	"name": "文安县",
	"adcode": 131026,
	"center": [116.460107, 38.866801]
}, {
	"name": "大厂回族自治县",
	"adcode": 131028,
	"center": [116.986501, 39.889266]
}, {
	"name": "霸州市",
	"adcode": 131081,
	"center": [116.392021, 39.117331]
}, {
	"name": "三河市",
	"adcode": 131082,
	"center": [117.077018, 39.982778]
}, {
	"name": "桃城区",
	"adcode": 131102,
	"center": [115.694945, 37.732237]
}, {
	"name": "冀州区",
	"adcode": 131103,
	"center": [115.579173, 37.542788]
}, {
	"name": "枣强县",
	"adcode": 131121,
	"center": [115.726499, 37.511512]
}, {
	"name": "武邑县",
	"adcode": 131122,
	"center": [115.892415, 37.803774]
}, {
	"name": "武强县",
	"adcode": 131123,
	"center": [115.970236, 38.03698]
}, {
	"name": "饶阳县",
	"adcode": 131124,
	"center": [115.726577, 38.232671]
}, {
	"name": "安平县",
	"adcode": 131125,
	"center": [115.519627, 38.233511]
}, {
	"name": "故城县",
	"adcode": 131126,
	"center": [115.966747, 37.350981]
}, {
	"name": "景县",
	"adcode": 131127,
	"center": [116.258446, 37.686622]
}, {
	"name": "阜城县",
	"adcode": 131128,
	"center": [116.164727, 37.869945]
}, {
	"name": "深州市",
	"adcode": 131182,
	"center": [115.554596, 38.00347]
}, {
	"name": "小店区",
	"adcode": 140105,
	"center": [112.564273, 37.817974]
}, {
	"name": "迎泽区",
	"adcode": 140106,
	"center": [112.558851, 37.855804]
}, {
	"name": "杏花岭区",
	"adcode": 140107,
	"center": [112.560743, 37.879291]
}, {
	"name": "尖草坪区",
	"adcode": 140108,
	"center": [112.487122, 37.939893]
}, {
	"name": "万柏林区",
	"adcode": 140109,
	"center": [112.522258, 37.862653]
}, {
	"name": "晋源区",
	"adcode": 140110,
	"center": [112.477849, 37.715619]
}, {
	"name": "清徐县",
	"adcode": 140121,
	"center": [112.357961, 37.60729]
}, {
	"name": "阳曲县",
	"adcode": 140122,
	"center": [112.673818, 38.058797]
}, {
	"name": "娄烦县",
	"adcode": 140123,
	"center": [111.793798, 38.066035]
}, {
	"name": "古交市",
	"adcode": 140181,
	"center": [112.174353, 37.908534]
}, {
	"name": "新荣区",
	"adcode": 140212,
	"center": [113.141044, 40.258269]
}, {
	"name": "平城区",
	"adcode": 140213,
	"center": [113.298027, 40.075667]
}, {
	"name": "云冈区",
	"adcode": 140214,
	"center": [113.149693, 40.005405]
}, {
	"name": "云州区",
	"adcode": 140215,
	"center": [113.61244, 40.040295]
}, {
	"name": "阳高县",
	"adcode": 140221,
	"center": [113.749871, 40.364927]
}, {
	"name": "天镇县",
	"adcode": 140222,
	"center": [114.09112, 40.421336]
}, {
	"name": "广灵县",
	"adcode": 140223,
	"center": [114.279252, 39.763051]
}, {
	"name": "灵丘县",
	"adcode": 140224,
	"center": [114.23576, 39.438867]
}, {
	"name": "浑源县",
	"adcode": 140225,
	"center": [113.698091, 39.699099]
}, {
	"name": "左云县",
	"adcode": 140226,
	"center": [112.70641, 40.012873]
}, {
	"name": "城区",
	"adcode": 140302,
	"center": [113.586513, 37.860938]
}, {
	"name": "矿区",
	"adcode": 140303,
	"center": [113.559066, 37.870085]
}, {
	"name": "郊区",
	"adcode": 140311,
	"center": [113.58664, 37.94096]
}, {
	"name": "平定县",
	"adcode": 140321,
	"center": [113.631049, 37.800289]
}, {
	"name": "盂县",
	"adcode": 140322,
	"center": [113.41223, 38.086131]
}, {
	"name": "潞州区",
	"adcode": 140403,
	"center": [113.114107, 36.187895]
}, {
	"name": "上党区",
	"adcode": 140404,
	"center": [113.056679, 36.052438]
}, {
	"name": "屯留区",
	"adcode": 140405,
	"center": [112.892741, 36.314072]
}, {
	"name": "潞城区",
	"adcode": 140406,
	"center": [113.223245, 36.332232]
}, {
	"name": "襄垣县",
	"adcode": 140423,
	"center": [113.050094, 36.532854]
}, {
	"name": "平顺县",
	"adcode": 140425,
	"center": [113.438791, 36.200202]
}, {
	"name": "黎城县",
	"adcode": 140426,
	"center": [113.387366, 36.502971]
}, {
	"name": "壶关县",
	"adcode": 140427,
	"center": [113.206138, 36.110938]
}, {
	"name": "长子县",
	"adcode": 140428,
	"center": [112.884656, 36.119484]
}, {
	"name": "武乡县",
	"adcode": 140429,
	"center": [112.8653, 36.834315]
}, {
	"name": "沁县",
	"adcode": 140430,
	"center": [112.70138, 36.757123]
}, {
	"name": "沁源县",
	"adcode": 140431,
	"center": [112.340878, 36.500777]
}, {
	"name": "城区",
	"adcode": 140502,
	"center": [112.853106, 35.496641]
}, {
	"name": "沁水县",
	"adcode": 140521,
	"center": [112.187213, 35.689472]
}, {
	"name": "阳城县",
	"adcode": 140522,
	"center": [112.422014, 35.482177]
}, {
	"name": "陵川县",
	"adcode": 140524,
	"center": [113.278877, 35.775614]
}, {
	"name": "泽州县",
	"adcode": 140525,
	"center": [112.899137, 35.617221]
}, {
	"name": "高平市",
	"adcode": 140581,
	"center": [112.930691, 35.791355]
}, {
	"name": "朔城区",
	"adcode": 140602,
	"center": [112.428676, 39.324525]
}, {
	"name": "平鲁区",
	"adcode": 140603,
	"center": [112.295227, 39.515603]
}, {
	"name": "山阴县",
	"adcode": 140621,
	"center": [112.816396, 39.52677]
}, {
	"name": "应县",
	"adcode": 140622,
	"center": [113.187505, 39.559187]
}, {
	"name": "右玉县",
	"adcode": 140623,
	"center": [112.465588, 39.988812]
}, {
	"name": "怀仁市",
	"adcode": 140681,
	"center": [113.100511, 39.820789]
}, {
	"name": "榆次区",
	"adcode": 140702,
	"center": [112.740056, 37.6976]
}, {
	"name": "太谷区",
	"adcode": 140703,
	"center": [112.554103, 37.424595]
}, {
	"name": "榆社县",
	"adcode": 140721,
	"center": [112.973521, 37.069019]
}, {
	"name": "左权县",
	"adcode": 140722,
	"center": [113.377834, 37.079672]
}, {
	"name": "和顺县",
	"adcode": 140723,
	"center": [113.572919, 37.327027]
}, {
	"name": "昔阳县",
	"adcode": 140724,
	"center": [113.706166, 37.60437]
}, {
	"name": "寿阳县",
	"adcode": 140725,
	"center": [113.177708, 37.891136]
}, {
	"name": "祁县",
	"adcode": 140727,
	"center": [112.330532, 37.358739]
}, {
	"name": "平遥县",
	"adcode": 140728,
	"center": [112.174059, 37.195474]
}, {
	"name": "灵石县",
	"adcode": 140729,
	"center": [111.772759, 36.847469]
}, {
	"name": "介休市",
	"adcode": 140781,
	"center": [111.913857, 37.027616]
}, {
	"name": "盐湖区",
	"adcode": 140802,
	"center": [111.000627, 35.025643]
}, {
	"name": "临猗县",
	"adcode": 140821,
	"center": [110.77493, 35.141883]
}, {
	"name": "万荣县",
	"adcode": 140822,
	"center": [110.843561, 35.417042]
}, {
	"name": "闻喜县",
	"adcode": 140823,
	"center": [111.220306, 35.353839]
}, {
	"name": "稷山县",
	"adcode": 140824,
	"center": [110.978996, 35.600412]
}, {
	"name": "新绛县",
	"adcode": 140825,
	"center": [111.225205, 35.613697]
}, {
	"name": "绛县",
	"adcode": 140826,
	"center": [111.576182, 35.49045]
}, {
	"name": "垣曲县",
	"adcode": 140827,
	"center": [111.67099, 35.298293]
}, {
	"name": "夏县",
	"adcode": 140828,
	"center": [111.223174, 35.140441]
}, {
	"name": "平陆县",
	"adcode": 140829,
	"center": [111.212377, 34.837256]
}, {
	"name": "芮城县",
	"adcode": 140830,
	"center": [110.69114, 34.694769]
}, {
	"name": "永济市",
	"adcode": 140881,
	"center": [110.447984, 34.865125]
}, {
	"name": "河津市",
	"adcode": 140882,
	"center": [110.710268, 35.59715]
}, {
	"name": "忻府区",
	"adcode": 140902,
	"center": [112.734112, 38.417743]
}, {
	"name": "定襄县",
	"adcode": 140921,
	"center": [112.963231, 38.484948]
}, {
	"name": "五台县",
	"adcode": 140922,
	"center": [113.259012, 38.725711]
}, {
	"name": "代县",
	"adcode": 140923,
	"center": [112.962519, 39.065138]
}, {
	"name": "繁峙县",
	"adcode": 140924,
	"center": [113.267707, 39.188104]
}, {
	"name": "宁武县",
	"adcode": 140925,
	"center": [112.307936, 39.001718]
}, {
	"name": "静乐县",
	"adcode": 140926,
	"center": [111.940231, 38.355947]
}, {
	"name": "神池县",
	"adcode": 140927,
	"center": [112.200438, 39.088467]
}, {
	"name": "五寨县",
	"adcode": 140928,
	"center": [111.841015, 38.912761]
}, {
	"name": "岢岚县",
	"adcode": 140929,
	"center": [111.56981, 38.705625]
}, {
	"name": "河曲县",
	"adcode": 140930,
	"center": [111.146609, 39.381895]
}, {
	"name": "保德县",
	"adcode": 140931,
	"center": [111.085688, 39.022576]
}, {
	"name": "偏关县",
	"adcode": 140932,
	"center": [111.500477, 39.442153]
}, {
	"name": "原平市",
	"adcode": 140981,
	"center": [112.713132, 38.729186]
}, {
	"name": "尧都区",
	"adcode": 141002,
	"center": [111.522945, 36.080366]
}, {
	"name": "曲沃县",
	"adcode": 141021,
	"center": [111.475529, 35.641387]
}, {
	"name": "翼城县",
	"adcode": 141022,
	"center": [111.713508, 35.738621]
}, {
	"name": "襄汾县",
	"adcode": 141023,
	"center": [111.442932, 35.876139]
}, {
	"name": "洪洞县",
	"adcode": 141024,
	"center": [111.673692, 36.255742]
}, {
	"name": "古县",
	"adcode": 141025,
	"center": [111.920207, 36.26855]
}, {
	"name": "安泽县",
	"adcode": 141026,
	"center": [112.251372, 36.146032]
}, {
	"name": "浮山县",
	"adcode": 141027,
	"center": [111.850039, 35.971359]
}, {
	"name": "吉县",
	"adcode": 141028,
	"center": [110.682853, 36.099355]
}, {
	"name": "乡宁县",
	"adcode": 141029,
	"center": [110.857365, 35.975402]
}, {
	"name": "大宁县",
	"adcode": 141030,
	"center": [110.751283, 36.46383]
}, {
	"name": "隰县",
	"adcode": 141031,
	"center": [110.935809, 36.692675]
}, {
	"name": "永和县",
	"adcode": 141032,
	"center": [110.631276, 36.760614]
}, {
	"name": "蒲县",
	"adcode": 141033,
	"center": [111.09733, 36.411682]
}, {
	"name": "汾西县",
	"adcode": 141034,
	"center": [111.563021, 36.653368]
}, {
	"name": "侯马市",
	"adcode": 141081,
	"center": [111.371272, 35.620302]
}, {
	"name": "霍州市",
	"adcode": 141082,
	"center": [111.723103, 36.57202]
}, {
	"name": "离石区",
	"adcode": 141102,
	"center": [111.134462, 37.524037]
}, {
	"name": "文水县",
	"adcode": 141121,
	"center": [112.032595, 37.436314]
}, {
	"name": "交城县",
	"adcode": 141122,
	"center": [112.159154, 37.555155]
}, {
	"name": "兴县",
	"adcode": 141123,
	"center": [111.124816, 38.464136]
}, {
	"name": "临县",
	"adcode": 141124,
	"center": [110.995963, 37.960806]
}, {
	"name": "柳林县",
	"adcode": 141125,
	"center": [110.89613, 37.431664]
}, {
	"name": "石楼县",
	"adcode": 141126,
	"center": [110.837119, 36.999426]
}, {
	"name": "岚县",
	"adcode": 141127,
	"center": [111.671555, 38.278654]
}, {
	"name": "方山县",
	"adcode": 141128,
	"center": [111.238885, 37.892632]
}, {
	"name": "中阳县",
	"adcode": 141129,
	"center": [111.193319, 37.342054]
}, {
	"name": "交口县",
	"adcode": 141130,
	"center": [111.183188, 36.983068]
}, {
	"name": "孝义市",
	"adcode": 141181,
	"center": [111.781568, 37.144474]
}, {
	"name": "汾阳市",
	"adcode": 141182,
	"center": [111.785273, 37.267742]
}, {
	"name": "新城区",
	"adcode": 150102,
	"center": [111.685964, 40.826225]
}, {
	"name": "回民区",
	"adcode": 150103,
	"center": [111.662162, 40.815149]
}, {
	"name": "玉泉区",
	"adcode": 150104,
	"center": [111.66543, 40.799421]
}, {
	"name": "赛罕区",
	"adcode": 150105,
	"center": [111.698463, 40.807834]
}, {
	"name": "土默特左旗",
	"adcode": 150121,
	"center": [111.133615, 40.720416]
}, {
	"name": "托克托县",
	"adcode": 150122,
	"center": [111.197317, 40.276729]
}, {
	"name": "和林格尔县",
	"adcode": 150123,
	"center": [111.824143, 40.380288]
}, {
	"name": "清水河县",
	"adcode": 150124,
	"center": [111.67222, 39.912479]
}, {
	"name": "武川县",
	"adcode": 150125,
	"center": [111.456563, 41.094483]
}, {
	"name": "东河区",
	"adcode": 150202,
	"center": [110.026895, 40.587056]
}, {
	"name": "昆都仑区",
	"adcode": 150203,
	"center": [109.822932, 40.661345]
}, {
	"name": "青山区",
	"adcode": 150204,
	"center": [109.880049, 40.668558]
}, {
	"name": "石拐区",
	"adcode": 150205,
	"center": [110.272565, 40.672094]
}, {
	"name": "白云鄂博矿区",
	"adcode": 150206,
	"center": [109.97016, 41.769246]
}, {
	"name": "九原区",
	"adcode": 150207,
	"center": [109.968122, 40.600581]
}, {
	"name": "土默特右旗",
	"adcode": 150221,
	"center": [110.526766, 40.566434]
}, {
	"name": "固阳县",
	"adcode": 150222,
	"center": [110.063421, 41.030004]
}, {
	"name": "达尔罕茂明安联合旗",
	"adcode": 150223,
	"center": [110.438452, 41.702836]
}, {
	"name": "海勃湾区",
	"adcode": 150302,
	"center": [106.817762, 39.673527]
}, {
	"name": "海南区",
	"adcode": 150303,
	"center": [106.884789, 39.44153]
}, {
	"name": "乌达区",
	"adcode": 150304,
	"center": [106.722711, 39.502288]
}, {
	"name": "红山区",
	"adcode": 150402,
	"center": [118.961087, 42.269732]
}, {
	"name": "元宝山区",
	"adcode": 150403,
	"center": [119.289877, 42.041168]
}, {
	"name": "松山区",
	"adcode": 150404,
	"center": [118.938958, 42.281046]
}, {
	"name": "阿鲁科尔沁旗",
	"adcode": 150421,
	"center": [120.094969, 43.87877]
}, {
	"name": "巴林左旗",
	"adcode": 150422,
	"center": [119.391737, 43.980715]
}, {
	"name": "巴林右旗",
	"adcode": 150423,
	"center": [118.678347, 43.528963]
}, {
	"name": "林西县",
	"adcode": 150424,
	"center": [118.05775, 43.605326]
}, {
	"name": "克什克腾旗",
	"adcode": 150425,
	"center": [117.542465, 43.256233]
}, {
	"name": "翁牛特旗",
	"adcode": 150426,
	"center": [119.022619, 42.937128]
}, {
	"name": "喀喇沁旗",
	"adcode": 150428,
	"center": [118.708572, 41.92778]
}, {
	"name": "宁城县",
	"adcode": 150429,
	"center": [119.339242, 41.598692]
}, {
	"name": "敖汉旗",
	"adcode": 150430,
	"center": [119.906486, 42.287012]
}, {
	"name": "科尔沁区",
	"adcode": 150502,
	"center": [122.264042, 43.617422]
}, {
	"name": "科尔沁左翼中旗",
	"adcode": 150521,
	"center": [123.313873, 44.127166]
}, {
	"name": "科尔沁左翼后旗",
	"adcode": 150522,
	"center": [122.355155, 42.954564]
}, {
	"name": "开鲁县",
	"adcode": 150523,
	"center": [121.308797, 43.602432]
}, {
	"name": "库伦旗",
	"adcode": 150524,
	"center": [121.774886, 42.734692]
}, {
	"name": "奈曼旗",
	"adcode": 150525,
	"center": [120.662543, 42.84685]
}, {
	"name": "扎鲁特旗",
	"adcode": 150526,
	"center": [120.905275, 44.555294]
}, {
	"name": "霍林郭勒市",
	"adcode": 150581,
	"center": [119.657862, 45.532361]
}, {
	"name": "东胜区",
	"adcode": 150602,
	"center": [109.98945, 39.81788]
}, {
	"name": "康巴什区",
	"adcode": 150603,
	"center": [109.790076, 39.607472]
}, {
	"name": "达拉特旗",
	"adcode": 150621,
	"center": [110.040281, 40.404076]
}, {
	"name": "准格尔旗",
	"adcode": 150622,
	"center": [111.238332, 39.865221]
}, {
	"name": "鄂托克前旗",
	"adcode": 150623,
	"center": [107.48172, 38.183257]
}, {
	"name": "鄂托克旗",
	"adcode": 150624,
	"center": [107.982604, 39.095752]
}, {
	"name": "杭锦旗",
	"adcode": 150625,
	"center": [108.736324, 39.831789]
}, {
	"name": "乌审旗",
	"adcode": 150626,
	"center": [108.842454, 38.596611]
}, {
	"name": "伊金霍洛旗",
	"adcode": 150627,
	"center": [109.787402, 39.604312]
}, {
	"name": "海拉尔区",
	"adcode": 150702,
	"center": [119.764923, 49.213889]
}, {
	"name": "扎赉诺尔区",
	"adcode": 150703,
	"center": [117.716373, 49.456567]
}, {
	"name": "阿荣旗",
	"adcode": 150721,
	"center": [123.464615, 48.130503]
}, {
	"name": "莫力达瓦达斡尔族自治旗",
	"adcode": 150722,
	"center": [124.507401, 48.478385]
}, {
	"name": "鄂伦春自治旗",
	"adcode": 150723,
	"center": [123.725684, 50.590177]
}, {
	"name": "鄂温克族自治旗",
	"adcode": 150724,
	"center": [119.754041, 49.143293]
}, {
	"name": "陈巴尔虎旗",
	"adcode": 150725,
	"center": [119.437609, 49.328422]
}, {
	"name": "新巴尔虎左旗",
	"adcode": 150726,
	"center": [118.267454, 48.216571]
}, {
	"name": "新巴尔虎右旗",
	"adcode": 150727,
	"center": [116.825991, 48.669134]
}, {
	"name": "满洲里市",
	"adcode": 150781,
	"center": [117.455561, 49.590788]
}, {
	"name": "牙克石市",
	"adcode": 150782,
	"center": [120.729005, 49.287024]
}, {
	"name": "扎兰屯市",
	"adcode": 150783,
	"center": [122.744401, 48.007412]
}, {
	"name": "额尔古纳市",
	"adcode": 150784,
	"center": [120.178636, 50.2439]
}, {
	"name": "根河市",
	"adcode": 150785,
	"center": [121.532724, 50.780454]
}, {
	"name": "临河区",
	"adcode": 150802,
	"center": [107.417018, 40.757092]
}, {
	"name": "五原县",
	"adcode": 150821,
	"center": [108.270658, 41.097639]
}, {
	"name": "磴口县",
	"adcode": 150822,
	"center": [107.006056, 40.330479]
}, {
	"name": "乌拉特前旗",
	"adcode": 150823,
	"center": [108.656816, 40.725209]
}, {
	"name": "乌拉特中旗",
	"adcode": 150824,
	"center": [108.515255, 41.57254]
}, {
	"name": "乌拉特后旗",
	"adcode": 150825,
	"center": [107.074941, 41.084307]
}, {
	"name": "杭锦后旗",
	"adcode": 150826,
	"center": [107.147682, 40.888797]
}, {
	"name": "集宁区",
	"adcode": 150902,
	"center": [113.116453, 41.034134]
}, {
	"name": "卓资县",
	"adcode": 150921,
	"center": [112.577702, 40.89576]
}, {
	"name": "化德县",
	"adcode": 150922,
	"center": [114.01008, 41.899335]
}, {
	"name": "商都县",
	"adcode": 150923,
	"center": [113.560643, 41.560163]
}, {
	"name": "兴和县",
	"adcode": 150924,
	"center": [113.834009, 40.872437]
}, {
	"name": "凉城县",
	"adcode": 150925,
	"center": [112.500911, 40.531627]
}, {
	"name": "察哈尔右翼前旗",
	"adcode": 150926,
	"center": [113.211958, 40.786859]
}, {
	"name": "察哈尔右翼中旗",
	"adcode": 150927,
	"center": [112.633563, 41.274212]
}, {
	"name": "察哈尔右翼后旗",
	"adcode": 150928,
	"center": [113.1906, 41.447213]
}, {
	"name": "四子王旗",
	"adcode": 150929,
	"center": [111.70123, 41.528114]
}, {
	"name": "丰镇市",
	"adcode": 150981,
	"center": [113.163462, 40.437534]
}, {
	"name": "乌兰浩特市",
	"adcode": 152201,
	"center": [122.068975, 46.077238]
}, {
	"name": "阿尔山市",
	"adcode": 152202,
	"center": [119.943656, 47.177]
}, {
	"name": "科尔沁右翼前旗",
	"adcode": 152221,
	"center": [121.957544, 46.076497]
}, {
	"name": "科尔沁右翼中旗",
	"adcode": 152222,
	"center": [121.472818, 45.059645]
}, {
	"name": "扎赉特旗",
	"adcode": 152223,
	"center": [122.909332, 46.725136]
}, {
	"name": "突泉县",
	"adcode": 152224,
	"center": [121.564856, 45.380986]
}, {
	"name": "二连浩特市",
	"adcode": 152501,
	"center": [111.97981, 43.652895]
}, {
	"name": "锡林浩特市",
	"adcode": 152502,
	"center": [116.091903, 43.944301]
}, {
	"name": "阿巴嘎旗",
	"adcode": 152522,
	"center": [114.970618, 44.022728]
}, {
	"name": "苏尼特左旗",
	"adcode": 152523,
	"center": [113.653412, 43.854108]
}, {
	"name": "苏尼特右旗",
	"adcode": 152524,
	"center": [112.65539, 42.746662]
}, {
	"name": "东乌珠穆沁旗",
	"adcode": 152525,
	"center": [116.980022, 45.510307]
}, {
	"name": "西乌珠穆沁旗",
	"adcode": 152526,
	"center": [117.615249, 44.586147]
}, {
	"name": "太仆寺旗",
	"adcode": 152527,
	"center": [115.28728, 41.895199]
}, {
	"name": "镶黄旗",
	"adcode": 152528,
	"center": [113.843869, 42.239229]
}, {
	"name": "正镶白旗",
	"adcode": 152529,
	"center": [115.031423, 42.286807]
}, {
	"name": "正蓝旗",
	"adcode": 152530,
	"center": [116.003311, 42.245895]
}, {
	"name": "多伦县",
	"adcode": 152531,
	"center": [116.477288, 42.197962]
}, {
	"name": "阿拉善左旗",
	"adcode": 152921,
	"center": [105.70192, 38.847241]
}, {
	"name": "阿拉善右旗",
	"adcode": 152922,
	"center": [101.671984, 39.21159]
}, {
	"name": "额济纳旗",
	"adcode": 152923,
	"center": [101.06944, 41.958813]
}, {
	"name": "和平区",
	"adcode": 210102,
	"center": [123.406664, 41.788074]
}, {
	"name": "沈河区",
	"adcode": 210103,
	"center": [123.445696, 41.795591]
}, {
	"name": "大东区",
	"adcode": 210104,
	"center": [123.469956, 41.808503]
}, {
	"name": "皇姑区",
	"adcode": 210105,
	"center": [123.405677, 41.822336]
}, {
	"name": "铁西区",
	"adcode": 210106,
	"center": [123.350664, 41.787808]
}, {
	"name": "苏家屯区",
	"adcode": 210111,
	"center": [123.341604, 41.665904]
}, {
	"name": "浑南区",
	"adcode": 210112,
	"center": [123.458981, 41.741946]
}, {
	"name": "沈北新区",
	"adcode": 210113,
	"center": [123.521471, 42.052312]
}, {
	"name": "于洪区",
	"adcode": 210114,
	"center": [123.310829, 41.795833]
}, {
	"name": "辽中区",
	"adcode": 210115,
	"center": [122.731269, 41.512725]
}, {
	"name": "康平县",
	"adcode": 210123,
	"center": [123.352703, 42.741533]
}, {
	"name": "法库县",
	"adcode": 210124,
	"center": [123.416722, 42.507045]
}, {
	"name": "新民市",
	"adcode": 210181,
	"center": [122.828868, 41.996508]
}, {
	"name": "中山区",
	"adcode": 210202,
	"center": [121.64376, 38.921553]
}, {
	"name": "西岗区",
	"adcode": 210203,
	"center": [121.616112, 38.914266]
}, {
	"name": "沙河口区",
	"adcode": 210204,
	"center": [121.593702, 38.912859]
}, {
	"name": "甘井子区",
	"adcode": 210211,
	"center": [121.582614, 38.975148]
}, {
	"name": "旅顺口区",
	"adcode": 210212,
	"center": [121.26713, 38.812043]
}, {
	"name": "金州区",
	"adcode": 210213,
	"center": [121.789413, 39.052745]
}, {
	"name": "普兰店区",
	"adcode": 210214,
	"center": [121.9705, 39.401555]
}, {
	"name": "长海县",
	"adcode": 210224,
	"center": [122.587824, 39.272399]
}, {
	"name": "瓦房店市",
	"adcode": 210281,
	"center": [122.002656, 39.63065]
}, {
	"name": "庄河市",
	"adcode": 210283,
	"center": [122.970612, 39.69829]
}, {
	"name": "铁东区",
	"adcode": 210302,
	"center": [122.994475, 41.110344]
}, {
	"name": "铁西区",
	"adcode": 210303,
	"center": [122.971834, 41.11069]
}, {
	"name": "立山区",
	"adcode": 210304,
	"center": [123.024806, 41.150622]
}, {
	"name": "千山区",
	"adcode": 210311,
	"center": [122.949298, 41.068909]
}, {
	"name": "台安县",
	"adcode": 210321,
	"center": [122.429736, 41.38686]
}, {
	"name": "岫岩满族自治县",
	"adcode": 210323,
	"center": [123.28833, 40.281509]
}, {
	"name": "海城市",
	"adcode": 210381,
	"center": [122.752199, 40.852533]
}, {
	"name": "新抚区",
	"adcode": 210402,
	"center": [123.902858, 41.86082]
}, {
	"name": "东洲区",
	"adcode": 210403,
	"center": [124.047219, 41.866829]
}, {
	"name": "望花区",
	"adcode": 210404,
	"center": [123.801509, 41.851803]
}, {
	"name": "顺城区",
	"adcode": 210411,
	"center": [123.917165, 41.881132]
}, {
	"name": "抚顺县",
	"adcode": 210421,
	"center": [124.097979, 41.922644]
}, {
	"name": "新宾满族自治县",
	"adcode": 210422,
	"center": [125.037547, 41.732456]
}, {
	"name": "清原满族自治县",
	"adcode": 210423,
	"center": [124.927192, 42.10135]
}, {
	"name": "平山区",
	"adcode": 210502,
	"center": [123.761231, 41.291581]
}, {
	"name": "溪湖区",
	"adcode": 210503,
	"center": [123.765226, 41.330056]
}, {
	"name": "明山区",
	"adcode": 210504,
	"center": [123.763288, 41.302429]
}, {
	"name": "南芬区",
	"adcode": 210505,
	"center": [123.748381, 41.104093]
}, {
	"name": "本溪满族自治县",
	"adcode": 210521,
	"center": [124.126156, 41.300344]
}, {
	"name": "桓仁满族自治县",
	"adcode": 210522,
	"center": [125.359195, 41.268997]
}, {
	"name": "元宝区",
	"adcode": 210602,
	"center": [124.397814, 40.136483]
}, {
	"name": "振兴区",
	"adcode": 210603,
	"center": [124.361153, 40.102801]
}, {
	"name": "振安区",
	"adcode": 210604,
	"center": [124.427709, 40.158557]
}, {
	"name": "宽甸满族自治县",
	"adcode": 210624,
	"center": [124.784867, 40.730412]
}, {
	"name": "东港市",
	"adcode": 210681,
	"center": [124.149437, 39.883467]
}, {
	"name": "凤城市",
	"adcode": 210682,
	"center": [124.071067, 40.457567]
}, {
	"name": "古塔区",
	"adcode": 210702,
	"center": [121.130085, 41.115719]
}, {
	"name": "凌河区",
	"adcode": 210703,
	"center": [121.151304, 41.114662]
}, {
	"name": "太和区",
	"adcode": 210711,
	"center": [121.107297, 41.105378]
}, {
	"name": "黑山县",
	"adcode": 210726,
	"center": [122.117915, 41.691804]
}, {
	"name": "义县",
	"adcode": 210727,
	"center": [121.242831, 41.537224]
}, {
	"name": "凌海市",
	"adcode": 210781,
	"center": [121.364236, 41.171738]
}, {
	"name": "北镇市",
	"adcode": 210782,
	"center": [121.795962, 41.598764]
}, {
	"name": "站前区",
	"adcode": 210802,
	"center": [122.253235, 40.669949]
}, {
	"name": "西市区",
	"adcode": 210803,
	"center": [122.210067, 40.663086]
}, {
	"name": "鲅鱼圈区",
	"adcode": 210804,
	"center": [122.127242, 40.263646]
}, {
	"name": "老边区",
	"adcode": 210811,
	"center": [122.382584, 40.682723]
}, {
	"name": "盖州市",
	"adcode": 210881,
	"center": [122.355534, 40.405234]
}, {
	"name": "大石桥市",
	"adcode": 210882,
	"center": [122.505894, 40.633973]
}, {
	"name": "海州区",
	"adcode": 210902,
	"center": [121.657639, 42.011162]
}, {
	"name": "新邱区",
	"adcode": 210903,
	"center": [121.790541, 42.086603]
}, {
	"name": "太平区",
	"adcode": 210904,
	"center": [121.677575, 42.011145]
}, {
	"name": "清河门区",
	"adcode": 210905,
	"center": [121.42018, 41.780477]
}, {
	"name": "细河区",
	"adcode": 210911,
	"center": [121.654791, 42.019218]
}, {
	"name": "阜新蒙古族自治县",
	"adcode": 210921,
	"center": [121.743125, 42.058607]
}, {
	"name": "彰武县",
	"adcode": 210922,
	"center": [122.537444, 42.384823]
}, {
	"name": "白塔区",
	"adcode": 211002,
	"center": [123.172611, 41.26745]
}, {
	"name": "文圣区",
	"adcode": 211003,
	"center": [123.188227, 41.266765]
}, {
	"name": "宏伟区",
	"adcode": 211004,
	"center": [123.200461, 41.205747]
}, {
	"name": "弓长岭区",
	"adcode": 211005,
	"center": [123.431633, 41.157831]
}, {
	"name": "太子河区",
	"adcode": 211011,
	"center": [123.185336, 41.251682]
}, {
	"name": "辽阳县",
	"adcode": 211021,
	"center": [123.079674, 41.216479]
}, {
	"name": "灯塔市",
	"adcode": 211081,
	"center": [123.325864, 41.427836]
}, {
	"name": "双台子区",
	"adcode": 211102,
	"center": [122.055733, 41.190365]
}, {
	"name": "兴隆台区",
	"adcode": 211103,
	"center": [122.071624, 41.122423]
}, {
	"name": "大洼区",
	"adcode": 211104,
	"center": [122.071708, 40.994428]
}, {
	"name": "盘山县",
	"adcode": 211122,
	"center": [121.98528, 41.240701]
}, {
	"name": "银州区",
	"adcode": 211202,
	"center": [123.844877, 42.292278]
}, {
	"name": "清河区",
	"adcode": 211204,
	"center": [124.14896, 42.542978]
}, {
	"name": "铁岭县",
	"adcode": 211221,
	"center": [123.725669, 42.223316]
}, {
	"name": "西丰县",
	"adcode": 211223,
	"center": [124.72332, 42.738091]
}, {
	"name": "昌图县",
	"adcode": 211224,
	"center": [124.11017, 42.784441]
}, {
	"name": "调兵山市",
	"adcode": 211281,
	"center": [123.545366, 42.450734]
}, {
	"name": "开原市",
	"adcode": 211282,
	"center": [124.045551, 42.542141]
}, {
	"name": "双塔区",
	"adcode": 211302,
	"center": [120.44877, 41.579389]
}, {
	"name": "龙城区",
	"adcode": 211303,
	"center": [120.413376, 41.576749]
}, {
	"name": "朝阳县",
	"adcode": 211321,
	"center": [120.404217, 41.526342]
}, {
	"name": "建平县",
	"adcode": 211322,
	"center": [119.642363, 41.402576]
}, {
	"name": "喀喇沁左翼蒙古族自治县",
	"adcode": 211324,
	"center": [119.744883, 41.125428]
}, {
	"name": "北票市",
	"adcode": 211381,
	"center": [120.766951, 41.803286]
}, {
	"name": "凌源市",
	"adcode": 211382,
	"center": [119.404789, 41.243086]
}, {
	"name": "连山区",
	"adcode": 211402,
	"center": [120.85937, 40.755143]
}, {
	"name": "龙港区",
	"adcode": 211403,
	"center": [120.838569, 40.709991]
}, {
	"name": "南票区",
	"adcode": 211404,
	"center": [120.752314, 41.098813]
}, {
	"name": "绥中县",
	"adcode": 211421,
	"center": [120.342112, 40.328407]
}, {
	"name": "建昌县",
	"adcode": 211422,
	"center": [119.807776, 40.812871]
}, {
	"name": "兴城市",
	"adcode": 211481,
	"center": [120.729365, 40.619413]
}, {
	"name": "南关区",
	"adcode": 220102,
	"center": [125.337237, 43.890235]
}, {
	"name": "宽城区",
	"adcode": 220103,
	"center": [125.342828, 43.903823]
}, {
	"name": "朝阳区",
	"adcode": 220104,
	"center": [125.318042, 43.86491]
}, {
	"name": "二道区",
	"adcode": 220105,
	"center": [125.384727, 43.870824]
}, {
	"name": "绿园区",
	"adcode": 220106,
	"center": [125.272467, 43.892177]
}, {
	"name": "双阳区",
	"adcode": 220112,
	"center": [125.659018, 43.525168]
}, {
	"name": "九台区",
	"adcode": 220113,
	"center": [125.844682, 44.157155]
}, {
	"name": "农安县",
	"adcode": 220122,
	"center": [125.175287, 44.431258]
}, {
	"name": "榆树市",
	"adcode": 220182,
	"center": [126.550107, 44.827642]
}, {
	"name": "德惠市",
	"adcode": 220183,
	"center": [125.703327, 44.533909]
}, {
	"name": "公主岭市",
	"adcode": 220184,
	"center": [124.817588, 43.509474]
}, {
	"name": "昌邑区",
	"adcode": 220202,
	"center": [126.570766, 43.851118]
}, {
	"name": "龙潭区",
	"adcode": 220203,
	"center": [126.561429, 43.909755]
}, {
	"name": "船营区",
	"adcode": 220204,
	"center": [126.55239, 43.843804]
}, {
	"name": "丰满区",
	"adcode": 220211,
	"center": [126.560759, 43.816594]
}, {
	"name": "永吉县",
	"adcode": 220221,
	"center": [126.501622, 43.667416]
}, {
	"name": "蛟河市",
	"adcode": 220281,
	"center": [127.342739, 43.720579]
}, {
	"name": "桦甸市",
	"adcode": 220282,
	"center": [126.745445, 42.972093]
}, {
	"name": "舒兰市",
	"adcode": 220283,
	"center": [126.947813, 44.410906]
}, {
	"name": "磐石市",
	"adcode": 220284,
	"center": [126.059929, 42.942476]
}, {
	"name": "铁西区",
	"adcode": 220302,
	"center": [124.360894, 43.176263]
}, {
	"name": "铁东区",
	"adcode": 220303,
	"center": [124.388464, 43.16726]
}, {
	"name": "梨树县",
	"adcode": 220322,
	"center": [124.335802, 43.30831]
}, {
	"name": "伊通满族自治县",
	"adcode": 220323,
	"center": [125.303124, 43.345464]
}, {
	"name": "双辽市",
	"adcode": 220382,
	"center": [123.505283, 43.518275]
}, {
	"name": "龙山区",
	"adcode": 220402,
	"center": [125.145164, 42.902702]
}, {
	"name": "西安区",
	"adcode": 220403,
	"center": [125.151424, 42.920415]
}, {
	"name": "东丰县",
	"adcode": 220421,
	"center": [125.529623, 42.675228]
}, {
	"name": "东辽县",
	"adcode": 220422,
	"center": [124.991995, 42.927724]
}, {
	"name": "东昌区",
	"adcode": 220502,
	"center": [125.936716, 41.721233]
}, {
	"name": "二道江区",
	"adcode": 220503,
	"center": [126.045987, 41.777564]
}, {
	"name": "通化县",
	"adcode": 220521,
	"center": [125.753121, 41.677918]
}, {
	"name": "辉南县",
	"adcode": 220523,
	"center": [126.042821, 42.683459]
}, {
	"name": "柳河县",
	"adcode": 220524,
	"center": [125.740536, 42.281484]
}, {
	"name": "梅河口市",
	"adcode": 220581,
	"center": [125.687336, 42.530002]
}, {
	"name": "集安市",
	"adcode": 220582,
	"center": [126.186204, 41.126276]
}, {
	"name": "浑江区",
	"adcode": 220602,
	"center": [126.428035, 41.943065]
}, {
	"name": "江源区",
	"adcode": 220605,
	"center": [126.584229, 42.048109]
}, {
	"name": "抚松县",
	"adcode": 220621,
	"center": [127.273796, 42.332643]
}, {
	"name": "靖宇县",
	"adcode": 220622,
	"center": [126.808386, 42.389689]
}, {
	"name": "长白朝鲜族自治县",
	"adcode": 220623,
	"center": [128.203384, 41.419361]
}, {
	"name": "临江市",
	"adcode": 220681,
	"center": [126.919296, 41.810689]
}, {
	"name": "宁江区",
	"adcode": 220702,
	"center": [124.827851, 45.176498]
}, {
	"name": "前郭尔罗斯蒙古族自治县",
	"adcode": 220721,
	"center": [124.826808, 45.116288]
}, {
	"name": "长岭县",
	"adcode": 220722,
	"center": [123.985184, 44.276579]
}, {
	"name": "乾安县",
	"adcode": 220723,
	"center": [124.024361, 45.006846]
}, {
	"name": "扶余市",
	"adcode": 220781,
	"center": [126.042758, 44.986199]
}, {
	"name": "洮北区",
	"adcode": 220802,
	"center": [122.842499, 45.619253]
}, {
	"name": "镇赉县",
	"adcode": 220821,
	"center": [123.202246, 45.846089]
}, {
	"name": "通榆县",
	"adcode": 220822,
	"center": [123.088543, 44.80915]
}, {
	"name": "洮南市",
	"adcode": 220881,
	"center": [122.783779, 45.339113]
}, {
	"name": "大安市",
	"adcode": 220882,
	"center": [124.291512, 45.507648]
}, {
	"name": "延吉市",
	"adcode": 222401,
	"center": [129.51579, 42.906964]
}, {
	"name": "图们市",
	"adcode": 222402,
	"center": [129.846701, 42.966621]
}, {
	"name": "敦化市",
	"adcode": 222403,
	"center": [128.22986, 43.366921]
}, {
	"name": "珲春市",
	"adcode": 222404,
	"center": [130.365787, 42.871057]
}, {
	"name": "龙井市",
	"adcode": 222405,
	"center": [129.425747, 42.771029]
}, {
	"name": "和龙市",
	"adcode": 222406,
	"center": [129.008748, 42.547004]
}, {
	"name": "汪清县",
	"adcode": 222424,
	"center": [129.766161, 43.315426]
}, {
	"name": "安图县",
	"adcode": 222426,
	"center": [128.901865, 43.110994]
}, {
	"name": "道里区",
	"adcode": 230102,
	"center": [126.612532, 45.762035]
}, {
	"name": "南岗区",
	"adcode": 230103,
	"center": [126.652098, 45.755971]
}, {
	"name": "道外区",
	"adcode": 230104,
	"center": [126.648838, 45.78454]
}, {
	"name": "平房区",
	"adcode": 230108,
	"center": [126.629257, 45.605567]
}, {
	"name": "松北区",
	"adcode": 230109,
	"center": [126.563066, 45.814656]
}, {
	"name": "香坊区",
	"adcode": 230110,
	"center": [126.667049, 45.713067]
}, {
	"name": "呼兰区",
	"adcode": 230111,
	"center": [126.603302, 45.98423]
}, {
	"name": "阿城区",
	"adcode": 230112,
	"center": [126.972726, 45.538372]
}, {
	"name": "双城区",
	"adcode": 230113,
	"center": [126.308784, 45.377942]
}, {
	"name": "依兰县",
	"adcode": 230123,
	"center": [129.565594, 46.315105]
}, {
	"name": "方正县",
	"adcode": 230124,
	"center": [128.836131, 45.839536]
}, {
	"name": "宾县",
	"adcode": 230125,
	"center": [127.48594, 45.759369]
}, {
	"name": "巴彦县",
	"adcode": 230126,
	"center": [127.403602, 46.081889]
}, {
	"name": "木兰县",
	"adcode": 230127,
	"center": [128.042675, 45.949826]
}, {
	"name": "通河县",
	"adcode": 230128,
	"center": [128.747786, 45.977618]
}, {
	"name": "延寿县",
	"adcode": 230129,
	"center": [128.331886, 45.455648]
}, {
	"name": "尚志市",
	"adcode": 230183,
	"center": [127.968539, 45.214953]
}, {
	"name": "五常市",
	"adcode": 230184,
	"center": [127.15759, 44.919418]
}, {
	"name": "龙沙区",
	"adcode": 230202,
	"center": [123.957338, 47.341736]
}, {
	"name": "建华区",
	"adcode": 230203,
	"center": [123.955888, 47.354494]
}, {
	"name": "铁锋区",
	"adcode": 230204,
	"center": [123.973555, 47.339499]
}, {
	"name": "昂昂溪区",
	"adcode": 230205,
	"center": [123.813181, 47.156867]
}, {
	"name": "富拉尔基区",
	"adcode": 230206,
	"center": [123.638873, 47.20697]
}, {
	"name": "碾子山区",
	"adcode": 230207,
	"center": [122.887972, 47.51401]
}, {
	"name": "梅里斯达斡尔族区",
	"adcode": 230208,
	"center": [123.754599, 47.311113]
}, {
	"name": "龙江县",
	"adcode": 230221,
	"center": [123.187225, 47.336388]
}, {
	"name": "依安县",
	"adcode": 230223,
	"center": [125.307561, 47.890098]
}, {
	"name": "泰来县",
	"adcode": 230224,
	"center": [123.41953, 46.39233]
}, {
	"name": "甘南县",
	"adcode": 230225,
	"center": [123.506034, 47.917838]
}, {
	"name": "富裕县",
	"adcode": 230227,
	"center": [124.469106, 47.797172]
}, {
	"name": "克山县",
	"adcode": 230229,
	"center": [125.874355, 48.034342]
}, {
	"name": "克东县",
	"adcode": 230230,
	"center": [126.249094, 48.03732]
}, {
	"name": "拜泉县",
	"adcode": 230231,
	"center": [126.091911, 47.607363]
}, {
	"name": "讷河市",
	"adcode": 230281,
	"center": [124.882172, 48.481133]
}, {
	"name": "鸡冠区",
	"adcode": 230302,
	"center": [130.974374, 45.30034]
}, {
	"name": "恒山区",
	"adcode": 230303,
	"center": [130.910636, 45.213242]
}, {
	"name": "滴道区",
	"adcode": 230304,
	"center": [130.846823, 45.348812]
}, {
	"name": "梨树区",
	"adcode": 230305,
	"center": [130.697781, 45.092195]
}, {
	"name": "城子河区",
	"adcode": 230306,
	"center": [131.010501, 45.338248]
}, {
	"name": "麻山区",
	"adcode": 230307,
	"center": [130.481126, 45.209607]
}, {
	"name": "鸡东县",
	"adcode": 230321,
	"center": [131.148907, 45.250892]
}, {
	"name": "虎林市",
	"adcode": 230381,
	"center": [132.973881, 45.767985]
}, {
	"name": "密山市",
	"adcode": 230382,
	"center": [131.874137, 45.54725]
}, {
	"name": "向阳区",
	"adcode": 230402,
	"center": [130.292478, 47.345372]
}, {
	"name": "工农区",
	"adcode": 230403,
	"center": [130.276652, 47.331678]
}, {
	"name": "南山区",
	"adcode": 230404,
	"center": [130.275533, 47.31324]
}, {
	"name": "兴安区",
	"adcode": 230405,
	"center": [130.236169, 47.252911]
}, {
	"name": "东山区",
	"adcode": 230406,
	"center": [130.31714, 47.337385]
}, {
	"name": "兴山区",
	"adcode": 230407,
	"center": [130.30534, 47.35997]
}, {
	"name": "萝北县",
	"adcode": 230421,
	"center": [130.829087, 47.577577]
}, {
	"name": "绥滨县",
	"adcode": 230422,
	"center": [131.860526, 47.289892]
}, {
	"name": "尖山区",
	"adcode": 230502,
	"center": [131.15896, 46.642961]
}, {
	"name": "岭东区",
	"adcode": 230503,
	"center": [131.163675, 46.591076]
}, {
	"name": "四方台区",
	"adcode": 230505,
	"center": [131.333181, 46.594347]
}, {
	"name": "宝山区",
	"adcode": 230506,
	"center": [131.404294, 46.573366]
}, {
	"name": "集贤县",
	"adcode": 230521,
	"center": [131.13933, 46.72898]
}, {
	"name": "友谊县",
	"adcode": 230522,
	"center": [131.810622, 46.775159]
}, {
	"name": "宝清县",
	"adcode": 230523,
	"center": [132.206415, 46.328781]
}, {
	"name": "饶河县",
	"adcode": 230524,
	"center": [134.021162, 46.801288]
}, {
	"name": "萨尔图区",
	"adcode": 230602,
	"center": [125.114643, 46.596356]
}, {
	"name": "龙凤区",
	"adcode": 230603,
	"center": [125.145794, 46.573948]
}, {
	"name": "让胡路区",
	"adcode": 230604,
	"center": [124.868341, 46.653254]
}, {
	"name": "红岗区",
	"adcode": 230605,
	"center": [124.889528, 46.403049]
}, {
	"name": "大同区",
	"adcode": 230606,
	"center": [124.818509, 46.034304]
}, {
	"name": "肇州县",
	"adcode": 230621,
	"center": [125.273254, 45.708685]
}, {
	"name": "肇源县",
	"adcode": 230622,
	"center": [125.081974, 45.518832]
}, {
	"name": "林甸县",
	"adcode": 230623,
	"center": [124.877742, 47.186411]
}, {
	"name": "杜尔伯特蒙古族自治县",
	"adcode": 230624,
	"center": [124.446259, 46.865973]
}, {
	"name": "伊美区",
	"adcode": 230717,
	"center": [128.907303, 47.728171]
}, {
	"name": "乌翠区",
	"adcode": 230718,
	"center": [128.669859, 47.726728]
}, {
	"name": "友好区",
	"adcode": 230719,
	"center": [128.84075, 47.853778]
}, {
	"name": "嘉荫县",
	"adcode": 230722,
	"center": [130.397684, 48.891378]
}, {
	"name": "汤旺县",
	"adcode": 230723,
	"center": [129.571108, 48.454651]
}, {
	"name": "丰林县",
	"adcode": 230724,
	"center": [129.5336, 48.290455]
}, {
	"name": "大箐山县",
	"adcode": 230725,
	"center": [129.020793, 47.028397]
}, {
	"name": "南岔县",
	"adcode": 230726,
	"center": [129.28246, 47.137314]
}, {
	"name": "金林区",
	"adcode": 230751,
	"center": [129.429117, 47.413074]
}, {
	"name": "铁力市",
	"adcode": 230781,
	"center": [128.030561, 46.985772]
}, {
	"name": "向阳区",
	"adcode": 230803,
	"center": [130.361786, 46.809645]
}, {
	"name": "前进区",
	"adcode": 230804,
	"center": [130.377684, 46.812345]
}, {
	"name": "东风区",
	"adcode": 230805,
	"center": [130.403297, 46.822476]
}, {
	"name": "郊区",
	"adcode": 230811,
	"center": [130.351588, 46.80712]
}, {
	"name": "桦南县",
	"adcode": 230822,
	"center": [130.570112, 46.240118]
}, {
	"name": "桦川县",
	"adcode": 230826,
	"center": [130.723713, 47.023039]
}, {
	"name": "汤原县",
	"adcode": 230828,
	"center": [129.904463, 46.730048]
}, {
	"name": "同江市",
	"adcode": 230881,
	"center": [132.510119, 47.651131]
}, {
	"name": "富锦市",
	"adcode": 230882,
	"center": [132.037951, 47.250747]
}, {
	"name": "抚远市",
	"adcode": 230883,
	"center": [134.294501, 48.364707]
}, {
	"name": "新兴区",
	"adcode": 230902,
	"center": [130.889482, 45.794258]
}, {
	"name": "桃山区",
	"adcode": 230903,
	"center": [131.015848, 45.771217]
}, {
	"name": "茄子河区",
	"adcode": 230904,
	"center": [131.071561, 45.776587]
}, {
	"name": "勃利县",
	"adcode": 230921,
	"center": [130.575025, 45.751573]
}, {
	"name": "东安区",
	"adcode": 231002,
	"center": [129.623292, 44.582399]
}, {
	"name": "阳明区",
	"adcode": 231003,
	"center": [129.634645, 44.596328]
}, {
	"name": "爱民区",
	"adcode": 231004,
	"center": [129.601232, 44.595443]
}, {
	"name": "西安区",
	"adcode": 231005,
	"center": [129.61311, 44.581032]
}, {
	"name": "林口县",
	"adcode": 231025,
	"center": [130.268402, 45.286645]
}, {
	"name": "绥芬河市",
	"adcode": 231081,
	"center": [131.164856, 44.396864]
}, {
	"name": "海林市",
	"adcode": 231083,
	"center": [129.387902, 44.574149]
}, {
	"name": "宁安市",
	"adcode": 231084,
	"center": [129.470019, 44.346836]
}, {
	"name": "穆棱市",
	"adcode": 231085,
	"center": [130.527085, 44.91967]
}, {
	"name": "东宁市",
	"adcode": 231086,
	"center": [131.125296, 44.063578]
}, {
	"name": "爱辉区",
	"adcode": 231102,
	"center": [127.497639, 50.249027]
}, {
	"name": "逊克县",
	"adcode": 231123,
	"center": [128.476152, 49.582974]
}, {
	"name": "孙吴县",
	"adcode": 231124,
	"center": [127.327315, 49.423941]
}, {
	"name": "北安市",
	"adcode": 231181,
	"center": [126.508737, 48.245437]
}, {
	"name": "五大连池市",
	"adcode": 231182,
	"center": [126.197694, 48.512688]
}, {
	"name": "嫩江市",
	"adcode": 231183,
	"center": [125.229904, 49.177461]
}, {
	"name": "北林区",
	"adcode": 231202,
	"center": [126.990665, 46.634912]
}, {
	"name": "望奎县",
	"adcode": 231221,
	"center": [126.484191, 46.83352]
}, {
	"name": "兰西县",
	"adcode": 231222,
	"center": [126.289315, 46.259037]
}, {
	"name": "青冈县",
	"adcode": 231223,
	"center": [126.112268, 46.686596]
}, {
	"name": "庆安县",
	"adcode": 231224,
	"center": [127.510024, 46.879203]
}, {
	"name": "明水县",
	"adcode": 231225,
	"center": [125.907544, 47.183527]
}, {
	"name": "绥棱县",
	"adcode": 231226,
	"center": [127.111121, 47.247195]
}, {
	"name": "安达市",
	"adcode": 231281,
	"center": [125.329926, 46.410614]
}, {
	"name": "肇东市",
	"adcode": 231282,
	"center": [125.991402, 46.069471]
}, {
	"name": "海伦市",
	"adcode": 231283,
	"center": [126.969383, 47.460428]
}, {
	"name": "漠河市",
	"adcode": 232701,
	"center": [122.536256, 52.972074]
}, {
	"name": "加格达奇区",
	"adcode": 232718,
	"center": [124.126716, 50.424654]
}, {
	"name": "呼玛县",
	"adcode": 232721,
	"center": [126.662105, 51.726998]
}, {
	"name": "塔河县",
	"adcode": 232722,
	"center": [124.710516, 52.335229]
}, {
	"name": "黄浦区",
	"adcode": 310101,
	"center": [121.490317, 31.222771]
}, {
	"name": "徐汇区",
	"adcode": 310104,
	"center": [121.43752, 31.179973]
}, {
	"name": "长宁区",
	"adcode": 310105,
	"center": [121.4222, 31.218123]
}, {
	"name": "静安区",
	"adcode": 310106,
	"center": [121.448224, 31.229003]
}, {
	"name": "普陀区",
	"adcode": 310107,
	"center": [121.392499, 31.241701]
}, {
	"name": "虹口区",
	"adcode": 310109,
	"center": [121.491832, 31.26097]
}, {
	"name": "杨浦区",
	"adcode": 310110,
	"center": [121.522797, 31.270755]
}, {
	"name": "闵行区",
	"adcode": 310112,
	"center": [121.375972, 31.111658]
}, {
	"name": "宝山区",
	"adcode": 310113,
	"center": [121.489934, 31.398896]
}, {
	"name": "嘉定区",
	"adcode": 310114,
	"center": [121.250333, 31.383524]
}, {
	"name": "浦东新区",
	"adcode": 310115,
	"center": [121.567706, 31.245944]
}, {
	"name": "金山区",
	"adcode": 310116,
	"center": [121.330736, 30.724697]
}, {
	"name": "松江区",
	"adcode": 310117,
	"center": [121.223543, 31.03047]
}, {
	"name": "青浦区",
	"adcode": 310118,
	"center": [121.113021, 31.151209]
}, {
	"name": "奉贤区",
	"adcode": 310120,
	"center": [121.458472, 30.912345]
}, {
	"name": "崇明区",
	"adcode": 310151,
	"center": [121.397516, 31.626946]
}, {
	"name": "玄武区",
	"adcode": 320102,
	"center": [118.792199, 32.050678]
}, {
	"name": "秦淮区",
	"adcode": 320104,
	"center": [118.786088, 32.033818]
}, {
	"name": "建邺区",
	"adcode": 320105,
	"center": [118.732688, 32.004538]
}, {
	"name": "鼓楼区",
	"adcode": 320106,
	"center": [118.769739, 32.066966]
}, {
	"name": "浦口区",
	"adcode": 320111,
	"center": [118.625307, 32.05839]
}, {
	"name": "栖霞区",
	"adcode": 320113,
	"center": [118.808702, 32.102147]
}, {
	"name": "雨花台区",
	"adcode": 320114,
	"center": [118.77207, 31.995946]
}, {
	"name": "江宁区",
	"adcode": 320115,
	"center": [118.850621, 31.953418]
}, {
	"name": "六合区",
	"adcode": 320116,
	"center": [118.85065, 32.340655]
}, {
	"name": "溧水区",
	"adcode": 320117,
	"center": [119.028732, 31.653061]
}, {
	"name": "高淳区",
	"adcode": 320118,
	"center": [118.87589, 31.327132]
}, {
	"name": "锡山区",
	"adcode": 320205,
	"center": [120.357298, 31.585559]
}, {
	"name": "惠山区",
	"adcode": 320206,
	"center": [120.303543, 31.681019]
}, {
	"name": "滨湖区",
	"adcode": 320211,
	"center": [120.266053, 31.550228]
}, {
	"name": "梁溪区",
	"adcode": 320213,
	"center": [120.296595, 31.575706]
}, {
	"name": "新吴区",
	"adcode": 320214,
	"center": [120.352782, 31.550966]
}, {
	"name": "江阴市",
	"adcode": 320281,
	"center": [120.275891, 31.910984]
}, {
	"name": "宜兴市",
	"adcode": 320282,
	"center": [119.820538, 31.364384]
}, {
	"name": "鼓楼区",
	"adcode": 320302,
	"center": [117.192941, 34.269397]
}, {
	"name": "云龙区",
	"adcode": 320303,
	"center": [117.194589, 34.254805]
}, {
	"name": "贾汪区",
	"adcode": 320305,
	"center": [117.450212, 34.441642]
}, {
	"name": "泉山区",
	"adcode": 320311,
	"center": [117.182225, 34.262249]
}, {
	"name": "铜山区",
	"adcode": 320312,
	"center": [117.183894, 34.19288]
}, {
	"name": "丰县",
	"adcode": 320321,
	"center": [116.592888, 34.696946]
}, {
	"name": "沛县",
	"adcode": 320322,
	"center": [116.937182, 34.729044]
}, {
	"name": "睢宁县",
	"adcode": 320324,
	"center": [117.95066, 33.899222]
}, {
	"name": "新沂市",
	"adcode": 320381,
	"center": [118.345828, 34.368779]
}, {
	"name": "邳州市",
	"adcode": 320382,
	"center": [117.963923, 34.314708]
}, {
	"name": "天宁区",
	"adcode": 320402,
	"center": [119.963783, 31.779632]
}, {
	"name": "钟楼区",
	"adcode": 320404,
	"center": [119.948388, 31.78096]
}, {
	"name": "新北区",
	"adcode": 320411,
	"center": [119.974654, 31.824664]
}, {
	"name": "武进区",
	"adcode": 320412,
	"center": [119.958773, 31.718566]
}, {
	"name": "金坛区",
	"adcode": 320413,
	"center": [119.573395, 31.744399]
}, {
	"name": "溧阳市",
	"adcode": 320481,
	"center": [119.487816, 31.427081]
}, {
	"name": "虎丘区",
	"adcode": 320505,
	"center": [120.566833, 31.294845]
}, {
	"name": "吴中区",
	"adcode": 320506,
	"center": [120.624621, 31.270839]
}, {
	"name": "相城区",
	"adcode": 320507,
	"center": [120.618956, 31.396684]
}, {
	"name": "姑苏区",
	"adcode": 320508,
	"center": [120.622249, 31.311414]
}, {
	"name": "吴江区",
	"adcode": 320509,
	"center": [120.641601, 31.160404]
}, {
	"name": "常熟市",
	"adcode": 320581,
	"center": [120.74852, 31.658156]
}, {
	"name": "张家港市",
	"adcode": 320582,
	"center": [120.543441, 31.865553]
}, {
	"name": "昆山市",
	"adcode": 320583,
	"center": [120.958137, 31.381925]
}, {
	"name": "太仓市",
	"adcode": 320585,
	"center": [121.112275, 31.452568]
}, {
	"name": "崇川区",
	"adcode": 320602,
	"center": [120.86635, 32.015278]
}, {
	"name": "通州区",
	"adcode": 320612,
	"center": [121.073171, 32.084287]
}, {
	"name": "如东县",
	"adcode": 320623,
	"center": [121.186088, 32.311832]
}, {
	"name": "启东市",
	"adcode": 320681,
	"center": [121.659724, 31.810158]
}, {
	"name": "如皋市",
	"adcode": 320682,
	"center": [120.566324, 32.391591]
}, {
	"name": "海门区",
	"adcode": 320684,
	"center": [121.176609, 31.893528]
}, {
	"name": "海安市",
	"adcode": 320685,
	"center": [120.465995, 32.540288]
}, {
	"name": "连云区",
	"adcode": 320703,
	"center": [119.366487, 34.739529]
}, {
	"name": "海州区",
	"adcode": 320706,
	"center": [119.179793, 34.601584]
}, {
	"name": "赣榆区",
	"adcode": 320707,
	"center": [119.128774, 34.839154]
}, {
	"name": "东海县",
	"adcode": 320722,
	"center": [118.766489, 34.522859]
}, {
	"name": "灌云县",
	"adcode": 320723,
	"center": [119.255741, 34.298436]
}, {
	"name": "灌南县",
	"adcode": 320724,
	"center": [119.352331, 34.092553]
}, {
	"name": "淮安区",
	"adcode": 320803,
	"center": [119.14634, 33.507499]
}, {
	"name": "淮阴区",
	"adcode": 320804,
	"center": [119.020817, 33.622452]
}, {
	"name": "清江浦区",
	"adcode": 320812,
	"center": [119.019454, 33.603234]
}, {
	"name": "洪泽区",
	"adcode": 320813,
	"center": [118.867875, 33.294975]
}, {
	"name": "涟水县",
	"adcode": 320826,
	"center": [119.266078, 33.771308]
}, {
	"name": "盱眙县",
	"adcode": 320830,
	"center": [118.493823, 33.00439]
}, {
	"name": "金湖县",
	"adcode": 320831,
	"center": [119.016936, 33.018162]
}, {
	"name": "亭湖区",
	"adcode": 320902,
	"center": [120.136078, 33.383912]
}, {
	"name": "盐都区",
	"adcode": 320903,
	"center": [120.139753, 33.341288]
}, {
	"name": "大丰区",
	"adcode": 320904,
	"center": [120.470324, 33.199531]
}, {
	"name": "响水县",
	"adcode": 320921,
	"center": [119.579573, 34.19996]
}, {
	"name": "滨海县",
	"adcode": 320922,
	"center": [119.828434, 33.989888]
}, {
	"name": "阜宁县",
	"adcode": 320923,
	"center": [119.805338, 33.78573]
}, {
	"name": "射阳县",
	"adcode": 320924,
	"center": [120.257444, 33.773779]
}, {
	"name": "建湖县",
	"adcode": 320925,
	"center": [119.793105, 33.472621]
}, {
	"name": "东台市",
	"adcode": 320981,
	"center": [120.314101, 32.853174]
}, {
	"name": "广陵区",
	"adcode": 321002,
	"center": [119.442267, 32.392154]
}, {
	"name": "邗江区",
	"adcode": 321003,
	"center": [119.397777, 32.377899]
}, {
	"name": "江都区",
	"adcode": 321012,
	"center": [119.567481, 32.426564]
}, {
	"name": "宝应县",
	"adcode": 321023,
	"center": [119.321284, 33.23694]
}, {
	"name": "仪征市",
	"adcode": 321081,
	"center": [119.182443, 32.271965]
}, {
	"name": "高邮市",
	"adcode": 321084,
	"center": [119.443842, 32.785164]
}, {
	"name": "京口区",
	"adcode": 321102,
	"center": [119.454571, 32.206191]
}, {
	"name": "润州区",
	"adcode": 321111,
	"center": [119.414877, 32.213501]
}, {
	"name": "丹徒区",
	"adcode": 321112,
	"center": [119.433883, 32.128972]
}, {
	"name": "丹阳市",
	"adcode": 321181,
	"center": [119.581911, 31.991459]
}, {
	"name": "扬中市",
	"adcode": 321182,
	"center": [119.828054, 32.237266]
}, {
	"name": "句容市",
	"adcode": 321183,
	"center": [119.167135, 31.947355]
}, {
	"name": "海陵区",
	"adcode": 321202,
	"center": [119.920187, 32.488406]
}, {
	"name": "高港区",
	"adcode": 321203,
	"center": [119.88166, 32.315701]
}, {
	"name": "姜堰区",
	"adcode": 321204,
	"center": [120.148208, 32.508483]
}, {
	"name": "兴化市",
	"adcode": 321281,
	"center": [119.840162, 32.938065]
}, {
	"name": "靖江市",
	"adcode": 321282,
	"center": [120.26825, 32.018168]
}, {
	"name": "泰兴市",
	"adcode": 321283,
	"center": [120.020228, 32.168784]
}, {
	"name": "宿城区",
	"adcode": 321302,
	"center": [118.278984, 33.937726]
}, {
	"name": "宿豫区",
	"adcode": 321311,
	"center": [118.330012, 33.941071]
}, {
	"name": "沭阳县",
	"adcode": 321322,
	"center": [118.775889, 34.129097]
}, {
	"name": "泗阳县",
	"adcode": 321323,
	"center": [118.681284, 33.711433]
}, {
	"name": "泗洪县",
	"adcode": 321324,
	"center": [118.211824, 33.456538]
}, {
	"name": "上城区",
	"adcode": 330102,
	"center": [120.171465, 30.250236]
}, {
	"name": "拱墅区",
	"adcode": 330105,
	"center": [120.150053, 30.314697]
}, {
	"name": "西湖区",
	"adcode": 330106,
	"center": [120.147376, 30.272934]
}, {
	"name": "滨江区",
	"adcode": 330108,
	"center": [120.21062, 30.206615]
}, {
	"name": "萧山区",
	"adcode": 330109,
	"center": [120.27069, 30.162932]
}, {
	"name": "余杭区",
	"adcode": 330110,
	"center": [119.978959, 30.27365]
}, {
	"name": "富阳区",
	"adcode": 330111,
	"center": [119.949869, 30.049871]
}, {
	"name": "临安区",
	"adcode": 330112,
	"center": [119.715101, 30.231153]
}, {
	"name": "钱塘区",
	"adcode": 330114,
	"center": [120.493972, 30.322904]
}, {
	"name": "临平区",
	"adcode": 330113,
	"center": [120.299376, 30.419025]
}, {
	"name": "桐庐县",
	"adcode": 330122,
	"center": [119.685045, 29.797437]
}, {
	"name": "淳安县",
	"adcode": 330127,
	"center": [119.044276, 29.604177]
}, {
	"name": "建德市",
	"adcode": 330182,
	"center": [119.279089, 29.472284]
}, {
	"name": "海曙区",
	"adcode": 330203,
	"center": [121.539698, 29.874452]
}, {
	"name": "江北区",
	"adcode": 330205,
	"center": [121.559282, 29.888361]
}, {
	"name": "北仑区",
	"adcode": 330206,
	"center": [121.831303, 29.90944]
}, {
	"name": "镇海区",
	"adcode": 330211,
	"center": [121.713162, 29.952107]
}, {
	"name": "鄞州区",
	"adcode": 330212,
	"center": [121.558436, 29.831662]
}, {
	"name": "奉化区",
	"adcode": 330213,
	"center": [121.41089, 29.662348]
}, {
	"name": "象山县",
	"adcode": 330225,
	"center": [121.877091, 29.470206]
}, {
	"name": "宁海县",
	"adcode": 330226,
	"center": [121.432606, 29.299836]
}, {
	"name": "余姚市",
	"adcode": 330281,
	"center": [121.156294, 30.045404]
}, {
	"name": "慈溪市",
	"adcode": 330282,
	"center": [121.248052, 30.177142]
}, {
	"name": "鹿城区",
	"adcode": 330302,
	"center": [120.674231, 28.003352]
}, {
	"name": "龙湾区",
	"adcode": 330303,
	"center": [120.763469, 27.970254]
}, {
	"name": "瓯海区",
	"adcode": 330304,
	"center": [120.637145, 28.006444]
}, {
	"name": "洞头区",
	"adcode": 330305,
	"center": [121.156181, 27.836057]
}, {
	"name": "永嘉县",
	"adcode": 330324,
	"center": [120.690968, 28.153886]
}, {
	"name": "平阳县",
	"adcode": 330326,
	"center": [120.564387, 27.6693]
}, {
	"name": "苍南县",
	"adcode": 330327,
	"center": [120.406256, 27.507743]
}, {
	"name": "文成县",
	"adcode": 330328,
	"center": [120.09245, 27.789133]
}, {
	"name": "泰顺县",
	"adcode": 330329,
	"center": [119.71624, 27.557309]
}, {
	"name": "瑞安市",
	"adcode": 330381,
	"center": [120.646171, 27.779321]
}, {
	"name": "乐清市",
	"adcode": 330382,
	"center": [120.967147, 28.116083]
}, {
	"name": "龙港市",
	"adcode": 330383,
	"center": [120.553039, 27.578156]
}, {
	"name": "南湖区",
	"adcode": 330402,
	"center": [120.749953, 30.764652]
}, {
	"name": "秀洲区",
	"adcode": 330411,
	"center": [120.720431, 30.763323]
}, {
	"name": "嘉善县",
	"adcode": 330421,
	"center": [120.921871, 30.841352]
}, {
	"name": "海盐县",
	"adcode": 330424,
	"center": [120.942017, 30.522223]
}, {
	"name": "海宁市",
	"adcode": 330481,
	"center": [120.688821, 30.525544]
}, {
	"name": "平湖市",
	"adcode": 330482,
	"center": [121.014666, 30.698921]
}, {
	"name": "桐乡市",
	"adcode": 330483,
	"center": [120.551085, 30.629065]
}, {
	"name": "吴兴区",
	"adcode": 330502,
	"center": [120.101416, 30.867252]
}, {
	"name": "南浔区",
	"adcode": 330503,
	"center": [120.417195, 30.872742]
}, {
	"name": "德清县",
	"adcode": 330521,
	"center": [119.967662, 30.534927]
}, {
	"name": "长兴县",
	"adcode": 330522,
	"center": [119.910122, 31.00475]
}, {
	"name": "安吉县",
	"adcode": 330523,
	"center": [119.687891, 30.631974]
}, {
	"name": "越城区",
	"adcode": 330602,
	"center": [120.585315, 29.996993]
}, {
	"name": "柯桥区",
	"adcode": 330603,
	"center": [120.476075, 30.078038]
}, {
	"name": "上虞区",
	"adcode": 330604,
	"center": [120.874185, 30.016769]
}, {
	"name": "新昌县",
	"adcode": 330624,
	"center": [120.905665, 29.501205]
}, {
	"name": "诸暨市",
	"adcode": 330681,
	"center": [120.244326, 29.713662]
}, {
	"name": "嵊州市",
	"adcode": 330683,
	"center": [120.82888, 29.586606]
}, {
	"name": "婺城区",
	"adcode": 330702,
	"center": [119.652579, 29.082607]
}, {
	"name": "金东区",
	"adcode": 330703,
	"center": [119.681264, 29.095835]
}, {
	"name": "武义县",
	"adcode": 330723,
	"center": [119.819159, 28.896563]
}, {
	"name": "浦江县",
	"adcode": 330726,
	"center": [119.893363, 29.451254]
}, {
	"name": "磐安县",
	"adcode": 330727,
	"center": [120.44513, 29.052627]
}, {
	"name": "兰溪市",
	"adcode": 330781,
	"center": [119.460521, 29.210065]
}, {
	"name": "义乌市",
	"adcode": 330782,
	"center": [120.074911, 29.306863]
}, {
	"name": "东阳市",
	"adcode": 330783,
	"center": [120.23334, 29.262546]
}, {
	"name": "永康市",
	"adcode": 330784,
	"center": [120.036328, 28.895293]
}, {
	"name": "柯城区",
	"adcode": 330802,
	"center": [118.873041, 28.944539]
}, {
	"name": "衢江区",
	"adcode": 330803,
	"center": [118.957683, 28.973195]
}, {
	"name": "常山县",
	"adcode": 330822,
	"center": [118.521654, 28.900039]
}, {
	"name": "开化县",
	"adcode": 330824,
	"center": [118.414435, 29.136503]
}, {
	"name": "龙游县",
	"adcode": 330825,
	"center": [119.172525, 29.031364]
}, {
	"name": "江山市",
	"adcode": 330881,
	"center": [118.627879, 28.734674]
}, {
	"name": "定海区",
	"adcode": 330902,
	"center": [122.108496, 30.016423]
}, {
	"name": "普陀区",
	"adcode": 330903,
	"center": [122.301953, 29.945614]
}, {
	"name": "岱山县",
	"adcode": 330921,
	"center": [122.201132, 30.242865]
}, {
	"name": "嵊泗县",
	"adcode": 330922,
	"center": [122.457809, 30.727166]
}, {
	"name": "椒江区",
	"adcode": 331002,
	"center": [121.431049, 28.67615]
}, {
	"name": "黄岩区",
	"adcode": 331003,
	"center": [121.262138, 28.64488]
}, {
	"name": "路桥区",
	"adcode": 331004,
	"center": [121.37292, 28.581799]
}, {
	"name": "三门县",
	"adcode": 331022,
	"center": [121.376429, 29.118955]
}, {
	"name": "天台县",
	"adcode": 331023,
	"center": [121.031227, 29.141126]
}, {
	"name": "仙居县",
	"adcode": 331024,
	"center": [120.735074, 28.849213]
}, {
	"name": "温岭市",
	"adcode": 331081,
	"center": [121.373611, 28.368781]
}, {
	"name": "临海市",
	"adcode": 331082,
	"center": [121.131229, 28.845441]
}, {
	"name": "玉环市",
	"adcode": 331083,
	"center": [121.232337, 28.12842]
}, {
	"name": "莲都区",
	"adcode": 331102,
	"center": [119.922293, 28.451103]
}, {
	"name": "青田县",
	"adcode": 331121,
	"center": [120.291939, 28.135247]
}, {
	"name": "缙云县",
	"adcode": 331122,
	"center": [120.078965, 28.654208]
}, {
	"name": "遂昌县",
	"adcode": 331123,
	"center": [119.27589, 28.5924]
}, {
	"name": "松阳县",
	"adcode": 331124,
	"center": [119.485292, 28.449937]
}, {
	"name": "云和县",
	"adcode": 331125,
	"center": [119.569458, 28.111077]
}, {
	"name": "庆元县",
	"adcode": 331126,
	"center": [119.067233, 27.618231]
}, {
	"name": "景宁畲族自治县",
	"adcode": 331127,
	"center": [119.634669, 27.977247]
}, {
	"name": "龙泉市",
	"adcode": 331181,
	"center": [119.132319, 28.069177]
}, {
	"name": "瑶海区",
	"adcode": 340102,
	"center": [117.315358, 31.86961]
}, {
	"name": "庐阳区",
	"adcode": 340103,
	"center": [117.283776, 31.869011]
}, {
	"name": "蜀山区",
	"adcode": 340104,
	"center": [117.262072, 31.855868]
}, {
	"name": "包河区",
	"adcode": 340111,
	"center": [117.285751, 31.82956]
}, {
	"name": "长丰县",
	"adcode": 340121,
	"center": [117.164699, 32.478548]
}, {
	"name": "肥东县",
	"adcode": 340122,
	"center": [117.463222, 31.883992]
}, {
	"name": "肥西县",
	"adcode": 340123,
	"center": [117.166118, 31.719646]
}, {
	"name": "庐江县",
	"adcode": 340124,
	"center": [117.289844, 31.251488]
}, {
	"name": "巢湖市",
	"adcode": 340181,
	"center": [117.874155, 31.600518]
}, {
	"name": "镜湖区",
	"adcode": 340202,
	"center": [118.376343, 31.32559]
}, {
	"name": "鸠江区",
	"adcode": 340207,
	"center": [118.400174, 31.362716]
}, {
	"name": "弋江区",
	"adcode": 340209,
	"center": [118.377476, 31.313394]
}, {
	"name": "湾沚区",
	"adcode": 340210,
	"center": [118.572301, 31.145262]
}, {
	"name": "繁昌区",
	"adcode": 340211,
	"center": [118.201349, 31.080896]
}, {
	"name": "南陵县",
	"adcode": 340223,
	"center": [118.337104, 30.919638]
}, {
	"name": "无为市",
	"adcode": 340281,
	"center": [117.911432, 31.303075]
}, {
	"name": "龙子湖区",
	"adcode": 340302,
	"center": [117.382312, 32.950452]
}, {
	"name": "蚌山区",
	"adcode": 340303,
	"center": [117.355789, 32.938066]
}, {
	"name": "禹会区",
	"adcode": 340304,
	"center": [117.35259, 32.931933]
}, {
	"name": "淮上区",
	"adcode": 340311,
	"center": [117.34709, 32.963147]
}, {
	"name": "怀远县",
	"adcode": 340321,
	"center": [117.200171, 32.956934]
}, {
	"name": "五河县",
	"adcode": 340322,
	"center": [117.888809, 33.146202]
}, {
	"name": "固镇县",
	"adcode": 340323,
	"center": [117.315962, 33.318679]
}, {
	"name": "大通区",
	"adcode": 340402,
	"center": [117.052927, 32.632066]
}, {
	"name": "田家庵区",
	"adcode": 340403,
	"center": [117.018318, 32.644342]
}, {
	"name": "谢家集区",
	"adcode": 340404,
	"center": [116.865354, 32.598289]
}, {
	"name": "八公山区",
	"adcode": 340405,
	"center": [116.841111, 32.628229]
}, {
	"name": "潘集区",
	"adcode": 340406,
	"center": [116.816879, 32.782117]
}, {
	"name": "凤台县",
	"adcode": 340421,
	"center": [116.722769, 32.705382]
}, {
	"name": "寿县",
	"adcode": 340422,
	"center": [116.785349, 32.577304]
}, {
	"name": "花山区",
	"adcode": 340503,
	"center": [118.511308, 31.69902]
}, {
	"name": "雨山区",
	"adcode": 340504,
	"center": [118.493104, 31.685912]
}, {
	"name": "博望区",
	"adcode": 340506,
	"center": [118.843742, 31.562321]
}, {
	"name": "当涂县",
	"adcode": 340521,
	"center": [118.489873, 31.556167]
}, {
	"name": "含山县",
	"adcode": 340522,
	"center": [118.105545, 31.727758]
}, {
	"name": "和县",
	"adcode": 340523,
	"center": [118.362998, 31.716634]
}, {
	"name": "杜集区",
	"adcode": 340602,
	"center": [116.833925, 33.991218]
}, {
	"name": "相山区",
	"adcode": 340603,
	"center": [116.790775, 33.970916]
}, {
	"name": "烈山区",
	"adcode": 340604,
	"center": [116.809465, 33.889529]
}, {
	"name": "濉溪县",
	"adcode": 340621,
	"center": [116.767435, 33.916407]
}, {
	"name": "铜官区",
	"adcode": 340705,
	"center": [117.816167, 30.927613]
}, {
	"name": "义安区",
	"adcode": 340706,
	"center": [117.792288, 30.952338]
}, {
	"name": "郊区",
	"adcode": 340711,
	"center": [117.80707, 30.908927]
}, {
	"name": "枞阳县",
	"adcode": 340722,
	"center": [117.222027, 30.700615]
}, {
	"name": "迎江区",
	"adcode": 340802,
	"center": [117.044965, 30.506375]
}, {
	"name": "大观区",
	"adcode": 340803,
	"center": [117.034512, 30.505632]
}, {
	"name": "宜秀区",
	"adcode": 340811,
	"center": [117.070003, 30.541323]
}, {
	"name": "怀宁县",
	"adcode": 340822,
	"center": [116.828664, 30.734994]
}, {
	"name": "太湖县",
	"adcode": 340825,
	"center": [116.305225, 30.451869]
}, {
	"name": "宿松县",
	"adcode": 340826,
	"center": [116.120204, 30.158327]
}, {
	"name": "望江县",
	"adcode": 340827,
	"center": [116.690927, 30.12491]
}, {
	"name": "岳西县",
	"adcode": 340828,
	"center": [116.360482, 30.848502]
}, {
	"name": "桐城市",
	"adcode": 340881,
	"center": [116.959656, 31.050576]
}, {
	"name": "潜山市",
	"adcode": 340882,
	"center": [116.573665, 30.638222]
}, {
	"name": "屯溪区",
	"adcode": 341002,
	"center": [118.317354, 29.709186]
}, {
	"name": "黄山区",
	"adcode": 341003,
	"center": [118.136639, 30.294517]
}, {
	"name": "徽州区",
	"adcode": 341004,
	"center": [118.339743, 29.825201]
}, {
	"name": "歙县",
	"adcode": 341021,
	"center": [118.428025, 29.867748]
}, {
	"name": "休宁县",
	"adcode": 341022,
	"center": [118.188531, 29.788878]
}, {
	"name": "黟县",
	"adcode": 341023,
	"center": [117.942911, 29.923812]
}, {
	"name": "祁门县",
	"adcode": 341024,
	"center": [117.717237, 29.853472]
}, {
	"name": "琅琊区",
	"adcode": 341102,
	"center": [118.316475, 32.303797]
}, {
	"name": "南谯区",
	"adcode": 341103,
	"center": [118.296955, 32.329841]
}, {
	"name": "来安县",
	"adcode": 341122,
	"center": [118.433293, 32.450231]
}, {
	"name": "全椒县",
	"adcode": 341124,
	"center": [118.268576, 32.09385]
}, {
	"name": "定远县",
	"adcode": 341125,
	"center": [117.683713, 32.527105]
}, {
	"name": "凤阳县",
	"adcode": 341126,
	"center": [117.562461, 32.867146]
}, {
	"name": "天长市",
	"adcode": 341181,
	"center": [119.011212, 32.6815]
}, {
	"name": "明光市",
	"adcode": 341182,
	"center": [117.998048, 32.781206]
}, {
	"name": "颍州区",
	"adcode": 341202,
	"center": [115.813914, 32.891238]
}, {
	"name": "颍东区",
	"adcode": 341203,
	"center": [115.858747, 32.908861]
}, {
	"name": "颍泉区",
	"adcode": 341204,
	"center": [115.804525, 32.924797]
}, {
	"name": "临泉县",
	"adcode": 341221,
	"center": [115.261688, 33.062698]
}, {
	"name": "太和县",
	"adcode": 341222,
	"center": [115.627243, 33.16229]
}, {
	"name": "阜南县",
	"adcode": 341225,
	"center": [115.590534, 32.638102]
}, {
	"name": "颍上县",
	"adcode": 341226,
	"center": [116.259122, 32.637065]
}, {
	"name": "界首市",
	"adcode": 341282,
	"center": [115.362117, 33.26153]
}, {
	"name": "埇桥区",
	"adcode": 341302,
	"center": [116.983309, 33.633853]
}, {
	"name": "砀山县",
	"adcode": 341321,
	"center": [116.351113, 34.426247]
}, {
	"name": "萧县",
	"adcode": 341322,
	"center": [116.945399, 34.183266]
}, {
	"name": "灵璧县",
	"adcode": 341323,
	"center": [117.551493, 33.540629]
}, {
	"name": "泗县",
	"adcode": 341324,
	"center": [117.885443, 33.47758]
}, {
	"name": "金安区",
	"adcode": 341502,
	"center": [116.503288, 31.754491]
}, {
	"name": "裕安区",
	"adcode": 341503,
	"center": [116.494543, 31.750692]
}, {
	"name": "叶集区",
	"adcode": 341504,
	"center": [115.913594, 31.84768]
}, {
	"name": "霍邱县",
	"adcode": 341522,
	"center": [116.278875, 32.341305]
}, {
	"name": "舒城县",
	"adcode": 341523,
	"center": [116.944088, 31.462848]
}, {
	"name": "金寨县",
	"adcode": 341524,
	"center": [115.878514, 31.681624]
}, {
	"name": "霍山县",
	"adcode": 341525,
	"center": [116.333078, 31.402456]
}, {
	"name": "谯城区",
	"adcode": 341602,
	"center": [115.781214, 33.869284]
}, {
	"name": "涡阳县",
	"adcode": 341621,
	"center": [116.211551, 33.502831]
}, {
	"name": "蒙城县",
	"adcode": 341622,
	"center": [116.560337, 33.260814]
}, {
	"name": "利辛县",
	"adcode": 341623,
	"center": [116.207782, 33.143503]
}, {
	"name": "贵池区",
	"adcode": 341702,
	"center": [117.488342, 30.657378]
}, {
	"name": "东至县",
	"adcode": 341721,
	"center": [117.021476, 30.096568]
}, {
	"name": "石台县",
	"adcode": 341722,
	"center": [117.482907, 30.210324]
}, {
	"name": "青阳县",
	"adcode": 341723,
	"center": [117.857395, 30.63818]
}, {
	"name": "宣州区",
	"adcode": 341802,
	"center": [118.758412, 30.946003]
}, {
	"name": "郎溪县",
	"adcode": 341821,
	"center": [119.185024, 31.127834]
}, {
	"name": "泾县",
	"adcode": 341823,
	"center": [118.412397, 30.685975]
}, {
	"name": "绩溪县",
	"adcode": 341824,
	"center": [118.594705, 30.065267]
}, {
	"name": "旌德县",
	"adcode": 341825,
	"center": [118.543081, 30.288057]
}, {
	"name": "宁国市",
	"adcode": 341881,
	"center": [118.983407, 30.626529]
}, {
	"name": "广德市",
	"adcode": 341882,
	"center": [119.417521, 30.893116]
}, {
	"name": "鼓楼区",
	"adcode": 350102,
	"center": [119.29929, 26.082284]
}, {
	"name": "台江区",
	"adcode": 350103,
	"center": [119.310156, 26.058616]
}, {
	"name": "仓山区",
	"adcode": 350104,
	"center": [119.320988, 26.038912]
}, {
	"name": "马尾区",
	"adcode": 350105,
	"center": [119.458725, 25.991975]
}, {
	"name": "晋安区",
	"adcode": 350111,
	"center": [119.328597, 26.078837]
}, {
	"name": "长乐区",
	"adcode": 350112,
	"center": [119.510849, 25.960583]
}, {
	"name": "闽侯县",
	"adcode": 350121,
	"center": [119.145117, 26.148567]
}, {
	"name": "连江县",
	"adcode": 350122,
	"center": [119.538365, 26.202109]
}, {
	"name": "罗源县",
	"adcode": 350123,
	"center": [119.552645, 26.487234]
}, {
	"name": "闽清县",
	"adcode": 350124,
	"center": [118.868416, 26.223793]
}, {
	"name": "永泰县",
	"adcode": 350125,
	"center": [118.939089, 25.864825]
}, {
	"name": "平潭县",
	"adcode": 350128,
	"center": [119.791197, 25.503672]
}, {
	"name": "福清市",
	"adcode": 350181,
	"center": [119.376992, 25.720402]
}, {
	"name": "思明区",
	"adcode": 350203,
	"center": [118.087828, 24.462059]
}, {
	"name": "海沧区",
	"adcode": 350205,
	"center": [118.036364, 24.492512]
}, {
	"name": "湖里区",
	"adcode": 350206,
	"center": [118.10943, 24.512764]
}, {
	"name": "集美区",
	"adcode": 350211,
	"center": [118.100869, 24.572874]
}, {
	"name": "同安区",
	"adcode": 350212,
	"center": [118.150455, 24.729333]
}, {
	"name": "翔安区",
	"adcode": 350213,
	"center": [118.242811, 24.637479]
}, {
	"name": "城厢区",
	"adcode": 350302,
	"center": [119.001028, 25.433737]
}, {
	"name": "涵江区",
	"adcode": 350303,
	"center": [119.119102, 25.459273]
}, {
	"name": "荔城区",
	"adcode": 350304,
	"center": [119.020047, 25.430047]
}, {
	"name": "秀屿区",
	"adcode": 350305,
	"center": [119.092607, 25.316141]
}, {
	"name": "仙游县",
	"adcode": 350322,
	"center": [118.694331, 25.356529]
}, {
	"name": "三元区",
	"adcode": 350403,
	"center": [117.607418, 26.234191]
}, {
	"name": "明溪县",
	"adcode": 350421,
	"center": [117.201845, 26.357375]
}, {
	"name": "清流县",
	"adcode": 350423,
	"center": [116.815821, 26.17761]
}, {
	"name": "宁化县",
	"adcode": 350424,
	"center": [116.659725, 26.259932]
}, {
	"name": "大田县",
	"adcode": 350425,
	"center": [117.849355, 25.690803]
}, {
	"name": "尤溪县",
	"adcode": 350426,
	"center": [118.188577, 26.169261]
}, {
	"name": "沙县区",
	"adcode": 350427,
	"center": [117.789095, 26.397361]
}, {
	"name": "将乐县",
	"adcode": 350428,
	"center": [117.473558, 26.728667]
}, {
	"name": "泰宁县",
	"adcode": 350429,
	"center": [117.177522, 26.897995]
}, {
	"name": "建宁县",
	"adcode": 350430,
	"center": [116.845832, 26.831398]
}, {
	"name": "永安市",
	"adcode": 350481,
	"center": [117.364447, 25.974075]
}, {
	"name": "鲤城区",
	"adcode": 350502,
	"center": [118.588929, 24.907645]
}, {
	"name": "丰泽区",
	"adcode": 350503,
	"center": [118.605147, 24.896041]
}, {
	"name": "洛江区",
	"adcode": 350504,
	"center": [118.670312, 24.941153]
}, {
	"name": "泉港区",
	"adcode": 350505,
	"center": [118.912285, 25.126859]
}, {
	"name": "惠安县",
	"adcode": 350521,
	"center": [118.798954, 25.028718]
}, {
	"name": "安溪县",
	"adcode": 350524,
	"center": [118.186014, 25.056824]
}, {
	"name": "永春县",
	"adcode": 350525,
	"center": [118.29503, 25.320721]
}, {
	"name": "德化县",
	"adcode": 350526,
	"center": [118.242986, 25.489004]
}, {
	"name": "金门县",
	"adcode": 350527,
	"center": [118.323221, 24.436417]
}, {
	"name": "石狮市",
	"adcode": 350581,
	"center": [118.628402, 24.731978]
}, {
	"name": "晋江市",
	"adcode": 350582,
	"center": [118.577338, 24.807322]
}, {
	"name": "南安市",
	"adcode": 350583,
	"center": [118.387031, 24.959494]
}, {
	"name": "芗城区",
	"adcode": 350602,
	"center": [117.656461, 24.509955]
}, {
	"name": "龙文区",
	"adcode": 350603,
	"center": [117.671387, 24.515656]
}, {
	"name": "云霄县",
	"adcode": 350622,
	"center": [117.340946, 23.950486]
}, {
	"name": "漳浦县",
	"adcode": 350623,
	"center": [117.614023, 24.117907]
}, {
	"name": "诏安县",
	"adcode": 350624,
	"center": [117.176083, 23.710834]
}, {
	"name": "长泰区",
	"adcode": 350625,
	"center": [117.755913, 24.621475]
}, {
	"name": "东山县",
	"adcode": 350626,
	"center": [117.427679, 23.702845]
}, {
	"name": "南靖县",
	"adcode": 350627,
	"center": [117.365462, 24.516425]
}, {
	"name": "平和县",
	"adcode": 350628,
	"center": [117.313549, 24.366158]
}, {
	"name": "华安县",
	"adcode": 350629,
	"center": [117.53631, 25.001416]
}, {
	"name": "龙海区",
	"adcode": 350681,
	"center": [117.817292, 24.445341]
}, {
	"name": "延平区",
	"adcode": 350702,
	"center": [118.178918, 26.636079]
}, {
	"name": "建阳区",
	"adcode": 350703,
	"center": [118.12267, 27.332067]
}, {
	"name": "顺昌县",
	"adcode": 350721,
	"center": [117.80771, 26.792851]
}, {
	"name": "浦城县",
	"adcode": 350722,
	"center": [118.536822, 27.920412]
}, {
	"name": "光泽县",
	"adcode": 350723,
	"center": [117.337897, 27.542803]
}, {
	"name": "松溪县",
	"adcode": 350724,
	"center": [118.783491, 27.525785]
}, {
	"name": "政和县",
	"adcode": 350725,
	"center": [118.858661, 27.365398]
}, {
	"name": "邵武市",
	"adcode": 350781,
	"center": [117.491544, 27.337952]
}, {
	"name": "武夷山市",
	"adcode": 350782,
	"center": [118.032796, 27.751733]
}, {
	"name": "建瓯市",
	"adcode": 350783,
	"center": [118.321765, 27.03502]
}, {
	"name": "新罗区",
	"adcode": 350802,
	"center": [117.030721, 25.0918]
}, {
	"name": "永定区",
	"adcode": 350803,
	"center": [116.732691, 24.720442]
}, {
	"name": "长汀县",
	"adcode": 350821,
	"center": [116.361007, 25.842278]
}, {
	"name": "上杭县",
	"adcode": 350823,
	"center": [116.424774, 25.050019]
}, {
	"name": "武平县",
	"adcode": 350824,
	"center": [116.100928, 25.08865]
}, {
	"name": "连城县",
	"adcode": 350825,
	"center": [116.756687, 25.708506]
}, {
	"name": "漳平市",
	"adcode": 350881,
	"center": [117.42073, 25.291597]
}, {
	"name": "蕉城区",
	"adcode": 350902,
	"center": [119.527225, 26.659253]
}, {
	"name": "霞浦县",
	"adcode": 350921,
	"center": [120.005214, 26.882068]
}, {
	"name": "古田县",
	"adcode": 350922,
	"center": [118.743156, 26.577491]
}, {
	"name": "屏南县",
	"adcode": 350923,
	"center": [118.987544, 26.910826]
}, {
	"name": "寿宁县",
	"adcode": 350924,
	"center": [119.506733, 27.457798]
}, {
	"name": "周宁县",
	"adcode": 350925,
	"center": [119.338239, 27.103106]
}, {
	"name": "柘荣县",
	"adcode": 350926,
	"center": [119.898226, 27.236163]
}, {
	"name": "福安市",
	"adcode": 350981,
	"center": [119.650798, 27.084246]
}, {
	"name": "福鼎市",
	"adcode": 350982,
	"center": [120.219761, 27.318884]
}, {
	"name": "东湖区",
	"adcode": 360102,
	"center": [115.889675, 28.682988]
}, {
	"name": "西湖区",
	"adcode": 360103,
	"center": [115.91065, 28.662901]
}, {
	"name": "青云谱区",
	"adcode": 360104,
	"center": [115.907292, 28.635724]
}, {
	"name": "青山湖区",
	"adcode": 360111,
	"center": [115.949044, 28.689292]
}, {
	"name": "新建区",
	"adcode": 360112,
	"center": [115.820806, 28.690788]
}, {
	"name": "红谷滩区",
	"adcode": 360113,
	"center": [115.8580521, 28.69819928]
}, {
	"name": "南昌县",
	"adcode": 360121,
	"center": [115.942465, 28.543781]
}, {
	"name": "安义县",
	"adcode": 360123,
	"center": [115.553109, 28.841334]
}, {
	"name": "进贤县",
	"adcode": 360124,
	"center": [116.267671, 28.365681]
}, {
	"name": "昌江区",
	"adcode": 360202,
	"center": [117.195023, 29.288465]
}, {
	"name": "珠山区",
	"adcode": 360203,
	"center": [117.214814, 29.292812]
}, {
	"name": "浮梁县",
	"adcode": 360222,
	"center": [117.217611, 29.352251]
}, {
	"name": "乐平市",
	"adcode": 360281,
	"center": [117.129376, 28.967361]
}, {
	"name": "安源区",
	"adcode": 360302,
	"center": [113.855044, 27.625826]
}, {
	"name": "湘东区",
	"adcode": 360313,
	"center": [113.7456, 27.639319]
}, {
	"name": "莲花县",
	"adcode": 360321,
	"center": [113.955582, 27.127807]
}, {
	"name": "上栗县",
	"adcode": 360322,
	"center": [113.800525, 27.877041]
}, {
	"name": "芦溪县",
	"adcode": 360323,
	"center": [114.041206, 27.633633]
}, {
	"name": "濂溪区",
	"adcode": 360402,
	"center": [115.99012, 29.676175]
}, {
	"name": "浔阳区",
	"adcode": 360403,
	"center": [115.995947, 29.72465]
}, {
	"name": "柴桑区",
	"adcode": 360404,
	"center": [115.892977, 29.610264]
}, {
	"name": "武宁县",
	"adcode": 360423,
	"center": [115.105646, 29.260182]
}, {
	"name": "修水县",
	"adcode": 360424,
	"center": [114.573428, 29.032729]
}, {
	"name": "永修县",
	"adcode": 360425,
	"center": [115.809055, 29.018212]
}, {
	"name": "德安县",
	"adcode": 360426,
	"center": [115.762611, 29.327474]
}, {
	"name": "都昌县",
	"adcode": 360428,
	"center": [116.205114, 29.275105]
}, {
	"name": "湖口县",
	"adcode": 360429,
	"center": [116.244313, 29.7263]
}, {
	"name": "彭泽县",
	"adcode": 360430,
	"center": [116.55584, 29.898865]
}, {
	"name": "瑞昌市",
	"adcode": 360481,
	"center": [115.669081, 29.676599]
}, {
	"name": "共青城市",
	"adcode": 360482,
	"center": [115.805712, 29.247884]
}, {
	"name": "庐山市",
	"adcode": 360483,
	"center": [116.043743, 29.456169]
}, {
	"name": "渝水区",
	"adcode": 360502,
	"center": [114.923923, 27.819171]
}, {
	"name": "分宜县",
	"adcode": 360521,
	"center": [114.675262, 27.811301]
}, {
	"name": "月湖区",
	"adcode": 360602,
	"center": [117.034112, 28.239076]
}, {
	"name": "余江区",
	"adcode": 360603,
	"center": [116.822763, 28.206177]
}, {
	"name": "贵溪市",
	"adcode": 360681,
	"center": [117.212103, 28.283693]
}, {
	"name": "章贡区",
	"adcode": 360702,
	"center": [114.93872, 25.851367]
}, {
	"name": "南康区",
	"adcode": 360703,
	"center": [114.756933, 25.661721]
}, {
	"name": "赣县区",
	"adcode": 360704,
	"center": [115.018461, 25.865432]
}, {
	"name": "信丰县",
	"adcode": 360722,
	"center": [114.930893, 25.38023]
}, {
	"name": "大余县",
	"adcode": 360723,
	"center": [114.362243, 25.395937]
}, {
	"name": "上犹县",
	"adcode": 360724,
	"center": [114.540537, 25.794284]
}, {
	"name": "崇义县",
	"adcode": 360725,
	"center": [114.307348, 25.687911]
}, {
	"name": "安远县",
	"adcode": 360726,
	"center": [115.392328, 25.134591]
}, {
	"name": "定南县",
	"adcode": 360728,
	"center": [115.03267, 24.774277]
}, {
	"name": "全南县",
	"adcode": 360729,
	"center": [114.531589, 24.742651]
}, {
	"name": "宁都县",
	"adcode": 360730,
	"center": [116.018782, 26.472054]
}, {
	"name": "于都县",
	"adcode": 360731,
	"center": [115.411198, 25.955033]
}, {
	"name": "兴国县",
	"adcode": 360732,
	"center": [115.351896, 26.330489]
}, {
	"name": "会昌县",
	"adcode": 360733,
	"center": [115.791158, 25.599125]
}, {
	"name": "寻乌县",
	"adcode": 360734,
	"center": [115.651399, 24.954136]
}, {
	"name": "石城县",
	"adcode": 360735,
	"center": [116.342249, 26.326582]
}, {
	"name": "瑞金市",
	"adcode": 360781,
	"center": [116.034854, 25.875278]
}, {
	"name": "龙南市",
	"adcode": 360783,
	"center": [114.792657, 24.90476]
}, {
	"name": "吉州区",
	"adcode": 360802,
	"center": [114.987331, 27.112367]
}, {
	"name": "青原区",
	"adcode": 360803,
	"center": [115.016306, 27.105879]
}, {
	"name": "吉安县",
	"adcode": 360821,
	"center": [114.905117, 27.040042]
}, {
	"name": "吉水县",
	"adcode": 360822,
	"center": [115.134569, 27.213445]
}, {
	"name": "峡江县",
	"adcode": 360823,
	"center": [115.319331, 27.580862]
}, {
	"name": "新干县",
	"adcode": 360824,
	"center": [115.399294, 27.755758]
}, {
	"name": "永丰县",
	"adcode": 360825,
	"center": [115.435559, 27.321087]
}, {
	"name": "泰和县",
	"adcode": 360826,
	"center": [114.901393, 26.790164]
}, {
	"name": "遂川县",
	"adcode": 360827,
	"center": [114.51689, 26.323705]
}, {
	"name": "万安县",
	"adcode": 360828,
	"center": [114.784694, 26.462085]
}, {
	"name": "安福县",
	"adcode": 360829,
	"center": [114.61384, 27.382746]
}, {
	"name": "永新县",
	"adcode": 360830,
	"center": [114.242534, 26.944721]
}, {
	"name": "井冈山市",
	"adcode": 360881,
	"center": [114.284421, 26.745919]
}, {
	"name": "袁州区",
	"adcode": 360902,
	"center": [114.387379, 27.800117]
}, {
	"name": "奉新县",
	"adcode": 360921,
	"center": [115.389899, 28.700672]
}, {
	"name": "万载县",
	"adcode": 360922,
	"center": [114.449012, 28.104528]
}, {
	"name": "上高县",
	"adcode": 360923,
	"center": [114.932653, 28.234789]
}, {
	"name": "宜丰县",
	"adcode": 360924,
	"center": [114.787381, 28.388289]
}, {
	"name": "靖安县",
	"adcode": 360925,
	"center": [115.361744, 28.86054]
}, {
	"name": "铜鼓县",
	"adcode": 360926,
	"center": [114.37014, 28.520956]
}, {
	"name": "丰城市",
	"adcode": 360981,
	"center": [115.786005, 28.191584]
}, {
	"name": "樟树市",
	"adcode": 360982,
	"center": [115.543388, 28.055898]
}, {
	"name": "高安市",
	"adcode": 360983,
	"center": [115.381527, 28.420951]
}, {
	"name": "临川区",
	"adcode": 361002,
	"center": [116.361404, 27.981919]
}, {
	"name": "东乡区",
	"adcode": 361003,
	"center": [116.605341, 28.2325]
}, {
	"name": "南城县",
	"adcode": 361021,
	"center": [116.63945, 27.55531]
}, {
	"name": "黎川县",
	"adcode": 361022,
	"center": [116.91457, 27.292561]
}, {
	"name": "南丰县",
	"adcode": 361023,
	"center": [116.532994, 27.210132]
}, {
	"name": "崇仁县",
	"adcode": 361024,
	"center": [116.059109, 27.760907]
}, {
	"name": "乐安县",
	"adcode": 361025,
	"center": [115.838432, 27.420101]
}, {
	"name": "宜黄县",
	"adcode": 361026,
	"center": [116.223023, 27.546512]
}, {
	"name": "金溪县",
	"adcode": 361027,
	"center": [116.778751, 27.907387]
}, {
	"name": "资溪县",
	"adcode": 361028,
	"center": [117.066095, 27.70653]
}, {
	"name": "广昌县",
	"adcode": 361030,
	"center": [116.327291, 26.838426]
}, {
	"name": "信州区",
	"adcode": 361102,
	"center": [117.970522, 28.445378]
}, {
	"name": "广丰区",
	"adcode": 361103,
	"center": [118.189852, 28.440285]
}, {
	"name": "广信区",
	"adcode": 361104,
	"center": [117.90612, 28.453897]
}, {
	"name": "玉山县",
	"adcode": 361123,
	"center": [118.244408, 28.673479]
}, {
	"name": "铅山县",
	"adcode": 361124,
	"center": [117.711906, 28.310892]
}, {
	"name": "横峰县",
	"adcode": 361125,
	"center": [117.608247, 28.415103]
}, {
	"name": "弋阳县",
	"adcode": 361126,
	"center": [117.435002, 28.402391]
}, {
	"name": "余干县",
	"adcode": 361127,
	"center": [116.691072, 28.69173]
}, {
	"name": "鄱阳县",
	"adcode": 361128,
	"center": [116.673748, 28.993374]
}, {
	"name": "万年县",
	"adcode": 361129,
	"center": [117.07015, 28.692589]
}, {
	"name": "婺源县",
	"adcode": 361130,
	"center": [117.86219, 29.254015]
}, {
	"name": "德兴市",
	"adcode": 361181,
	"center": [117.578732, 28.945034]
}, {
	"name": "历下区",
	"adcode": 370102,
	"center": [117.03862, 36.664169]
}, {
	"name": "市中区",
	"adcode": 370103,
	"center": [116.99898, 36.657354]
}, {
	"name": "槐荫区",
	"adcode": 370104,
	"center": [116.947921, 36.668205]
}, {
	"name": "天桥区",
	"adcode": 370105,
	"center": [116.996086, 36.693374]
}, {
	"name": "历城区",
	"adcode": 370112,
	"center": [117.063744, 36.681744]
}, {
	"name": "长清区",
	"adcode": 370113,
	"center": [116.74588, 36.561049]
}, {
	"name": "章丘区",
	"adcode": 370114,
	"center": [117.54069, 36.71209]
}, {
	"name": "济阳区",
	"adcode": 370115,
	"center": [117.176035, 36.976771]
}, {
	"name": "莱芜区",
	"adcode": 370116,
	"center": [117.675808, 36.214395]
}, {
	"name": "钢城区",
	"adcode": 370117,
	"center": [117.82033, 36.058038]
}, {
	"name": "平阴县",
	"adcode": 370124,
	"center": [116.455054, 36.286923]
}, {
	"name": "商河县",
	"adcode": 370126,
	"center": [117.156369, 37.310544]
}, {
	"name": "市南区",
	"adcode": 370202,
	"center": [120.395966, 36.070892]
}, {
	"name": "市北区",
	"adcode": 370203,
	"center": [120.355026, 36.083819]
}, {
	"name": "黄岛区",
	"adcode": 370211,
	"center": [119.995518, 35.875138]
}, {
	"name": "崂山区",
	"adcode": 370212,
	"center": [120.467393, 36.102569]
}, {
	"name": "李沧区",
	"adcode": 370213,
	"center": [120.421236, 36.160023]
}, {
	"name": "城阳区",
	"adcode": 370214,
	"center": [120.389135, 36.306833]
}, {
	"name": "即墨区",
	"adcode": 370215,
	"center": [120.447352, 36.390847]
}, {
	"name": "胶州市",
	"adcode": 370281,
	"center": [120.006202, 36.285878]
}, {
	"name": "平度市",
	"adcode": 370283,
	"center": [119.959012, 36.788828]
}, {
	"name": "莱西市",
	"adcode": 370285,
	"center": [120.526226, 36.86509]
}, {
	"name": "淄川区",
	"adcode": 370302,
	"center": [117.967696, 36.647272]
}, {
	"name": "张店区",
	"adcode": 370303,
	"center": [118.053521, 36.807049]
}, {
	"name": "博山区",
	"adcode": 370304,
	"center": [117.85823, 36.497567]
}, {
	"name": "临淄区",
	"adcode": 370305,
	"center": [118.306018, 36.816657]
}, {
	"name": "周村区",
	"adcode": 370306,
	"center": [117.851036, 36.803699]
}, {
	"name": "桓台县",
	"adcode": 370321,
	"center": [118.101556, 36.959773]
}, {
	"name": "高青县",
	"adcode": 370322,
	"center": [117.829839, 37.169581]
}, {
	"name": "沂源县",
	"adcode": 370323,
	"center": [118.166161, 36.186282]
}, {
	"name": "市中区",
	"adcode": 370402,
	"center": [117.557281, 34.856651]
}, {
	"name": "薛城区",
	"adcode": 370403,
	"center": [117.265293, 34.79789]
}, {
	"name": "峄城区",
	"adcode": 370404,
	"center": [117.586316, 34.767713]
}, {
	"name": "台儿庄区",
	"adcode": 370405,
	"center": [117.734747, 34.564815]
}, {
	"name": "山亭区",
	"adcode": 370406,
	"center": [117.458968, 35.096077]
}, {
	"name": "滕州市",
	"adcode": 370481,
	"center": [117.162098, 35.088498]
}, {
	"name": "东营区",
	"adcode": 370502,
	"center": [118.507543, 37.461567]
}, {
	"name": "河口区",
	"adcode": 370503,
	"center": [118.529613, 37.886015]
}, {
	"name": "垦利区",
	"adcode": 370505,
	"center": [118.551314, 37.588679]
}, {
	"name": "利津县",
	"adcode": 370522,
	"center": [118.248854, 37.493365]
}, {
	"name": "广饶县",
	"adcode": 370523,
	"center": [118.407522, 37.05161]
}, {
	"name": "芝罘区",
	"adcode": 370602,
	"center": [121.385877, 37.540925]
}, {
	"name": "福山区",
	"adcode": 370611,
	"center": [121.264741, 37.496875]
}, {
	"name": "牟平区",
	"adcode": 370612,
	"center": [121.60151, 37.388356]
}, {
	"name": "莱山区",
	"adcode": 370613,
	"center": [121.448866, 37.473549]
}, {
	"name": "蓬莱区",
	"adcode": 370614,
	"center": [120.759074, 37.811045]
}, {
	"name": "龙口市",
	"adcode": 370681,
	"center": [120.528328, 37.648446]
}, {
	"name": "莱阳市",
	"adcode": 370682,
	"center": [120.711151, 36.977037]
}, {
	"name": "莱州市",
	"adcode": 370683,
	"center": [119.942135, 37.182725]
}, {
	"name": "招远市",
	"adcode": 370685,
	"center": [120.403142, 37.364919]
}, {
	"name": "栖霞市",
	"adcode": 370686,
	"center": [120.834097, 37.305854]
}, {
	"name": "海阳市",
	"adcode": 370687,
	"center": [121.168392, 36.780657]
}, {
	"name": "潍城区",
	"adcode": 370702,
	"center": [119.103784, 36.710062]
}, {
	"name": "寒亭区",
	"adcode": 370703,
	"center": [119.207866, 36.772103]
}, {
	"name": "坊子区",
	"adcode": 370704,
	"center": [119.166326, 36.654616]
}, {
	"name": "奎文区",
	"adcode": 370705,
	"center": [119.137357, 36.709494]
}, {
	"name": "临朐县",
	"adcode": 370724,
	"center": [118.539876, 36.516371]
}, {
	"name": "昌乐县",
	"adcode": 370725,
	"center": [118.839995, 36.703253]
}, {
	"name": "青州市",
	"adcode": 370781,
	"center": [118.484693, 36.697855]
}, {
	"name": "诸城市",
	"adcode": 370782,
	"center": [119.403182, 35.997093]
}, {
	"name": "寿光市",
	"adcode": 370783,
	"center": [118.736451, 36.874411]
}, {
	"name": "安丘市",
	"adcode": 370784,
	"center": [119.206886, 36.427417]
}, {
	"name": "高密市",
	"adcode": 370785,
	"center": [119.757033, 36.37754]
}, {
	"name": "昌邑市",
	"adcode": 370786,
	"center": [119.394502, 36.854937]
}, {
	"name": "任城区",
	"adcode": 370811,
	"center": [116.595261, 35.414828]
}, {
	"name": "兖州区",
	"adcode": 370812,
	"center": [116.828996, 35.556445]
}, {
	"name": "微山县",
	"adcode": 370826,
	"center": [117.12861, 34.809525]
}, {
	"name": "鱼台县",
	"adcode": 370827,
	"center": [116.650023, 34.997706]
}, {
	"name": "金乡县",
	"adcode": 370828,
	"center": [116.310364, 35.06977]
}, {
	"name": "嘉祥县",
	"adcode": 370829,
	"center": [116.342885, 35.398098]
}, {
	"name": "汶上县",
	"adcode": 370830,
	"center": [116.487146, 35.721746]
}, {
	"name": "泗水县",
	"adcode": 370831,
	"center": [117.273605, 35.653216]
}, {
	"name": "梁山县",
	"adcode": 370832,
	"center": [116.08963, 35.801843]
}, {
	"name": "曲阜市",
	"adcode": 370881,
	"center": [116.991885, 35.592788]
}, {
	"name": "邹城市",
	"adcode": 370883,
	"center": [116.96673, 35.405259]
}, {
	"name": "泰山区",
	"adcode": 370902,
	"center": [117.129984, 36.189313]
}, {
	"name": "岱岳区",
	"adcode": 370911,
	"center": [117.04353, 36.1841]
}, {
	"name": "宁阳县",
	"adcode": 370921,
	"center": [116.799297, 35.76754]
}, {
	"name": "东平县",
	"adcode": 370923,
	"center": [116.461052, 35.930467]
}, {
	"name": "新泰市",
	"adcode": 370982,
	"center": [117.766092, 35.910387]
}, {
	"name": "肥城市",
	"adcode": 370983,
	"center": [116.763703, 36.1856]
}, {
	"name": "环翠区",
	"adcode": 371002,
	"center": [122.116189, 37.510754]
}, {
	"name": "文登区",
	"adcode": 371003,
	"center": [122.057139, 37.196211]
}, {
	"name": "荣成市",
	"adcode": 371082,
	"center": [122.422896, 37.160134]
}, {
	"name": "乳山市",
	"adcode": 371083,
	"center": [121.536346, 36.919622]
}, {
	"name": "东港区",
	"adcode": 371102,
	"center": [119.457703, 35.426152]
}, {
	"name": "岚山区",
	"adcode": 371103,
	"center": [119.315844, 35.119794]
}, {
	"name": "五莲县",
	"adcode": 371121,
	"center": [119.206745, 35.751936]
}, {
	"name": "莒县",
	"adcode": 371122,
	"center": [118.832859, 35.588115]
}, {
	"name": "兰山区",
	"adcode": 371302,
	"center": [118.327667, 35.061631]
}, {
	"name": "罗庄区",
	"adcode": 371311,
	"center": [118.284795, 34.997204]
}, {
	"name": "河东区",
	"adcode": 371312,
	"center": [118.398296, 35.085004]
}, {
	"name": "沂南县",
	"adcode": 371321,
	"center": [118.455395, 35.547002]
}, {
	"name": "郯城县",
	"adcode": 371322,
	"center": [118.342963, 34.614741]
}, {
	"name": "沂水县",
	"adcode": 371323,
	"center": [118.634543, 35.787029]
}, {
	"name": "兰陵县",
	"adcode": 371324,
	"center": [118.049968, 34.855573]
}, {
	"name": "费县",
	"adcode": 371325,
	"center": [117.968869, 35.269174]
}, {
	"name": "平邑县",
	"adcode": 371326,
	"center": [117.631884, 35.511519]
}, {
	"name": "莒南县",
	"adcode": 371327,
	"center": [118.838322, 35.175911]
}, {
	"name": "蒙阴县",
	"adcode": 371328,
	"center": [117.943271, 35.712435]
}, {
	"name": "临沭县",
	"adcode": 371329,
	"center": [118.648379, 34.917062]
}, {
	"name": "德城区",
	"adcode": 371402,
	"center": [116.307076, 37.453923]
}, {
	"name": "陵城区",
	"adcode": 371403,
	"center": [116.574929, 37.332848]
}, {
	"name": "宁津县",
	"adcode": 371422,
	"center": [116.79372, 37.649619]
}, {
	"name": "庆云县",
	"adcode": 371423,
	"center": [117.390507, 37.777724]
}, {
	"name": "临邑县",
	"adcode": 371424,
	"center": [116.867028, 37.192044]
}, {
	"name": "齐河县",
	"adcode": 371425,
	"center": [116.758394, 36.795497]
}, {
	"name": "平原县",
	"adcode": 371426,
	"center": [116.433904, 37.164465]
}, {
	"name": "夏津县",
	"adcode": 371427,
	"center": [116.003816, 36.950501]
}, {
	"name": "武城县",
	"adcode": 371428,
	"center": [116.078627, 37.209527]
}, {
	"name": "乐陵市",
	"adcode": 371481,
	"center": [117.216657, 37.729115]
}, {
	"name": "禹城市",
	"adcode": 371482,
	"center": [116.642554, 36.934485]
}, {
	"name": "东昌府区",
	"adcode": 371502,
	"center": [115.980023, 36.45606]
}, {
	"name": "茌平区",
	"adcode": 371503,
	"center": [116.25335, 36.591934]
}, {
	"name": "阳谷县",
	"adcode": 371521,
	"center": [115.784287, 36.113708]
}, {
	"name": "莘县",
	"adcode": 371522,
	"center": [115.667291, 36.237597]
}, {
	"name": "东阿县",
	"adcode": 371524,
	"center": [116.248855, 36.336004]
}, {
	"name": "冠县",
	"adcode": 371525,
	"center": [115.444808, 36.483753]
}, {
	"name": "高唐县",
	"adcode": 371526,
	"center": [116.229662, 36.859755]
}, {
	"name": "临清市",
	"adcode": 371581,
	"center": [115.713462, 36.842598]
}, {
	"name": "滨城区",
	"adcode": 371602,
	"center": [118.020149, 37.384842]
}, {
	"name": "沾化区",
	"adcode": 371603,
	"center": [118.129902, 37.698456]
}, {
	"name": "惠民县",
	"adcode": 371621,
	"center": [117.508941, 37.483876]
}, {
	"name": "阳信县",
	"adcode": 371622,
	"center": [117.581326, 37.640492]
}, {
	"name": "无棣县",
	"adcode": 371623,
	"center": [117.616325, 37.740848]
}, {
	"name": "博兴县",
	"adcode": 371625,
	"center": [118.123096, 37.147002]
}, {
	"name": "邹平市",
	"adcode": 371681,
	"center": [117.736807, 36.87803]
}, {
	"name": "牡丹区",
	"adcode": 371702,
	"center": [115.470946, 35.24311]
}, {
	"name": "定陶区",
	"adcode": 371703,
	"center": [115.569601, 35.072701]
}, {
	"name": "曹县",
	"adcode": 371721,
	"center": [115.549482, 34.823253]
}, {
	"name": "单县",
	"adcode": 371722,
	"center": [116.08262, 34.790851]
}, {
	"name": "成武县",
	"adcode": 371723,
	"center": [115.897349, 34.947366]
}, {
	"name": "巨野县",
	"adcode": 371724,
	"center": [116.089341, 35.390999]
}, {
	"name": "郓城县",
	"adcode": 371725,
	"center": [115.93885, 35.594773]
}, {
	"name": "鄄城县",
	"adcode": 371726,
	"center": [115.51434, 35.560257]
}, {
	"name": "东明县",
	"adcode": 371728,
	"center": [115.098412, 35.289637]
}, {
	"name": "中原区",
	"adcode": 410102,
	"center": [113.611576, 34.748286]
}, {
	"name": "二七区",
	"adcode": 410103,
	"center": [113.645422, 34.730936]
}, {
	"name": "管城回族区",
	"adcode": 410104,
	"center": [113.685313, 34.746453]
}, {
	"name": "金水区",
	"adcode": 410105,
	"center": [113.686037, 34.775838]
}, {
	"name": "上街区",
	"adcode": 410106,
	"center": [113.298282, 34.808689]
}, {
	"name": "惠济区",
	"adcode": 410108,
	"center": [113.61836, 34.828591]
}, {
	"name": "中牟县",
	"adcode": 410122,
	"center": [114.022521, 34.721976]
}, {
	"name": "巩义市",
	"adcode": 410181,
	"center": [112.98283, 34.75218]
}, {
	"name": "荥阳市",
	"adcode": 410182,
	"center": [113.391523, 34.789077]
}, {
	"name": "新密市",
	"adcode": 410183,
	"center": [113.380616, 34.537846]
}, {
	"name": "新郑市",
	"adcode": 410184,
	"center": [113.73967, 34.394219]
}, {
	"name": "登封市",
	"adcode": 410185,
	"center": [113.037768, 34.459939]
}, {
	"name": "龙亭区",
	"adcode": 410202,
	"center": [114.353348, 34.799833]
}, {
	"name": "顺河回族区",
	"adcode": 410203,
	"center": [114.364875, 34.800459]
}, {
	"name": "鼓楼区",
	"adcode": 410204,
	"center": [114.3485, 34.792383]
}, {
	"name": "禹王台区",
	"adcode": 410205,
	"center": [114.350246, 34.779727]
}, {
	"name": "祥符区",
	"adcode": 410212,
	"center": [114.437622, 34.756476]
}, {
	"name": "杞县",
	"adcode": 410221,
	"center": [114.770472, 34.554585]
}, {
	"name": "通许县",
	"adcode": 410222,
	"center": [114.467734, 34.477302]
}, {
	"name": "尉氏县",
	"adcode": 410223,
	"center": [114.193927, 34.412256]
}, {
	"name": "兰考县",
	"adcode": 410225,
	"center": [114.820572, 34.829899]
}, {
	"name": "老城区",
	"adcode": 410302,
	"center": [112.477298, 34.682945]
}, {
	"name": "西工区",
	"adcode": 410303,
	"center": [112.443232, 34.667847]
}, {
	"name": "瀍河回族区",
	"adcode": 410304,
	"center": [112.491625, 34.684738]
}, {
	"name": "涧西区",
	"adcode": 410305,
	"center": [112.399243, 34.654251]
}, {
	"name": "孟津区",
	"adcode": 410306,
	"center": [112.443892, 34.826485]
}, {
	"name": "洛龙区",
	"adcode": 410311,
	"center": [112.456634, 34.618557]
}, {
	"name": "新安县",
	"adcode": 410323,
	"center": [112.141403, 34.728679]
}, {
	"name": "栾川县",
	"adcode": 410324,
	"center": [111.618386, 33.783195]
}, {
	"name": "嵩县",
	"adcode": 410325,
	"center": [112.087765, 34.131563]
}, {
	"name": "汝阳县",
	"adcode": 410326,
	"center": [112.473789, 34.15323]
}, {
	"name": "宜阳县",
	"adcode": 410327,
	"center": [112.179989, 34.516478]
}, {
	"name": "洛宁县",
	"adcode": 410328,
	"center": [111.655399, 34.387179]
}, {
	"name": "伊川县",
	"adcode": 410329,
	"center": [112.429384, 34.423416]
}, {
	"name": "偃师区",
	"adcode": 410381,
	"center": [112.787739, 34.723042]
}, {
	"name": "新华区",
	"adcode": 410402,
	"center": [113.299061, 33.737579]
}, {
	"name": "卫东区",
	"adcode": 410403,
	"center": [113.310327, 33.739285]
}, {
	"name": "石龙区",
	"adcode": 410404,
	"center": [112.889885, 33.901538]
}, {
	"name": "湛河区",
	"adcode": 410411,
	"center": [113.320873, 33.725681]
}, {
	"name": "宝丰县",
	"adcode": 410421,
	"center": [113.066812, 33.866359]
}, {
	"name": "叶县",
	"adcode": 410422,
	"center": [113.358298, 33.621252]
}, {
	"name": "鲁山县",
	"adcode": 410423,
	"center": [112.906703, 33.740325]
}, {
	"name": "郏县",
	"adcode": 410425,
	"center": [113.220451, 33.971993]
}, {
	"name": "舞钢市",
	"adcode": 410481,
	"center": [113.52625, 33.302082]
}, {
	"name": "汝州市",
	"adcode": 410482,
	"center": [112.845336, 34.167408]
}, {
	"name": "文峰区",
	"adcode": 410502,
	"center": [114.352562, 36.098101]
}, {
	"name": "北关区",
	"adcode": 410503,
	"center": [114.352646, 36.10978]
}, {
	"name": "殷都区",
	"adcode": 410505,
	"center": [114.300098, 36.108974]
}, {
	"name": "龙安区",
	"adcode": 410506,
	"center": [114.323522, 36.095568]
}, {
	"name": "安阳县",
	"adcode": 410522,
	"center": [114.130207, 36.130585]
}, {
	"name": "汤阴县",
	"adcode": 410523,
	"center": [114.362357, 35.922349]
}, {
	"name": "滑县",
	"adcode": 410526,
	"center": [114.524, 35.574628]
}, {
	"name": "内黄县",
	"adcode": 410527,
	"center": [114.904582, 35.953702]
}, {
	"name": "林州市",
	"adcode": 410581,
	"center": [113.823767, 36.063403]
}, {
	"name": "鹤山区",
	"adcode": 410602,
	"center": [114.166551, 35.936128]
}, {
	"name": "山城区",
	"adcode": 410603,
	"center": [114.184202, 35.896058]
}, {
	"name": "淇滨区",
	"adcode": 410611,
	"center": [114.293917, 35.748382]
}, {
	"name": "浚县",
	"adcode": 410621,
	"center": [114.550162, 35.671282]
}, {
	"name": "淇县",
	"adcode": 410622,
	"center": [114.200379, 35.609478]
}, {
	"name": "红旗区",
	"adcode": 410702,
	"center": [113.878158, 35.302684]
}, {
	"name": "卫滨区",
	"adcode": 410703,
	"center": [113.866065, 35.304905]
}, {
	"name": "凤泉区",
	"adcode": 410704,
	"center": [113.906712, 35.379855]
}, {
	"name": "牧野区",
	"adcode": 410711,
	"center": [113.89716, 35.312974]
}, {
	"name": "新乡县",
	"adcode": 410721,
	"center": [113.806186, 35.190021]
}, {
	"name": "获嘉县",
	"adcode": 410724,
	"center": [113.657249, 35.261685]
}, {
	"name": "原阳县",
	"adcode": 410725,
	"center": [113.965966, 35.054001]
}, {
	"name": "延津县",
	"adcode": 410726,
	"center": [114.200982, 35.149515]
}, {
	"name": "封丘县",
	"adcode": 410727,
	"center": [114.423405, 35.04057]
}, {
	"name": "卫辉市",
	"adcode": 410781,
	"center": [114.065855, 35.404295]
}, {
	"name": "辉县市",
	"adcode": 410782,
	"center": [113.802518, 35.461318]
}, {
	"name": "长垣市",
	"adcode": 410783,
	"center": [114.673807, 35.19615]
}, {
	"name": "解放区",
	"adcode": 410802,
	"center": [113.226126, 35.241353]
}, {
	"name": "中站区",
	"adcode": 410803,
	"center": [113.175485, 35.236145]
}, {
	"name": "马村区",
	"adcode": 410804,
	"center": [113.321703, 35.265453]
}, {
	"name": "山阳区",
	"adcode": 410811,
	"center": [113.26766, 35.21476]
}, {
	"name": "修武县",
	"adcode": 410821,
	"center": [113.447465, 35.229923]
}, {
	"name": "博爱县",
	"adcode": 410822,
	"center": [113.069313, 35.170351]
}, {
	"name": "武陟县",
	"adcode": 410823,
	"center": [113.408334, 35.09885]
}, {
	"name": "温县",
	"adcode": 410825,
	"center": [113.079118, 34.941233]
}, {
	"name": "沁阳市",
	"adcode": 410882,
	"center": [112.934538, 35.08901]
}, {
	"name": "孟州市",
	"adcode": 410883,
	"center": [112.78708, 34.90963]
}, {
	"name": "华龙区",
	"adcode": 410902,
	"center": [115.03184, 35.760473]
}, {
	"name": "清丰县",
	"adcode": 410922,
	"center": [115.107287, 35.902413]
}, {
	"name": "南乐县",
	"adcode": 410923,
	"center": [115.204336, 36.075204]
}, {
	"name": "范县",
	"adcode": 410926,
	"center": [115.504212, 35.851977]
}, {
	"name": "台前县",
	"adcode": 410927,
	"center": [115.855681, 35.996474]
}, {
	"name": "濮阳县",
	"adcode": 410928,
	"center": [115.023844, 35.710349]
}, {
	"name": "魏都区",
	"adcode": 411002,
	"center": [113.828307, 34.02711]
}, {
	"name": "建安区",
	"adcode": 411003,
	"center": [113.842898, 34.005018]
}, {
	"name": "鄢陵县",
	"adcode": 411024,
	"center": [114.188507, 34.100502]
}, {
	"name": "襄城县",
	"adcode": 411025,
	"center": [113.493166, 33.855943]
}, {
	"name": "禹州市",
	"adcode": 411081,
	"center": [113.471316, 34.154403]
}, {
	"name": "长葛市",
	"adcode": 411082,
	"center": [113.768912, 34.219257]
}, {
	"name": "源汇区",
	"adcode": 411102,
	"center": [114.017948, 33.565441]
}, {
	"name": "郾城区",
	"adcode": 411103,
	"center": [114.016813, 33.588897]
}, {
	"name": "召陵区",
	"adcode": 411104,
	"center": [114.051686, 33.567555]
}, {
	"name": "舞阳县",
	"adcode": 411121,
	"center": [113.610565, 33.436278]
}, {
	"name": "临颍县",
	"adcode": 411122,
	"center": [113.938891, 33.80609]
}, {
	"name": "湖滨区",
	"adcode": 411202,
	"center": [111.19487, 34.77812]
}, {
	"name": "陕州区",
	"adcode": 411203,
	"center": [111.103851, 34.720244]
}, {
	"name": "渑池县",
	"adcode": 411221,
	"center": [111.762992, 34.763487]
}, {
	"name": "卢氏县",
	"adcode": 411224,
	"center": [111.052649, 34.053995]
}, {
	"name": "义马市",
	"adcode": 411281,
	"center": [111.869417, 34.746868]
}, {
	"name": "灵宝市",
	"adcode": 411282,
	"center": [110.88577, 34.521264]
}, {
	"name": "宛城区",
	"adcode": 411302,
	"center": [112.544591, 32.994857]
}, {
	"name": "卧龙区",
	"adcode": 411303,
	"center": [112.528789, 32.989877]
}, {
	"name": "南召县",
	"adcode": 411321,
	"center": [112.435583, 33.488617]
}, {
	"name": "方城县",
	"adcode": 411322,
	"center": [113.010933, 33.255138]
}, {
	"name": "西峡县",
	"adcode": 411323,
	"center": [111.485772, 33.302981]
}, {
	"name": "镇平县",
	"adcode": 411324,
	"center": [112.232722, 33.036651]
}, {
	"name": "内乡县",
	"adcode": 411325,
	"center": [111.843801, 33.046358]
}, {
	"name": "淅川县",
	"adcode": 411326,
	"center": [111.489026, 33.136106]
}, {
	"name": "社旗县",
	"adcode": 411327,
	"center": [112.938279, 33.056126]
}, {
	"name": "唐河县",
	"adcode": 411328,
	"center": [112.838492, 32.687892]
}, {
	"name": "新野县",
	"adcode": 411329,
	"center": [112.365624, 32.524006]
}, {
	"name": "桐柏县",
	"adcode": 411330,
	"center": [113.406059, 32.367153]
}, {
	"name": "邓州市",
	"adcode": 411381,
	"center": [112.092716, 32.681642]
}, {
	"name": "梁园区",
	"adcode": 411402,
	"center": [115.65459, 34.436553]
}, {
	"name": "睢阳区",
	"adcode": 411403,
	"center": [115.653813, 34.390536]
}, {
	"name": "民权县",
	"adcode": 411421,
	"center": [115.148146, 34.648455]
}, {
	"name": "睢县",
	"adcode": 411422,
	"center": [115.070109, 34.428433]
}, {
	"name": "宁陵县",
	"adcode": 411423,
	"center": [115.320055, 34.449299]
}, {
	"name": "柘城县",
	"adcode": 411424,
	"center": [115.307433, 34.075277]
}, {
	"name": "虞城县",
	"adcode": 411425,
	"center": [115.863811, 34.399634]
}, {
	"name": "夏邑县",
	"adcode": 411426,
	"center": [116.13989, 34.240894]
}, {
	"name": "永城市",
	"adcode": 411481,
	"center": [116.449672, 33.931318]
}, {
	"name": "浉河区",
	"adcode": 411502,
	"center": [114.075031, 32.123274]
}, {
	"name": "平桥区",
	"adcode": 411503,
	"center": [114.126027, 32.098395]
}, {
	"name": "罗山县",
	"adcode": 411521,
	"center": [114.533414, 32.203206]
}, {
	"name": "光山县",
	"adcode": 411522,
	"center": [114.903577, 32.010398]
}, {
	"name": "新县",
	"adcode": 411523,
	"center": [114.87705, 31.63515]
}, {
	"name": "商城县",
	"adcode": 411524,
	"center": [115.406297, 31.799982]
}, {
	"name": "固始县",
	"adcode": 411525,
	"center": [115.667328, 32.183074]
}, {
	"name": "潢川县",
	"adcode": 411526,
	"center": [115.050123, 32.134024]
}, {
	"name": "淮滨县",
	"adcode": 411527,
	"center": [115.415451, 32.452639]
}, {
	"name": "息县",
	"adcode": 411528,
	"center": [114.740713, 32.344744]
}, {
	"name": "川汇区",
	"adcode": 411602,
	"center": [114.652136, 33.614836]
}, {
	"name": "淮阳区",
	"adcode": 411603,
	"center": [114.870166, 33.732547]
}, {
	"name": "扶沟县",
	"adcode": 411621,
	"center": [114.392008, 34.054061]
}, {
	"name": "西华县",
	"adcode": 411622,
	"center": [114.530067, 33.784378]
}, {
	"name": "商水县",
	"adcode": 411623,
	"center": [114.60927, 33.543845]
}, {
	"name": "沈丘县",
	"adcode": 411624,
	"center": [115.078375, 33.395514]
}, {
	"name": "郸城县",
	"adcode": 411625,
	"center": [115.189, 33.643852]
}, {
	"name": "太康县",
	"adcode": 411627,
	"center": [114.853834, 34.065312]
}, {
	"name": "鹿邑县",
	"adcode": 411628,
	"center": [115.486386, 33.861067]
}, {
	"name": "项城市",
	"adcode": 411681,
	"center": [114.899521, 33.443085]
}, {
	"name": "驿城区",
	"adcode": 411702,
	"center": [114.029149, 32.977559]
}, {
	"name": "西平县",
	"adcode": 411721,
	"center": [114.026864, 33.382315]
}, {
	"name": "上蔡县",
	"adcode": 411722,
	"center": [114.266892, 33.264719]
}, {
	"name": "平舆县",
	"adcode": 411723,
	"center": [114.637105, 32.955626]
}, {
	"name": "正阳县",
	"adcode": 411724,
	"center": [114.38948, 32.601826]
}, {
	"name": "确山县",
	"adcode": 411725,
	"center": [114.026679, 32.801538]
}, {
	"name": "泌阳县",
	"adcode": 411726,
	"center": [113.32605, 32.725129]
}, {
	"name": "汝南县",
	"adcode": 411727,
	"center": [114.359495, 33.004535]
}, {
	"name": "遂平县",
	"adcode": 411728,
	"center": [114.00371, 33.14698]
}, {
	"name": "新蔡县",
	"adcode": 411729,
	"center": [114.975246, 32.749948]
}, {
	"name": "江岸区",
	"adcode": 420102,
	"center": [114.30304, 30.594911]
}, {
	"name": "江汉区",
	"adcode": 420103,
	"center": [114.283109, 30.578771]
}, {
	"name": "硚口区",
	"adcode": 420104,
	"center": [114.264568, 30.57061]
}, {
	"name": "汉阳区",
	"adcode": 420105,
	"center": [114.265807, 30.549326]
}, {
	"name": "武昌区",
	"adcode": 420106,
	"center": [114.307344, 30.546536]
}, {
	"name": "青山区",
	"adcode": 420107,
	"center": [114.39707, 30.634215]
}, {
	"name": "洪山区",
	"adcode": 420111,
	"center": [114.400718, 30.504259]
}, {
	"name": "东西湖区",
	"adcode": 420112,
	"center": [114.142483, 30.622467]
}, {
	"name": "汉南区",
	"adcode": 420113,
	"center": [114.08124, 30.309637]
}, {
	"name": "蔡甸区",
	"adcode": 420114,
	"center": [114.029341, 30.582186]
}, {
	"name": "江夏区",
	"adcode": 420115,
	"center": [114.313961, 30.349045]
}, {
	"name": "黄陂区",
	"adcode": 420116,
	"center": [114.374025, 30.874155]
}, {
	"name": "新洲区",
	"adcode": 420117,
	"center": [114.802108, 30.842149]
}, {
	"name": "黄石港区",
	"adcode": 420202,
	"center": [115.090164, 30.212086]
}, {
	"name": "西塞山区",
	"adcode": 420203,
	"center": [115.093354, 30.205365]
}, {
	"name": "下陆区",
	"adcode": 420204,
	"center": [114.975755, 30.177845]
}, {
	"name": "铁山区",
	"adcode": 420205,
	"center": [114.901366, 30.20601]
}, {
	"name": "阳新县",
	"adcode": 420222,
	"center": [115.212883, 29.841572]
}, {
	"name": "大冶市",
	"adcode": 420281,
	"center": [114.974842, 30.098804]
}, {
	"name": "茅箭区",
	"adcode": 420302,
	"center": [110.78621, 32.644463]
}, {
	"name": "张湾区",
	"adcode": 420303,
	"center": [110.772365, 32.652516]
}, {
	"name": "郧阳区",
	"adcode": 420304,
	"center": [110.812099, 32.838267]
}, {
	"name": "郧西县",
	"adcode": 420322,
	"center": [110.426472, 32.991457]
}, {
	"name": "竹山县",
	"adcode": 420323,
	"center": [110.2296, 32.22586]
}, {
	"name": "竹溪县",
	"adcode": 420324,
	"center": [109.717196, 32.315342]
}, {
	"name": "房县",
	"adcode": 420325,
	"center": [110.741966, 32.055002]
}, {
	"name": "丹江口市",
	"adcode": 420381,
	"center": [111.513793, 32.538839]
}, {
	"name": "西陵区",
	"adcode": 420502,
	"center": [111.295468, 30.702476]
}, {
	"name": "伍家岗区",
	"adcode": 420503,
	"center": [111.307215, 30.679053]
}, {
	"name": "点军区",
	"adcode": 420504,
	"center": [111.268163, 30.692322]
}, {
	"name": "猇亭区",
	"adcode": 420505,
	"center": [111.427642, 30.530744]
}, {
	"name": "夷陵区",
	"adcode": 420506,
	"center": [111.326747, 30.770199]
}, {
	"name": "远安县",
	"adcode": 420525,
	"center": [111.64331, 31.059626]
}, {
	"name": "兴山县",
	"adcode": 420526,
	"center": [110.754499, 31.34795]
}, {
	"name": "秭归县",
	"adcode": 420527,
	"center": [110.976785, 30.823908]
}, {
	"name": "长阳土家族自治县",
	"adcode": 420528,
	"center": [111.198475, 30.466534]
}, {
	"name": "五峰土家族自治县",
	"adcode": 420529,
	"center": [110.674938, 30.199252]
}, {
	"name": "宜都市",
	"adcode": 420581,
	"center": [111.454367, 30.387234]
}, {
	"name": "当阳市",
	"adcode": 420582,
	"center": [111.793419, 30.824492]
}, {
	"name": "枝江市",
	"adcode": 420583,
	"center": [111.751799, 30.425364]
}, {
	"name": "襄城区",
	"adcode": 420602,
	"center": [112.150327, 32.015088]
}, {
	"name": "樊城区",
	"adcode": 420606,
	"center": [112.13957, 32.058589]
}, {
	"name": "襄州区",
	"adcode": 420607,
	"center": [112.197378, 32.085517]
}, {
	"name": "南漳县",
	"adcode": 420624,
	"center": [111.844424, 31.77692]
}, {
	"name": "谷城县",
	"adcode": 420625,
	"center": [111.640147, 32.262676]
}, {
	"name": "保康县",
	"adcode": 420626,
	"center": [111.262235, 31.873507]
}, {
	"name": "老河口市",
	"adcode": 420682,
	"center": [111.675732, 32.385438]
}, {
	"name": "枣阳市",
	"adcode": 420683,
	"center": [112.765268, 32.123083]
}, {
	"name": "宜城市",
	"adcode": 420684,
	"center": [112.261441, 31.709203]
}, {
	"name": "梁子湖区",
	"adcode": 420702,
	"center": [114.681967, 30.098191]
}, {
	"name": "华容区",
	"adcode": 420703,
	"center": [114.74148, 30.534468]
}, {
	"name": "鄂城区",
	"adcode": 420704,
	"center": [114.890012, 30.39669]
}, {
	"name": "东宝区",
	"adcode": 420802,
	"center": [112.204804, 31.033461]
}, {
	"name": "掇刀区",
	"adcode": 420804,
	"center": [112.198413, 30.980798]
}, {
	"name": "沙洋县",
	"adcode": 420822,
	"center": [112.595218, 30.70359]
}, {
	"name": "钟祥市",
	"adcode": 420881,
	"center": [112.587267, 31.165573]
}, {
	"name": "京山市",
	"adcode": 420882,
	"center": [113.114595, 31.022457]
}, {
	"name": "孝南区",
	"adcode": 420902,
	"center": [113.925849, 30.925966]
}, {
	"name": "孝昌县",
	"adcode": 420921,
	"center": [113.988964, 31.251618]
}, {
	"name": "大悟县",
	"adcode": 420922,
	"center": [114.126249, 31.565483]
}, {
	"name": "云梦县",
	"adcode": 420923,
	"center": [113.750616, 31.021691]
}, {
	"name": "应城市",
	"adcode": 420981,
	"center": [113.573842, 30.939038]
}, {
	"name": "安陆市",
	"adcode": 420982,
	"center": [113.690401, 31.26174]
}, {
	"name": "汉川市",
	"adcode": 420984,
	"center": [113.835301, 30.652165]
}, {
	"name": "沙市区",
	"adcode": 421002,
	"center": [112.257433, 30.315895]
}, {
	"name": "荆州区",
	"adcode": 421003,
	"center": [112.195354, 30.350674]
}, {
	"name": "公安县",
	"adcode": 421022,
	"center": [112.230179, 30.059065]
}, {
	"name": "监利市",
	"adcode": 421023,
	"center": [112.904344, 29.820079]
}, {
	"name": "江陵县",
	"adcode": 421024,
	"center": [112.41735, 30.033919]
}, {
	"name": "石首市",
	"adcode": 421081,
	"center": [112.40887, 29.716437]
}, {
	"name": "洪湖市",
	"adcode": 421083,
	"center": [113.470304, 29.81297]
}, {
	"name": "松滋市",
	"adcode": 421087,
	"center": [111.77818, 30.176037]
}, {
	"name": "黄州区",
	"adcode": 421102,
	"center": [114.878934, 30.447435]
}, {
	"name": "团风县",
	"adcode": 421121,
	"center": [114.872029, 30.63569]
}, {
	"name": "红安县",
	"adcode": 421122,
	"center": [114.615095, 31.284777]
}, {
	"name": "罗田县",
	"adcode": 421123,
	"center": [115.398984, 30.781679]
}, {
	"name": "英山县",
	"adcode": 421124,
	"center": [115.67753, 30.735794]
}, {
	"name": "浠水县",
	"adcode": 421125,
	"center": [115.26344, 30.454837]
}, {
	"name": "蕲春县",
	"adcode": 421126,
	"center": [115.433964, 30.234927]
}, {
	"name": "黄梅县",
	"adcode": 421127,
	"center": [115.942548, 30.075113]
}, {
	"name": "麻城市",
	"adcode": 421181,
	"center": [115.02541, 31.177906]
}, {
	"name": "武穴市",
	"adcode": 421182,
	"center": [115.56242, 29.849342]
}, {
	"name": "咸安区",
	"adcode": 421202,
	"center": [114.333894, 29.824716]
}, {
	"name": "嘉鱼县",
	"adcode": 421221,
	"center": [113.921547, 29.973363]
}, {
	"name": "通城县",
	"adcode": 421222,
	"center": [113.814131, 29.246076]
}, {
	"name": "崇阳县",
	"adcode": 421223,
	"center": [114.049958, 29.54101]
}, {
	"name": "通山县",
	"adcode": 421224,
	"center": [114.493163, 29.604455]
}, {
	"name": "赤壁市",
	"adcode": 421281,
	"center": [113.88366, 29.716879]
}, {
	"name": "曾都区",
	"adcode": 421303,
	"center": [113.374519, 31.717521]
}, {
	"name": "随县",
	"adcode": 421321,
	"center": [113.301384, 31.854246]
}, {
	"name": "广水市",
	"adcode": 421381,
	"center": [113.826601, 31.617731]
}, {
	"name": "恩施市",
	"adcode": 422801,
	"center": [109.486761, 30.282406]
}, {
	"name": "利川市",
	"adcode": 422802,
	"center": [108.943491, 30.294247]
}, {
	"name": "建始县",
	"adcode": 422822,
	"center": [109.723822, 30.601632]
}, {
	"name": "巴东县",
	"adcode": 422823,
	"center": [110.336665, 31.041403]
}, {
	"name": "宣恩县",
	"adcode": 422825,
	"center": [109.482819, 29.98867]
}, {
	"name": "咸丰县",
	"adcode": 422826,
	"center": [109.15041, 29.678967]
}, {
	"name": "来凤县",
	"adcode": 422827,
	"center": [109.408328, 29.506945]
}, {
	"name": "鹤峰县",
	"adcode": 422828,
	"center": [110.033699, 29.887298]
}, {
	"name": "芙蓉区",
	"adcode": 430102,
	"center": [112.988094, 28.193106]
}, {
	"name": "天心区",
	"adcode": 430103,
	"center": [112.97307, 28.192375]
}, {
	"name": "岳麓区",
	"adcode": 430104,
	"center": [112.911591, 28.213044]
}, {
	"name": "开福区",
	"adcode": 430105,
	"center": [112.985525, 28.201336]
}, {
	"name": "雨花区",
	"adcode": 430111,
	"center": [113.016337, 28.109937]
}, {
	"name": "望城区",
	"adcode": 430112,
	"center": [112.819549, 28.347458]
}, {
	"name": "长沙县",
	"adcode": 430121,
	"center": [113.080098, 28.237888]
}, {
	"name": "浏阳市",
	"adcode": 430181,
	"center": [113.633301, 28.141112]
}, {
	"name": "宁乡市",
	"adcode": 430182,
	"center": [112.553182, 28.253928]
}, {
	"name": "荷塘区",
	"adcode": 430202,
	"center": [113.162548, 27.833036]
}, {
	"name": "芦淞区",
	"adcode": 430203,
	"center": [113.155169, 27.827246]
}, {
	"name": "石峰区",
	"adcode": 430204,
	"center": [113.11295, 27.871945]
}, {
	"name": "天元区",
	"adcode": 430211,
	"center": [113.136252, 27.826909]
}, {
	"name": "渌口区",
	"adcode": 430212,
	"center": [113.146175, 27.705844]
}, {
	"name": "攸县",
	"adcode": 430223,
	"center": [113.345774, 27.000071]
}, {
	"name": "茶陵县",
	"adcode": 430224,
	"center": [113.546509, 26.789534]
}, {
	"name": "炎陵县",
	"adcode": 430225,
	"center": [113.776884, 26.489459]
}, {
	"name": "醴陵市",
	"adcode": 430281,
	"center": [113.507157, 27.657873]
}, {
	"name": "雨湖区",
	"adcode": 430302,
	"center": [112.907427, 27.86077]
}, {
	"name": "岳塘区",
	"adcode": 430304,
	"center": [112.927707, 27.828854]
}, {
	"name": "湘潭县",
	"adcode": 430321,
	"center": [112.952829, 27.778601]
}, {
	"name": "湘乡市",
	"adcode": 430381,
	"center": [112.525217, 27.734918]
}, {
	"name": "韶山市",
	"adcode": 430382,
	"center": [112.52848, 27.922682]
}, {
	"name": "珠晖区",
	"adcode": 430405,
	"center": [112.626324, 26.891063]
}, {
	"name": "雁峰区",
	"adcode": 430406,
	"center": [112.612241, 26.893694]
}, {
	"name": "石鼓区",
	"adcode": 430407,
	"center": [112.607635, 26.903908]
}, {
	"name": "蒸湘区",
	"adcode": 430408,
	"center": [112.570608, 26.89087]
}, {
	"name": "南岳区",
	"adcode": 430412,
	"center": [112.734147, 27.240536]
}, {
	"name": "衡阳县",
	"adcode": 430421,
	"center": [112.379643, 26.962388]
}, {
	"name": "衡南县",
	"adcode": 430422,
	"center": [112.677459, 26.739973]
}, {
	"name": "衡山县",
	"adcode": 430423,
	"center": [112.86971, 27.234808]
}, {
	"name": "衡东县",
	"adcode": 430424,
	"center": [112.950412, 27.083531]
}, {
	"name": "祁东县",
	"adcode": 430426,
	"center": [112.111192, 26.787109]
}, {
	"name": "耒阳市",
	"adcode": 430481,
	"center": [112.847215, 26.414162]
}, {
	"name": "常宁市",
	"adcode": 430482,
	"center": [112.396821, 26.406773]
}, {
	"name": "双清区",
	"adcode": 430502,
	"center": [111.479756, 27.240001]
}, {
	"name": "大祥区",
	"adcode": 430503,
	"center": [111.462968, 27.233593]
}, {
	"name": "北塔区",
	"adcode": 430511,
	"center": [111.452315, 27.245688]
}, {
	"name": "新邵县",
	"adcode": 430522,
	"center": [111.459762, 27.311429]
}, {
	"name": "邵阳县",
	"adcode": 430523,
	"center": [111.2757, 26.989713]
}, {
	"name": "隆回县",
	"adcode": 430524,
	"center": [111.038785, 27.116002]
}, {
	"name": "洞口县",
	"adcode": 430525,
	"center": [110.579212, 27.062286]
}, {
	"name": "绥宁县",
	"adcode": 430527,
	"center": [110.155075, 26.580622]
}, {
	"name": "新宁县",
	"adcode": 430528,
	"center": [110.859115, 26.438912]
}, {
	"name": "城步苗族自治县",
	"adcode": 430529,
	"center": [110.313226, 26.363575]
}, {
	"name": "武冈市",
	"adcode": 430581,
	"center": [110.636804, 26.732086]
}, {
	"name": "邵东市",
	"adcode": 430582,
	"center": [111.743168, 27.257273]
}, {
	"name": "岳阳楼区",
	"adcode": 430602,
	"center": [113.120751, 29.366784]
}, {
	"name": "云溪区",
	"adcode": 430603,
	"center": [113.27387, 29.473395]
}, {
	"name": "君山区",
	"adcode": 430611,
	"center": [113.004082, 29.438062]
}, {
	"name": "岳阳县",
	"adcode": 430621,
	"center": [113.116073, 29.144843]
}, {
	"name": "华容县",
	"adcode": 430623,
	"center": [112.559369, 29.524107]
}, {
	"name": "湘阴县",
	"adcode": 430624,
	"center": [112.889748, 28.677498]
}, {
	"name": "平江县",
	"adcode": 430626,
	"center": [113.593751, 28.701523]
}, {
	"name": "汨罗市",
	"adcode": 430681,
	"center": [113.079419, 28.803149]
}, {
	"name": "临湘市",
	"adcode": 430682,
	"center": [113.450809, 29.471594]
}, {
	"name": "武陵区",
	"adcode": 430702,
	"center": [111.690718, 29.040477]
}, {
	"name": "鼎城区",
	"adcode": 430703,
	"center": [111.685327, 29.014426]
}, {
	"name": "安乡县",
	"adcode": 430721,
	"center": [112.172289, 29.414483]
}, {
	"name": "汉寿县",
	"adcode": 430722,
	"center": [111.968506, 28.907319]
}, {
	"name": "澧县",
	"adcode": 430723,
	"center": [111.761682, 29.64264]
}, {
	"name": "临澧县",
	"adcode": 430724,
	"center": [111.645602, 29.443217]
}, {
	"name": "桃源县",
	"adcode": 430725,
	"center": [111.484503, 28.902734]
}, {
	"name": "石门县",
	"adcode": 430726,
	"center": [111.379087, 29.584703]
}, {
	"name": "津市市",
	"adcode": 430781,
	"center": [111.879609, 29.630867]
}, {
	"name": "永定区",
	"adcode": 430802,
	"center": [110.484559, 29.125961]
}, {
	"name": "武陵源区",
	"adcode": 430811,
	"center": [110.54758, 29.347827]
}, {
	"name": "慈利县",
	"adcode": 430821,
	"center": [111.132702, 29.423876]
}, {
	"name": "桑植县",
	"adcode": 430822,
	"center": [110.164039, 29.399939]
}, {
	"name": "资阳区",
	"adcode": 430902,
	"center": [112.33084, 28.592771]
}, {
	"name": "赫山区",
	"adcode": 430903,
	"center": [112.360946, 28.568327]
}, {
	"name": "南县",
	"adcode": 430921,
	"center": [112.410399, 29.372181]
}, {
	"name": "桃江县",
	"adcode": 430922,
	"center": [112.139732, 28.520993]
}, {
	"name": "安化县",
	"adcode": 430923,
	"center": [111.221824, 28.377421]
}, {
	"name": "沅江市",
	"adcode": 430981,
	"center": [112.361088, 28.839713]
}, {
	"name": "北湖区",
	"adcode": 431002,
	"center": [113.032208, 25.792628]
}, {
	"name": "苏仙区",
	"adcode": 431003,
	"center": [113.038698, 25.793157]
}, {
	"name": "桂阳县",
	"adcode": 431021,
	"center": [112.734466, 25.737447]
}, {
	"name": "宜章县",
	"adcode": 431022,
	"center": [112.947884, 25.394345]
}, {
	"name": "永兴县",
	"adcode": 431023,
	"center": [113.114819, 26.129392]
}, {
	"name": "嘉禾县",
	"adcode": 431024,
	"center": [112.370618, 25.587309]
}, {
	"name": "临武县",
	"adcode": 431025,
	"center": [112.564589, 25.279119]
}, {
	"name": "汝城县",
	"adcode": 431026,
	"center": [113.685686, 25.553759]
}, {
	"name": "桂东县",
	"adcode": 431027,
	"center": [113.945879, 26.073917]
}, {
	"name": "安仁县",
	"adcode": 431028,
	"center": [113.27217, 26.708625]
}, {
	"name": "资兴市",
	"adcode": 431081,
	"center": [113.23682, 25.974152]
}, {
	"name": "零陵区",
	"adcode": 431102,
	"center": [111.626348, 26.223347]
}, {
	"name": "冷水滩区",
	"adcode": 431103,
	"center": [111.607156, 26.434364]
}, {
	"name": "祁阳市",
	"adcode": 431121,
	"center": [111.85734, 26.585929]
}, {
	"name": "东安县",
	"adcode": 431122,
	"center": [111.313035, 26.397278]
}, {
	"name": "双牌县",
	"adcode": 431123,
	"center": [111.662146, 25.959397]
}, {
	"name": "道县",
	"adcode": 431124,
	"center": [111.591614, 25.518444]
}, {
	"name": "江永县",
	"adcode": 431125,
	"center": [111.346803, 25.268154]
}, {
	"name": "宁远县",
	"adcode": 431126,
	"center": [111.944529, 25.584112]
}, {
	"name": "蓝山县",
	"adcode": 431127,
	"center": [112.194195, 25.375255]
}, {
	"name": "新田县",
	"adcode": 431128,
	"center": [112.220341, 25.906927]
}, {
	"name": "江华瑶族自治县",
	"adcode": 431129,
	"center": [111.577276, 25.182596]
}, {
	"name": "鹤城区",
	"adcode": 431202,
	"center": [109.982242, 27.548474]
}, {
	"name": "中方县",
	"adcode": 431221,
	"center": [109.948061, 27.43736]
}, {
	"name": "沅陵县",
	"adcode": 431222,
	"center": [110.399161, 28.455554]
}, {
	"name": "辰溪县",
	"adcode": 431223,
	"center": [110.196953, 28.005474]
}, {
	"name": "溆浦县",
	"adcode": 431224,
	"center": [110.593373, 27.903802]
}, {
	"name": "会同县",
	"adcode": 431225,
	"center": [109.720785, 26.870789]
}, {
	"name": "麻阳苗族自治县",
	"adcode": 431226,
	"center": [109.802807, 27.865991]
}, {
	"name": "新晃侗族自治县",
	"adcode": 431227,
	"center": [109.174443, 27.359897]
}, {
	"name": "芷江侗族自治县",
	"adcode": 431228,
	"center": [109.687777, 27.437996]
}, {
	"name": "靖州苗族侗族自治县",
	"adcode": 431229,
	"center": [109.691159, 26.573511]
}, {
	"name": "通道侗族自治县",
	"adcode": 431230,
	"center": [109.783359, 26.158349]
}, {
	"name": "洪江市",
	"adcode": 431281,
	"center": [109.831765, 27.201876]
}, {
	"name": "娄星区",
	"adcode": 431302,
	"center": [112.008486, 27.726643]
}, {
	"name": "双峰县",
	"adcode": 431321,
	"center": [112.198245, 27.459126]
}, {
	"name": "新化县",
	"adcode": 431322,
	"center": [111.306747, 27.737456]
}, {
	"name": "冷水江市",
	"adcode": 431381,
	"center": [111.434674, 27.685759]
}, {
	"name": "涟源市",
	"adcode": 431382,
	"center": [111.670847, 27.692301]
}, {
	"name": "吉首市",
	"adcode": 433101,
	"center": [109.738273, 28.314827]
}, {
	"name": "泸溪县",
	"adcode": 433122,
	"center": [110.214428, 28.214516]
}, {
	"name": "凤凰县",
	"adcode": 433123,
	"center": [109.599191, 27.948308]
}, {
	"name": "花垣县",
	"adcode": 433124,
	"center": [109.479063, 28.581352]
}, {
	"name": "保靖县",
	"adcode": 433125,
	"center": [109.651445, 28.709605]
}, {
	"name": "古丈县",
	"adcode": 433126,
	"center": [109.949592, 28.616973]
}, {
	"name": "永顺县",
	"adcode": 433127,
	"center": [109.853292, 28.998068]
}, {
	"name": "龙山县",
	"adcode": 433130,
	"center": [109.441189, 29.453438]
}, {
	"name": "荔湾区",
	"adcode": 440103,
	"center": [113.243038, 23.124943]
}, {
	"name": "越秀区",
	"adcode": 440104,
	"center": [113.280714, 23.125624]
}, {
	"name": "海珠区",
	"adcode": 440105,
	"center": [113.262008, 23.103131]
}, {
	"name": "天河区",
	"adcode": 440106,
	"center": [113.335367, 23.13559]
}, {
	"name": "白云区",
	"adcode": 440111,
	"center": [113.262831, 23.162281]
}, {
	"name": "黄埔区",
	"adcode": 440112,
	"center": [113.450761, 23.103239]
}, {
	"name": "番禺区",
	"adcode": 440113,
	"center": [113.364619, 22.938582]
}, {
	"name": "花都区",
	"adcode": 440114,
	"center": [113.211184, 23.39205]
}, {
	"name": "南沙区",
	"adcode": 440115,
	"center": [113.53738, 22.794531]
}, {
	"name": "从化区",
	"adcode": 440117,
	"center": [113.587386, 23.545283]
}, {
	"name": "增城区",
	"adcode": 440118,
	"center": [113.829579, 23.290497]
}, {
	"name": "武江区",
	"adcode": 440203,
	"center": [113.588289, 24.80016]
}, {
	"name": "浈江区",
	"adcode": 440204,
	"center": [113.599224, 24.803977]
}, {
	"name": "曲江区",
	"adcode": 440205,
	"center": [113.605582, 24.680195]
}, {
	"name": "始兴县",
	"adcode": 440222,
	"center": [114.067205, 24.948364]
}, {
	"name": "仁化县",
	"adcode": 440224,
	"center": [113.748627, 25.088226]
}, {
	"name": "翁源县",
	"adcode": 440229,
	"center": [114.131289, 24.353887]
}, {
	"name": "乳源瑶族自治县",
	"adcode": 440232,
	"center": [113.278417, 24.776109]
}, {
	"name": "新丰县",
	"adcode": 440233,
	"center": [114.207034, 24.055412]
}, {
	"name": "乐昌市",
	"adcode": 440281,
	"center": [113.352413, 25.128445]
}, {
	"name": "南雄市",
	"adcode": 440282,
	"center": [114.311231, 25.115328]
}, {
	"name": "罗湖区",
	"adcode": 440303,
	"center": [114.123885, 22.555341]
}, {
	"name": "福田区",
	"adcode": 440304,
	"center": [114.05096, 22.541009]
}, {
	"name": "南山区",
	"adcode": 440305,
	"center": [113.92943, 22.531221]
}, {
	"name": "宝安区",
	"adcode": 440306,
	"center": [113.828671, 22.754741]
}, {
	"name": "龙岗区",
	"adcode": 440307,
	"center": [114.251372, 22.721511]
}, {
	"name": "盐田区",
	"adcode": 440308,
	"center": [114.235366, 22.555069]
}, {
	"name": "龙华区",
	"adcode": 440309,
	"center": [114.044346, 22.691963]
}, {
	"name": "坪山区",
	"adcode": 440310,
	"center": [114.338441, 22.69423]
}, {
	"name": "光明区",
	"adcode": 440311,
	"center": [113.935895, 22.748816]
}, {
	"name": "香洲区",
	"adcode": 440402,
	"center": [113.55027, 22.271249]
}, {
	"name": "斗门区",
	"adcode": 440403,
	"center": [113.297739, 22.209117]
}, {
	"name": "金湾区",
	"adcode": 440404,
	"center": [113.345071, 22.139122]
}, {
	"name": "龙湖区",
	"adcode": 440507,
	"center": [116.732015, 23.373754]
}, {
	"name": "金平区",
	"adcode": 440511,
	"center": [116.703583, 23.367071]
}, {
	"name": "濠江区",
	"adcode": 440512,
	"center": [116.729528, 23.279345]
}, {
	"name": "潮阳区",
	"adcode": 440513,
	"center": [116.602602, 23.262336]
}, {
	"name": "潮南区",
	"adcode": 440514,
	"center": [116.423607, 23.249798]
}, {
	"name": "澄海区",
	"adcode": 440515,
	"center": [116.76336, 23.46844]
}, {
	"name": "南澳县",
	"adcode": 440523,
	"center": [117.027105, 23.419562]
}, {
	"name": "禅城区",
	"adcode": 440604,
	"center": [113.112414, 23.019643]
}, {
	"name": "南海区",
	"adcode": 440605,
	"center": [113.145577, 23.031562]
}, {
	"name": "顺德区",
	"adcode": 440606,
	"center": [113.281826, 22.75851]
}, {
	"name": "三水区",
	"adcode": 440607,
	"center": [112.899414, 23.16504]
}, {
	"name": "高明区",
	"adcode": 440608,
	"center": [112.882123, 22.893855]
}, {
	"name": "蓬江区",
	"adcode": 440703,
	"center": [113.07859, 22.59677]
}, {
	"name": "江海区",
	"adcode": 440704,
	"center": [113.120601, 22.572211]
}, {
	"name": "新会区",
	"adcode": 440705,
	"center": [113.038584, 22.520247]
}, {
	"name": "台山市",
	"adcode": 440781,
	"center": [112.793414, 22.250713]
}, {
	"name": "开平市",
	"adcode": 440783,
	"center": [112.692262, 22.366286]
}, {
	"name": "鹤山市",
	"adcode": 440784,
	"center": [112.961795, 22.768104]
}, {
	"name": "恩平市",
	"adcode": 440785,
	"center": [112.314051, 22.182956]
}, {
	"name": "赤坎区",
	"adcode": 440802,
	"center": [110.361634, 21.273365]
}, {
	"name": "霞山区",
	"adcode": 440803,
	"center": [110.406382, 21.194229]
}, {
	"name": "坡头区",
	"adcode": 440804,
	"center": [110.455632, 21.24441]
}, {
	"name": "麻章区",
	"adcode": 440811,
	"center": [110.329167, 21.265997]
}, {
	"name": "遂溪县",
	"adcode": 440823,
	"center": [110.255321, 21.376915]
}, {
	"name": "徐闻县",
	"adcode": 440825,
	"center": [110.175718, 20.326083]
}, {
	"name": "廉江市",
	"adcode": 440881,
	"center": [110.284961, 21.611281]
}, {
	"name": "雷州市",
	"adcode": 440882,
	"center": [110.088275, 20.908523]
}, {
	"name": "吴川市",
	"adcode": 440883,
	"center": [110.780508, 21.428453]
}, {
	"name": "茂南区",
	"adcode": 440902,
	"center": [110.920542, 21.660425]
}, {
	"name": "电白区",
	"adcode": 440904,
	"center": [111.007264, 21.507219]
}, {
	"name": "高州市",
	"adcode": 440981,
	"center": [110.853251, 21.915153]
}, {
	"name": "化州市",
	"adcode": 440982,
	"center": [110.63839, 21.654953]
}, {
	"name": "信宜市",
	"adcode": 440983,
	"center": [110.941656, 22.352681]
}, {
	"name": "端州区",
	"adcode": 441202,
	"center": [112.472329, 23.052662]
}, {
	"name": "鼎湖区",
	"adcode": 441203,
	"center": [112.565249, 23.155822]
}, {
	"name": "高要区",
	"adcode": 441204,
	"center": [112.460846, 23.027694]
}, {
	"name": "广宁县",
	"adcode": 441223,
	"center": [112.440419, 23.631486]
}, {
	"name": "怀集县",
	"adcode": 441224,
	"center": [112.182466, 23.913072]
}, {
	"name": "封开县",
	"adcode": 441225,
	"center": [111.502973, 23.434731]
}, {
	"name": "德庆县",
	"adcode": 441226,
	"center": [111.78156, 23.141711]
}, {
	"name": "四会市",
	"adcode": 441284,
	"center": [112.695028, 23.340324]
}, {
	"name": "惠城区",
	"adcode": 441302,
	"center": [114.413978, 23.079883]
}, {
	"name": "惠阳区",
	"adcode": 441303,
	"center": [114.469444, 22.78851]
}, {
	"name": "博罗县",
	"adcode": 441322,
	"center": [114.284254, 23.167575]
}, {
	"name": "惠东县",
	"adcode": 441323,
	"center": [114.723092, 22.983036]
}, {
	"name": "龙门县",
	"adcode": 441324,
	"center": [114.259986, 23.723894]
}, {
	"name": "梅江区",
	"adcode": 441402,
	"center": [116.12116, 24.302593]
}, {
	"name": "梅县区",
	"adcode": 441403,
	"center": [116.083482, 24.267825]
}, {
	"name": "大埔县",
	"adcode": 441422,
	"center": [116.69552, 24.351587]
}, {
	"name": "丰顺县",
	"adcode": 441423,
	"center": [116.184419, 23.752771]
}, {
	"name": "五华县",
	"adcode": 441424,
	"center": [115.775004, 23.925424]
}, {
	"name": "平远县",
	"adcode": 441426,
	"center": [115.891729, 24.569651]
}, {
	"name": "蕉岭县",
	"adcode": 441427,
	"center": [116.170531, 24.653313]
}, {
	"name": "兴宁市",
	"adcode": 441481,
	"center": [115.731648, 24.138077]
}, {
	"name": "城区",
	"adcode": 441502,
	"center": [115.363667, 22.776227]
}, {
	"name": "海丰县",
	"adcode": 441521,
	"center": [115.337324, 22.971042]
}, {
	"name": "陆河县",
	"adcode": 441523,
	"center": [115.657565, 23.302682]
}, {
	"name": "陆丰市",
	"adcode": 441581,
	"center": [115.644203, 22.946104]
}, {
	"name": "源城区",
	"adcode": 441602,
	"center": [114.696828, 23.746255]
}, {
	"name": "紫金县",
	"adcode": 441621,
	"center": [115.184383, 23.633744]
}, {
	"name": "龙川县",
	"adcode": 441622,
	"center": [115.256415, 24.101174]
}, {
	"name": "连平县",
	"adcode": 441623,
	"center": [114.495952, 24.364227]
}, {
	"name": "和平县",
	"adcode": 441624,
	"center": [114.941473, 24.44318]
}, {
	"name": "东源县",
	"adcode": 441625,
	"center": [114.742711, 23.789093]
}, {
	"name": "江城区",
	"adcode": 441702,
	"center": [111.968909, 21.859182]
}, {
	"name": "阳东区",
	"adcode": 441704,
	"center": [112.011267, 21.864728]
}, {
	"name": "阳西县",
	"adcode": 441721,
	"center": [111.617556, 21.75367]
}, {
	"name": "阳春市",
	"adcode": 441781,
	"center": [111.7905, 22.169598]
}, {
	"name": "清城区",
	"adcode": 441802,
	"center": [113.048698, 23.688976]
}, {
	"name": "清新区",
	"adcode": 441803,
	"center": [113.015203, 23.736949]
}, {
	"name": "佛冈县",
	"adcode": 441821,
	"center": [113.534094, 23.866739]
}, {
	"name": "阳山县",
	"adcode": 441823,
	"center": [112.634019, 24.470286]
}, {
	"name": "连山壮族瑶族自治县",
	"adcode": 441825,
	"center": [112.086555, 24.567271]
}, {
	"name": "连南瑶族自治县",
	"adcode": 441826,
	"center": [112.290808, 24.719097]
}, {
	"name": "英德市",
	"adcode": 441881,
	"center": [113.405404, 24.18612]
}, {
	"name": "连州市",
	"adcode": 441882,
	"center": [112.379271, 24.783966]
}, {
	"name": "湘桥区",
	"adcode": 445102,
	"center": [116.63365, 23.664675]
}, {
	"name": "潮安区",
	"adcode": 445103,
	"center": [116.67931, 23.461012]
}, {
	"name": "饶平县",
	"adcode": 445122,
	"center": [117.00205, 23.668171]
}, {
	"name": "榕城区",
	"adcode": 445202,
	"center": [116.357045, 23.535524]
}, {
	"name": "揭东区",
	"adcode": 445203,
	"center": [116.412947, 23.569887]
}, {
	"name": "揭西县",
	"adcode": 445222,
	"center": [115.838708, 23.4273]
}, {
	"name": "惠来县",
	"adcode": 445224,
	"center": [116.295832, 23.029834]
}, {
	"name": "普宁市",
	"adcode": 445281,
	"center": [116.165082, 23.29788]
}, {
	"name": "云城区",
	"adcode": 445302,
	"center": [112.04471, 22.930827]
}, {
	"name": "云安区",
	"adcode": 445303,
	"center": [112.005609, 23.073152]
}, {
	"name": "新兴县",
	"adcode": 445321,
	"center": [112.23083, 22.703204]
}, {
	"name": "郁南县",
	"adcode": 445322,
	"center": [111.535921, 23.237709]
}, {
	"name": "罗定市",
	"adcode": 445381,
	"center": [111.578201, 22.765415]
}, {
	"name": "兴宁区",
	"adcode": 450102,
	"center": [108.320189, 22.819511]
}, {
	"name": "青秀区",
	"adcode": 450103,
	"center": [108.346113, 22.816614]
}, {
	"name": "江南区",
	"adcode": 450105,
	"center": [108.310478, 22.799593]
}, {
	"name": "西乡塘区",
	"adcode": 450107,
	"center": [108.306903, 22.832779]
}, {
	"name": "良庆区",
	"adcode": 450108,
	"center": [108.322102, 22.75909]
}, {
	"name": "邕宁区",
	"adcode": 450109,
	"center": [108.484251, 22.756598]
}, {
	"name": "武鸣区",
	"adcode": 450110,
	"center": [108.280717, 23.157163]
}, {
	"name": "隆安县",
	"adcode": 450123,
	"center": [107.688661, 23.174763]
}, {
	"name": "马山县",
	"adcode": 450124,
	"center": [108.172903, 23.711758]
}, {
	"name": "上林县",
	"adcode": 450125,
	"center": [108.603937, 23.431769]
}, {
	"name": "宾阳县",
	"adcode": 450126,
	"center": [108.816735, 23.216884]
}, {
	"name": "横州市",
	"adcode": 450127,
	"center": [109.270987, 22.68743]
}, {
	"name": "城中区",
	"adcode": 450202,
	"center": [109.411749, 24.312324]
}, {
	"name": "鱼峰区",
	"adcode": 450203,
	"center": [109.415364, 24.303848]
}, {
	"name": "柳南区",
	"adcode": 450204,
	"center": [109.395936, 24.287013]
}, {
	"name": "柳北区",
	"adcode": 450205,
	"center": [109.406577, 24.359145]
}, {
	"name": "柳江区",
	"adcode": 450206,
	"center": [109.334503, 24.257512]
}, {
	"name": "柳城县",
	"adcode": 450222,
	"center": [109.245812, 24.655121]
}, {
	"name": "鹿寨县",
	"adcode": 450223,
	"center": [109.740805, 24.483405]
}, {
	"name": "融安县",
	"adcode": 450224,
	"center": [109.403621, 25.214703]
}, {
	"name": "融水苗族自治县",
	"adcode": 450225,
	"center": [109.252744, 25.068812]
}, {
	"name": "三江侗族自治县",
	"adcode": 450226,
	"center": [109.614846, 25.78553]
}, {
	"name": "秀峰区",
	"adcode": 450302,
	"center": [110.292445, 25.278544]
}, {
	"name": "叠彩区",
	"adcode": 450303,
	"center": [110.300783, 25.301334]
}, {
	"name": "象山区",
	"adcode": 450304,
	"center": [110.284882, 25.261986]
}, {
	"name": "七星区",
	"adcode": 450305,
	"center": [110.317577, 25.254339]
}, {
	"name": "雁山区",
	"adcode": 450311,
	"center": [110.305667, 25.077646]
}, {
	"name": "临桂区",
	"adcode": 450312,
	"center": [110.205487, 25.246257]
}, {
	"name": "阳朔县",
	"adcode": 450321,
	"center": [110.494699, 24.77534]
}, {
	"name": "灵川县",
	"adcode": 450323,
	"center": [110.325712, 25.408541]
}, {
	"name": "全州县",
	"adcode": 450324,
	"center": [111.072989, 25.929897]
}, {
	"name": "兴安县",
	"adcode": 450325,
	"center": [110.670783, 25.609554]
}, {
	"name": "永福县",
	"adcode": 450326,
	"center": [109.989208, 24.986692]
}, {
	"name": "灌阳县",
	"adcode": 450327,
	"center": [111.160248, 25.489098]
}, {
	"name": "龙胜各族自治县",
	"adcode": 450328,
	"center": [110.009423, 25.796428]
}, {
	"name": "资源县",
	"adcode": 450329,
	"center": [110.642587, 26.0342]
}, {
	"name": "平乐县",
	"adcode": 450330,
	"center": [110.642821, 24.632216]
}, {
	"name": "恭城瑶族自治县",
	"adcode": 450332,
	"center": [110.82952, 24.833612]
}, {
	"name": "荔浦市",
	"adcode": 450381,
	"center": [110.400149, 24.497786]
}, {
	"name": "万秀区",
	"adcode": 450403,
	"center": [111.315817, 23.471318]
}, {
	"name": "长洲区",
	"adcode": 450405,
	"center": [111.275678, 23.4777]
}, {
	"name": "龙圩区",
	"adcode": 450406,
	"center": [111.246035, 23.40996]
}, {
	"name": "苍梧县",
	"adcode": 450421,
	"center": [111.544008, 23.845097]
}, {
	"name": "藤县",
	"adcode": 450422,
	"center": [110.931826, 23.373963]
}, {
	"name": "蒙山县",
	"adcode": 450423,
	"center": [110.5226, 24.199829]
}, {
	"name": "岑溪市",
	"adcode": 450481,
	"center": [110.998114, 22.918406]
}, {
	"name": "海城区",
	"adcode": 450502,
	"center": [109.107529, 21.468443]
}, {
	"name": "银海区",
	"adcode": 450503,
	"center": [109.118707, 21.444909]
}, {
	"name": "铁山港区",
	"adcode": 450512,
	"center": [109.450573, 21.5928]
}, {
	"name": "合浦县",
	"adcode": 450521,
	"center": [109.200695, 21.663554]
}, {
	"name": "港口区",
	"adcode": 450602,
	"center": [108.346281, 21.614406]
}, {
	"name": "防城区",
	"adcode": 450603,
	"center": [108.358426, 21.764758]
}, {
	"name": "上思县",
	"adcode": 450621,
	"center": [107.982139, 22.151423]
}, {
	"name": "东兴市",
	"adcode": 450681,
	"center": [107.97017, 21.541172]
}, {
	"name": "钦南区",
	"adcode": 450702,
	"center": [108.626629, 21.966808]
}, {
	"name": "钦北区",
	"adcode": 450703,
	"center": [108.44911, 22.132761]
}, {
	"name": "灵山县",
	"adcode": 450721,
	"center": [109.293468, 22.418041]
}, {
	"name": "浦北县",
	"adcode": 450722,
	"center": [109.556341, 22.268335]
}, {
	"name": "港北区",
	"adcode": 450802,
	"center": [109.59481, 23.107677]
}, {
	"name": "港南区",
	"adcode": 450803,
	"center": [109.604665, 23.067516]
}, {
	"name": "覃塘区",
	"adcode": 450804,
	"center": [109.415697, 23.132815]
}, {
	"name": "平南县",
	"adcode": 450821,
	"center": [110.397485, 23.544546]
}, {
	"name": "桂平市",
	"adcode": 450881,
	"center": [110.074668, 23.382473]
}, {
	"name": "玉州区",
	"adcode": 450902,
	"center": [110.154912, 22.632132]
}, {
	"name": "福绵区",
	"adcode": 450903,
	"center": [110.054155, 22.58163]
}, {
	"name": "容县",
	"adcode": 450921,
	"center": [110.552467, 22.856435]
}, {
	"name": "陆川县",
	"adcode": 450922,
	"center": [110.264842, 22.321054]
}, {
	"name": "博白县",
	"adcode": 450923,
	"center": [109.980004, 22.271285]
}, {
	"name": "兴业县",
	"adcode": 450924,
	"center": [109.877768, 22.74187]
}, {
	"name": "北流市",
	"adcode": 450981,
	"center": [110.348052, 22.701648]
}, {
	"name": "右江区",
	"adcode": 451002,
	"center": [106.615727, 23.897675]
}, {
	"name": "田阳区",
	"adcode": 451003,
	"center": [106.904315, 23.736079]
}, {
	"name": "田东县",
	"adcode": 451022,
	"center": [107.12426, 23.600444]
}, {
	"name": "德保县",
	"adcode": 451024,
	"center": [106.618164, 23.321464]
}, {
	"name": "那坡县",
	"adcode": 451026,
	"center": [105.833553, 23.400785]
}, {
	"name": "凌云县",
	"adcode": 451027,
	"center": [106.56487, 24.345643]
}, {
	"name": "乐业县",
	"adcode": 451028,
	"center": [106.559638, 24.782204]
}, {
	"name": "田林县",
	"adcode": 451029,
	"center": [106.235047, 24.290262]
}, {
	"name": "西林县",
	"adcode": 451030,
	"center": [105.095025, 24.492041]
}, {
	"name": "隆林各族自治县",
	"adcode": 451031,
	"center": [105.342363, 24.774318]
}, {
	"name": "靖西市",
	"adcode": 451081,
	"center": [106.417549, 23.134766]
}, {
	"name": "平果市",
	"adcode": 451082,
	"center": [107.580403, 23.320479]
}, {
	"name": "八步区",
	"adcode": 451102,
	"center": [111.551991, 24.412446]
}, {
	"name": "平桂区",
	"adcode": 451103,
	"center": [111.524014, 24.417148]
}, {
	"name": "昭平县",
	"adcode": 451121,
	"center": [110.810865, 24.172958]
}, {
	"name": "钟山县",
	"adcode": 451122,
	"center": [111.303629, 24.528566]
}, {
	"name": "富川瑶族自治县",
	"adcode": 451123,
	"center": [111.277228, 24.81896]
}, {
	"name": "金城江区",
	"adcode": 451202,
	"center": [108.062131, 24.695625]
}, {
	"name": "宜州区",
	"adcode": 451203,
	"center": [108.653965, 24.492193]
}, {
	"name": "南丹县",
	"adcode": 451221,
	"center": [107.546605, 24.983192]
}, {
	"name": "天峨县",
	"adcode": 451222,
	"center": [107.174939, 24.985964]
}, {
	"name": "凤山县",
	"adcode": 451223,
	"center": [107.044592, 24.544561]
}, {
	"name": "东兰县",
	"adcode": 451224,
	"center": [107.373696, 24.509367]
}, {
	"name": "罗城仫佬族自治县",
	"adcode": 451225,
	"center": [108.902453, 24.779327]
}, {
	"name": "环江毛南族自治县",
	"adcode": 451226,
	"center": [108.258669, 24.827628]
}, {
	"name": "巴马瑶族自治县",
	"adcode": 451227,
	"center": [107.253126, 24.139538]
}, {
	"name": "都安瑶族自治县",
	"adcode": 451228,
	"center": [108.102761, 23.934964]
}, {
	"name": "大化瑶族自治县",
	"adcode": 451229,
	"center": [107.9945, 23.739596]
}, {
	"name": "兴宾区",
	"adcode": 451302,
	"center": [109.230541, 23.732926]
}, {
	"name": "忻城县",
	"adcode": 451321,
	"center": [108.667361, 24.064779]
}, {
	"name": "象州县",
	"adcode": 451322,
	"center": [109.684555, 23.959824]
}, {
	"name": "武宣县",
	"adcode": 451323,
	"center": [109.66287, 23.604162]
}, {
	"name": "金秀瑶族自治县",
	"adcode": 451324,
	"center": [110.188556, 24.134941]
}, {
	"name": "合山市",
	"adcode": 451381,
	"center": [108.88858, 23.81311]
}, {
	"name": "江州区",
	"adcode": 451402,
	"center": [107.354443, 22.40469]
}, {
	"name": "扶绥县",
	"adcode": 451421,
	"center": [107.911533, 22.635821]
}, {
	"name": "宁明县",
	"adcode": 451422,
	"center": [107.067616, 22.131353]
}, {
	"name": "龙州县",
	"adcode": 451423,
	"center": [106.857502, 22.343716]
}, {
	"name": "大新县",
	"adcode": 451424,
	"center": [107.200803, 22.833369]
}, {
	"name": "天等县",
	"adcode": 451425,
	"center": [107.142441, 23.082484]
}, {
	"name": "凭祥市",
	"adcode": 451481,
	"center": [106.759038, 22.108882]
}, {
	"name": "秀英区",
	"adcode": 460105,
	"center": [110.282393, 20.008145]
}, {
	"name": "龙华区",
	"adcode": 460106,
	"center": [110.330373, 20.031026]
}, {
	"name": "琼山区",
	"adcode": 460107,
	"center": [110.354722, 20.001051]
}, {
	"name": "美兰区",
	"adcode": 460108,
	"center": [110.356566, 20.03074]
}, {
	"name": "海棠区",
	"adcode": 460202,
	"center": [109.760778, 18.407516]
}, {
	"name": "吉阳区",
	"adcode": 460203,
	"center": [109.512081, 18.247436]
}, {
	"name": "天涯区",
	"adcode": 460204,
	"center": [109.506357, 18.24734]
}, {
	"name": "崖州区",
	"adcode": 460205,
	"center": [109.174306, 18.352192]
}, {
	"name": "西沙区",
	"adcode": 460301,
	"center": [112.3386402, 16.8310066]
}, {
	"name": "南沙区",
	"adcode": 460302,
	"center": [112.891018, 9.543575]
}, {
	"name": "万州区",
	"adcode": 500101,
	"center": [108.380246, 30.807807]
}, {
	"name": "涪陵区",
	"adcode": 500102,
	"center": [107.394905, 29.703652]
}, {
	"name": "渝中区",
	"adcode": 500103,
	"center": [106.56288, 29.556742]
}, {
	"name": "大渡口区",
	"adcode": 500104,
	"center": [106.48613, 29.481002]
}, {
	"name": "江北区",
	"adcode": 500105,
	"center": [106.532844, 29.575352]
}, {
	"name": "沙坪坝区",
	"adcode": 500106,
	"center": [106.4542, 29.541224]
}, {
	"name": "九龙坡区",
	"adcode": 500107,
	"center": [106.480989, 29.523492]
}, {
	"name": "南岸区",
	"adcode": 500108,
	"center": [106.560813, 29.523992]
}, {
	"name": "北碚区",
	"adcode": 500109,
	"center": [106.437868, 29.82543]
}, {
	"name": "綦江区",
	"adcode": 500110,
	"center": [106.651417, 29.028091]
}, {
	"name": "大足区",
	"adcode": 500111,
	"center": [105.715319, 29.700498]
}, {
	"name": "渝北区",
	"adcode": 500112,
	"center": [106.512851, 29.601451]
}, {
	"name": "巴南区",
	"adcode": 500113,
	"center": [106.519423, 29.381919]
}, {
	"name": "黔江区",
	"adcode": 500114,
	"center": [108.782577, 29.527548]
}, {
	"name": "长寿区",
	"adcode": 500115,
	"center": [107.074854, 29.833671]
}, {
	"name": "江津区",
	"adcode": 500116,
	"center": [106.253156, 29.283387]
}, {
	"name": "合川区",
	"adcode": 500117,
	"center": [106.265554, 29.990993]
}, {
	"name": "永川区",
	"adcode": 500118,
	"center": [105.894714, 29.348748]
}, {
	"name": "南川区",
	"adcode": 500119,
	"center": [107.098153, 29.156646]
}, {
	"name": "璧山区",
	"adcode": 500120,
	"center": [106.231126, 29.593581]
}, {
	"name": "铜梁区",
	"adcode": 500151,
	"center": [106.054948, 29.839944]
}, {
	"name": "潼南区",
	"adcode": 500152,
	"center": [105.841818, 30.189554]
}, {
	"name": "荣昌区",
	"adcode": 500153,
	"center": [105.594061, 29.403627]
}, {
	"name": "开州区",
	"adcode": 500154,
	"center": [108.413317, 31.167735]
}, {
	"name": "梁平区",
	"adcode": 500155,
	"center": [107.800034, 30.672168]
}, {
	"name": "武隆区",
	"adcode": 500156,
	"center": [107.75655, 29.32376]
}, {
	"name": "城口县",
	"adcode": 500229,
	"center": [108.6649, 31.946293]
}, {
	"name": "丰都县",
	"adcode": 500230,
	"center": [107.73248, 29.866424]
}, {
	"name": "垫江县",
	"adcode": 500231,
	"center": [107.348692, 30.330012]
}, {
	"name": "忠县",
	"adcode": 500233,
	"center": [108.037518, 30.291537]
}, {
	"name": "云阳县",
	"adcode": 500235,
	"center": [108.697698, 30.930529]
}, {
	"name": "奉节县",
	"adcode": 500236,
	"center": [109.465774, 31.019967]
}, {
	"name": "巫山县",
	"adcode": 500237,
	"center": [109.878928, 31.074843]
}, {
	"name": "巫溪县",
	"adcode": 500238,
	"center": [109.628912, 31.3966]
}, {
	"name": "石柱土家族自治县",
	"adcode": 500240,
	"center": [108.112448, 29.99853]
}, {
	"name": "秀山土家族苗族自治县",
	"adcode": 500241,
	"center": [108.996043, 28.444772]
}, {
	"name": "酉阳土家族苗族自治县",
	"adcode": 500242,
	"center": [108.767201, 28.839828]
}, {
	"name": "彭水苗族土家族自治县",
	"adcode": 500243,
	"center": [108.166551, 29.293856]
}, {
	"name": "锦江区",
	"adcode": 510104,
	"center": [104.080989, 30.657689]
}, {
	"name": "青羊区",
	"adcode": 510105,
	"center": [104.055731, 30.667648]
}, {
	"name": "金牛区",
	"adcode": 510106,
	"center": [104.043487, 30.692058]
}, {
	"name": "武侯区",
	"adcode": 510107,
	"center": [104.05167, 30.630862]
}, {
	"name": "成华区",
	"adcode": 510108,
	"center": [104.103077, 30.660275]
}, {
	"name": "龙泉驿区",
	"adcode": 510112,
	"center": [104.269181, 30.56065]
}, {
	"name": "青白江区",
	"adcode": 510113,
	"center": [104.25494, 30.883438]
}, {
	"name": "新都区",
	"adcode": 510114,
	"center": [104.16022, 30.824223]
}, {
	"name": "温江区",
	"adcode": 510115,
	"center": [103.836776, 30.697996]
}, {
	"name": "双流区",
	"adcode": 510116,
	"center": [103.922706, 30.573243]
}, {
	"name": "郫都区",
	"adcode": 510117,
	"center": [103.887842, 30.808752]
}, {
	"name": "新津区",
	"adcode": 510118,
	"center": [103.812449, 30.414284]
}, {
	"name": "金堂县",
	"adcode": 510121,
	"center": [104.415604, 30.858417]
}, {
	"name": "大邑县",
	"adcode": 510129,
	"center": [103.522397, 30.586602]
}, {
	"name": "蒲江县",
	"adcode": 510131,
	"center": [103.511541, 30.194359]
}, {
	"name": "都江堰市",
	"adcode": 510181,
	"center": [103.627898, 30.99114]
}, {
	"name": "彭州市",
	"adcode": 510182,
	"center": [103.941173, 30.985161]
}, {
	"name": "邛崃市",
	"adcode": 510183,
	"center": [103.46143, 30.413271]
}, {
	"name": "崇州市",
	"adcode": 510184,
	"center": [103.671049, 30.631478]
}, {
	"name": "简阳市",
	"adcode": 510185,
	"center": [104.550339, 30.390666]
}, {
	"name": "自流井区",
	"adcode": 510302,
	"center": [104.778188, 29.343231]
}, {
	"name": "贡井区",
	"adcode": 510303,
	"center": [104.714372, 29.345675]
}, {
	"name": "大安区",
	"adcode": 510304,
	"center": [104.783229, 29.367136]
}, {
	"name": "沿滩区",
	"adcode": 510311,
	"center": [104.876417, 29.272521]
}, {
	"name": "荣县",
	"adcode": 510321,
	"center": [104.423932, 29.454851]
}, {
	"name": "富顺县",
	"adcode": 510322,
	"center": [104.984256, 29.181282]
}, {
	"name": "东区",
	"adcode": 510402,
	"center": [101.715134, 26.580887]
}, {
	"name": "西区",
	"adcode": 510403,
	"center": [101.637969, 26.596776]
}, {
	"name": "仁和区",
	"adcode": 510411,
	"center": [101.737916, 26.497185]
}, {
	"name": "米易县",
	"adcode": 510421,
	"center": [102.109877, 26.887474]
}, {
	"name": "盐边县",
	"adcode": 510422,
	"center": [101.851848, 26.677619]
}, {
	"name": "江阳区",
	"adcode": 510502,
	"center": [105.445131, 28.882889]
}, {
	"name": "纳溪区",
	"adcode": 510503,
	"center": [105.37721, 28.77631]
}, {
	"name": "龙马潭区",
	"adcode": 510504,
	"center": [105.435228, 28.897572]
}, {
	"name": "泸县",
	"adcode": 510521,
	"center": [105.376335, 29.151288]
}, {
	"name": "合江县",
	"adcode": 510522,
	"center": [105.834098, 28.810325]
}, {
	"name": "叙永县",
	"adcode": 510524,
	"center": [105.437775, 28.167919]
}, {
	"name": "古蔺县",
	"adcode": 510525,
	"center": [105.813359, 28.03948]
}, {
	"name": "旌阳区",
	"adcode": 510603,
	"center": [104.389648, 31.130428]
}, {
	"name": "罗江区",
	"adcode": 510604,
	"center": [104.507126, 31.303281]
}, {
	"name": "中江县",
	"adcode": 510623,
	"center": [104.677831, 31.03681]
}, {
	"name": "广汉市",
	"adcode": 510681,
	"center": [104.281903, 30.97715]
}, {
	"name": "什邡市",
	"adcode": 510682,
	"center": [104.173653, 31.126881]
}, {
	"name": "绵竹市",
	"adcode": 510683,
	"center": [104.200162, 31.343084]
}, {
	"name": "涪城区",
	"adcode": 510703,
	"center": [104.740971, 31.463557]
}, {
	"name": "游仙区",
	"adcode": 510704,
	"center": [104.770006, 31.484772]
}, {
	"name": "安州区",
	"adcode": 510705,
	"center": [104.560341, 31.53894]
}, {
	"name": "三台县",
	"adcode": 510722,
	"center": [105.090316, 31.090909]
}, {
	"name": "盐亭县",
	"adcode": 510723,
	"center": [105.391991, 31.22318]
}, {
	"name": "梓潼县",
	"adcode": 510725,
	"center": [105.16353, 31.635225]
}, {
	"name": "北川羌族自治县",
	"adcode": 510726,
	"center": [104.468069, 31.615863]
}, {
	"name": "平武县",
	"adcode": 510727,
	"center": [104.530555, 32.407588]
}, {
	"name": "江油市",
	"adcode": 510781,
	"center": [104.744431, 31.776386]
}, {
	"name": "利州区",
	"adcode": 510802,
	"center": [105.826194, 32.432276]
}, {
	"name": "昭化区",
	"adcode": 510811,
	"center": [105.964121, 32.322788]
}, {
	"name": "朝天区",
	"adcode": 510812,
	"center": [105.88917, 32.642632]
}, {
	"name": "旺苍县",
	"adcode": 510821,
	"center": [106.290426, 32.22833]
}, {
	"name": "青川县",
	"adcode": 510822,
	"center": [105.238847, 32.585655]
}, {
	"name": "剑阁县",
	"adcode": 510823,
	"center": [105.527035, 32.286517]
}, {
	"name": "苍溪县",
	"adcode": 510824,
	"center": [105.939706, 31.732251]
}, {
	"name": "船山区",
	"adcode": 510903,
	"center": [105.582215, 30.502647]
}, {
	"name": "安居区",
	"adcode": 510904,
	"center": [105.459383, 30.346121]
}, {
	"name": "蓬溪县",
	"adcode": 510921,
	"center": [105.713699, 30.774883]
}, {
	"name": "大英县",
	"adcode": 510923,
	"center": [105.252187, 30.581571]
}, {
	"name": "射洪市",
	"adcode": 510981,
	"center": [105.381849, 30.868752]
}, {
	"name": "市中区",
	"adcode": 511002,
	"center": [105.065467, 29.585265]
}, {
	"name": "东兴区",
	"adcode": 511011,
	"center": [105.067203, 29.600107]
}, {
	"name": "威远县",
	"adcode": 511024,
	"center": [104.668327, 29.52686]
}, {
	"name": "资中县",
	"adcode": 511025,
	"center": [104.852463, 29.775295]
}, {
	"name": "隆昌市",
	"adcode": 511083,
	"center": [105.288074, 29.338162]
}, {
	"name": "市中区",
	"adcode": 511102,
	"center": [103.75539, 29.588327]
}, {
	"name": "��湾区",
	"adcode": 511111,
	"center": [103.549961, 29.416536]
}, {
	"name": "五通桥区",
	"adcode": 511112,
	"center": [103.816837, 29.406186]
}, {
	"name": "金口河区",
	"adcode": 511113,
	"center": [103.077831, 29.24602]
}, {
	"name": "犍为县",
	"adcode": 511123,
	"center": [103.944266, 29.209782]
}, {
	"name": "井研县",
	"adcode": 511124,
	"center": [104.06885, 29.651645]
}, {
	"name": "夹江县",
	"adcode": 511126,
	"center": [103.578862, 29.741019]
}, {
	"name": "沐川县",
	"adcode": 511129,
	"center": [103.90211, 28.956338]
}, {
	"name": "峨边彝族自治县",
	"adcode": 511132,
	"center": [103.262148, 29.230271]
}, {
	"name": "马边彝族自治县",
	"adcode": 511133,
	"center": [103.546851, 28.838933]
}, {
	"name": "峨眉山市",
	"adcode": 511181,
	"center": [103.492488, 29.597478]
}, {
	"name": "顺庆区",
	"adcode": 511302,
	"center": [106.084091, 30.795572]
}, {
	"name": "高坪区",
	"adcode": 511303,
	"center": [106.108996, 30.781809]
}, {
	"name": "嘉陵区",
	"adcode": 511304,
	"center": [106.067027, 30.762976]
}, {
	"name": "南部县",
	"adcode": 511321,
	"center": [106.061138, 31.349407]
}, {
	"name": "营山县",
	"adcode": 511322,
	"center": [106.564893, 31.075907]
}, {
	"name": "蓬安县",
	"adcode": 511323,
	"center": [106.413488, 31.027978]
}, {
	"name": "仪陇县",
	"adcode": 511324,
	"center": [106.297083, 31.271261]
}, {
	"name": "西充县",
	"adcode": 511325,
	"center": [105.893021, 30.994616]
}, {
	"name": "阆中市",
	"adcode": 511381,
	"center": [105.975266, 31.580466]
}, {
	"name": "东坡区",
	"adcode": 511402,
	"center": [103.831553, 30.048128]
}, {
	"name": "彭山区",
	"adcode": 511403,
	"center": [103.8701, 30.192298]
}, {
	"name": "仁寿县",
	"adcode": 511421,
	"center": [104.147646, 29.996721]
}, {
	"name": "洪雅县",
	"adcode": 511423,
	"center": [103.375006, 29.904867]
}, {
	"name": "丹棱县",
	"adcode": 511424,
	"center": [103.518333, 30.012751]
}, {
	"name": "青神县",
	"adcode": 511425,
	"center": [103.846131, 29.831469]
}, {
	"name": "翠屏区",
	"adcode": 511502,
	"center": [104.630231, 28.760179]
}, {
	"name": "南溪区",
	"adcode": 511503,
	"center": [104.981133, 28.839806]
}, {
	"name": "叙州区",
	"adcode": 511504,
	"center": [104.541489, 28.695678]
}, {
	"name": "江安县",
	"adcode": 511523,
	"center": [105.068697, 28.728102]
}, {
	"name": "长宁县",
	"adcode": 511524,
	"center": [104.921116, 28.577271]
}, {
	"name": "高县",
	"adcode": 511525,
	"center": [104.519187, 28.435676]
}, {
	"name": "珙县",
	"adcode": 511526,
	"center": [104.712268, 28.449041]
}, {
	"name": "筠连县",
	"adcode": 511527,
	"center": [104.507848, 28.162017]
}, {
	"name": "兴文县",
	"adcode": 511528,
	"center": [105.236549, 28.302988]
}, {
	"name": "屏山县",
	"adcode": 511529,
	"center": [104.162617, 28.64237]
}, {
	"name": "广安区",
	"adcode": 511602,
	"center": [106.632907, 30.456462]
}, {
	"name": "前锋区",
	"adcode": 511603,
	"center": [106.893277, 30.4963]
}, {
	"name": "岳池县",
	"adcode": 511621,
	"center": [106.444451, 30.533538]
}, {
	"name": "武胜县",
	"adcode": 511622,
	"center": [106.292473, 30.344291]
}, {
	"name": "邻水县",
	"adcode": 511623,
	"center": [106.934968, 30.334323]
}, {
	"name": "华蓥市",
	"adcode": 511681,
	"center": [106.777882, 30.380574]
}, {
	"name": "通川区",
	"adcode": 511702,
	"center": [107.501062, 31.213522]
}, {
	"name": "达川区",
	"adcode": 511703,
	"center": [107.507926, 31.199062]
}, {
	"name": "宣汉县",
	"adcode": 511722,
	"center": [107.722254, 31.355025]
}, {
	"name": "开江县",
	"adcode": 511723,
	"center": [107.864135, 31.085537]
}, {
	"name": "大竹县",
	"adcode": 511724,
	"center": [107.20742, 30.736289]
}, {
	"name": "渠县",
	"adcode": 511725,
	"center": [106.970746, 30.836348]
}, {
	"name": "万源市",
	"adcode": 511781,
	"center": [108.037548, 32.06777]
}, {
	"name": "雨城区",
	"adcode": 511802,
	"center": [103.003398, 29.981831]
}, {
	"name": "名山区",
	"adcode": 511803,
	"center": [103.112214, 30.084718]
}, {
	"name": "荥经县",
	"adcode": 511822,
	"center": [102.844674, 29.795529]
}, {
	"name": "汉源县",
	"adcode": 511823,
	"center": [102.677145, 29.349915]
}, {
	"name": "石棉县",
	"adcode": 511824,
	"center": [102.35962, 29.234063]
}, {
	"name": "天全县",
	"adcode": 511825,
	"center": [102.763462, 30.059955]
}, {
	"name": "芦山县",
	"adcode": 511826,
	"center": [102.924016, 30.152907]
}, {
	"name": "宝兴县",
	"adcode": 511827,
	"center": [102.813377, 30.369026]
}, {
	"name": "巴州区",
	"adcode": 511902,
	"center": [106.753671, 31.858366]
}, {
	"name": "恩阳区",
	"adcode": 511903,
	"center": [106.486515, 31.816336]
}, {
	"name": "通江县",
	"adcode": 511921,
	"center": [107.247621, 31.91212]
}, {
	"name": "南江县",
	"adcode": 511922,
	"center": [106.843418, 32.353164]
}, {
	"name": "平昌县",
	"adcode": 511923,
	"center": [107.101937, 31.562814]
}, {
	"name": "雁江区",
	"adcode": 512002,
	"center": [104.642338, 30.121686]
}, {
	"name": "安岳县",
	"adcode": 512021,
	"center": [105.336764, 30.099206]
}, {
	"name": "乐至县",
	"adcode": 512022,
	"center": [105.031142, 30.275619]
}, {
	"name": "马尔康市",
	"adcode": 513201,
	"center": [102.221187, 31.899761]
}, {
	"name": "汶川县",
	"adcode": 513221,
	"center": [103.580675, 31.47463]
}, {
	"name": "理县",
	"adcode": 513222,
	"center": [103.165486, 31.436764]
}, {
	"name": "茂县",
	"adcode": 513223,
	"center": [103.850684, 31.680407]
}, {
	"name": "松潘县",
	"adcode": 513224,
	"center": [103.599177, 32.63838]
}, {
	"name": "九寨沟县",
	"adcode": 513225,
	"center": [104.236344, 33.262097]
}, {
	"name": "金川县",
	"adcode": 513226,
	"center": [102.064647, 31.476356]
}, {
	"name": "小金县",
	"adcode": 513227,
	"center": [102.363193, 30.999016]
}, {
	"name": "黑水县",
	"adcode": 513228,
	"center": [102.990805, 32.061721]
}, {
	"name": "壤塘县",
	"adcode": 513230,
	"center": [100.979136, 32.264887]
}, {
	"name": "阿坝县",
	"adcode": 513231,
	"center": [101.700985, 32.904223]
}, {
	"name": "若尔盖县",
	"adcode": 513232,
	"center": [102.963726, 33.575934]
}, {
	"name": "红原县",
	"adcode": 513233,
	"center": [102.544906, 32.793902]
}, {
	"name": "康定市",
	"adcode": 513301,
	"center": [101.964057, 30.050738]
}, {
	"name": "泸定县",
	"adcode": 513322,
	"center": [102.233225, 29.912482]
}, {
	"name": "丹巴县",
	"adcode": 513323,
	"center": [101.886125, 30.877083]
}, {
	"name": "九龙县",
	"adcode": 513324,
	"center": [101.506942, 29.001975]
}, {
	"name": "雅江县",
	"adcode": 513325,
	"center": [101.015735, 30.03225]
}, {
	"name": "道孚县",
	"adcode": 513326,
	"center": [101.123327, 30.978767]
}, {
	"name": "炉霍县",
	"adcode": 513327,
	"center": [100.679495, 31.392674]
}, {
	"name": "甘孜县",
	"adcode": 513328,
	"center": [99.991753, 31.61975]
}, {
	"name": "新龙县",
	"adcode": 513329,
	"center": [100.312094, 30.93896]
}, {
	"name": "德格县",
	"adcode": 513330,
	"center": [98.57999, 31.806729]
}, {
	"name": "白玉县",
	"adcode": 513331,
	"center": [98.824343, 31.208805]
}, {
	"name": "石渠县",
	"adcode": 513332,
	"center": [98.100887, 32.975302]
}, {
	"name": "色达县",
	"adcode": 513333,
	"center": [100.331657, 32.268777]
}, {
	"name": "理塘县",
	"adcode": 513334,
	"center": [100.269862, 29.991807]
}, {
	"name": "巴塘县",
	"adcode": 513335,
	"center": [99.109037, 30.005723]
}, {
	"name": "乡城县",
	"adcode": 513336,
	"center": [99.799943, 28.930855]
}, {
	"name": "稻城县",
	"adcode": 513337,
	"center": [100.296689, 29.037544]
}, {
	"name": "得荣县",
	"adcode": 513338,
	"center": [99.288036, 28.71134]
}, {
	"name": "西昌市",
	"adcode": 513401,
	"center": [102.258758, 27.885786]
}, {
	"name": "木里藏族自治县",
	"adcode": 513422,
	"center": [101.280184, 27.926859]
}, {
	"name": "盐源县",
	"adcode": 513423,
	"center": [101.508909, 27.423415]
}, {
	"name": "德昌县",
	"adcode": 513424,
	"center": [102.178845, 27.403827]
}, {
	"name": "会理市",
	"adcode": 513425,
	"center": [102.249548, 26.658702]
}, {
	"name": "会东县",
	"adcode": 513426,
	"center": [102.578985, 26.630713]
}, {
	"name": "宁南县",
	"adcode": 513427,
	"center": [102.757374, 27.065205]
}, {
	"name": "普格县",
	"adcode": 513428,
	"center": [102.541082, 27.376828]
}, {
	"name": "布拖县",
	"adcode": 513429,
	"center": [102.808801, 27.709062]
}, {
	"name": "金阳县",
	"adcode": 513430,
	"center": [103.248704, 27.695916]
}, {
	"name": "昭觉县",
	"adcode": 513431,
	"center": [102.843991, 28.010554]
}, {
	"name": "喜德县",
	"adcode": 513432,
	"center": [102.412342, 28.305486]
}, {
	"name": "冕宁县",
	"adcode": 513433,
	"center": [102.170046, 28.550844]
}, {
	"name": "越西县",
	"adcode": 513434,
	"center": [102.508875, 28.639632]
}, {
	"name": "甘洛县",
	"adcode": 513435,
	"center": [102.775924, 28.977094]
}, {
	"name": "美姑县",
	"adcode": 513436,
	"center": [103.132007, 28.327946]
}, {
	"name": "雷波县",
	"adcode": 513437,
	"center": [103.571584, 28.262946]
}, {
	"name": "南明区",
	"adcode": 520102,
	"center": [106.715963, 26.573743]
}, {
	"name": "云岩区",
	"adcode": 520103,
	"center": [106.713397, 26.58301]
}, {
	"name": "花溪区",
	"adcode": 520111,
	"center": [106.670791, 26.410464]
}, {
	"name": "乌当区",
	"adcode": 520112,
	"center": [106.762123, 26.630928]
}, {
	"name": "白云区",
	"adcode": 520113,
	"center": [106.633037, 26.676849]
}, {
	"name": "观山湖区",
	"adcode": 520115,
	"center": [106.626323, 26.646358]
}, {
	"name": "开阳县",
	"adcode": 520121,
	"center": [106.969438, 27.056793]
}, {
	"name": "息烽县",
	"adcode": 520122,
	"center": [106.737693, 27.092665]
}, {
	"name": "修文县",
	"adcode": 520123,
	"center": [106.599218, 26.840672]
}, {
	"name": "清镇市",
	"adcode": 520181,
	"center": [106.470278, 26.551289]
}, {
	"name": "钟山区",
	"adcode": 520201,
	"center": [104.846244, 26.584805]
}, {
	"name": "六枝特区",
	"adcode": 520203,
	"center": [105.474235, 26.210662]
}, {
	"name": "水城区",
	"adcode": 520221,
	"center": [104.95685, 26.540478]
}, {
	"name": "盘州市",
	"adcode": 520281,
	"center": [104.468367, 25.706966]
}, {
	"name": "红花岗区",
	"adcode": 520302,
	"center": [106.943784, 27.694395]
}, {
	"name": "汇川区",
	"adcode": 520303,
	"center": [106.937265, 27.706626]
}, {
	"name": "播州区",
	"adcode": 520304,
	"center": [106.831668, 27.535288]
}, {
	"name": "桐梓县",
	"adcode": 520322,
	"center": [106.826591, 28.131559]
}, {
	"name": "绥阳县",
	"adcode": 520323,
	"center": [107.191024, 27.951342]
}, {
	"name": "正安县",
	"adcode": 520324,
	"center": [107.441872, 28.550337]
}, {
	"name": "道真仡佬族苗族自治县",
	"adcode": 520325,
	"center": [107.605342, 28.880088]
}, {
	"name": "务川仡佬族苗族自治县",
	"adcode": 520326,
	"center": [107.887857, 28.521567]
}, {
	"name": "凤冈县",
	"adcode": 520327,
	"center": [107.722021, 27.960858]
}, {
	"name": "湄潭县",
	"adcode": 520328,
	"center": [107.485723, 27.765839]
}, {
	"name": "余庆县",
	"adcode": 520329,
	"center": [107.892566, 27.221552]
}, {
	"name": "习水县",
	"adcode": 520330,
	"center": [106.200954, 28.327826]
}, {
	"name": "赤水市",
	"adcode": 520381,
	"center": [105.698116, 28.587057]
}, {
	"name": "仁怀市",
	"adcode": 520382,
	"center": [106.412476, 27.803377]
}, {
	"name": "西秀区",
	"adcode": 520402,
	"center": [105.946169, 26.248323]
}, {
	"name": "平坝区",
	"adcode": 520403,
	"center": [106.259942, 26.40608]
}, {
	"name": "普定县",
	"adcode": 520422,
	"center": [105.745609, 26.305794]
}, {
	"name": "镇宁布依族苗族自治县",
	"adcode": 520423,
	"center": [105.768656, 26.056096]
}, {
	"name": "关岭布依族苗族自治县",
	"adcode": 520424,
	"center": [105.618454, 25.944248]
}, {
	"name": "紫云苗族布依族自治县",
	"adcode": 520425,
	"center": [106.084515, 25.751567]
}, {
	"name": "七星关区",
	"adcode": 520502,
	"center": [105.284852, 27.302085]
}, {
	"name": "大方县",
	"adcode": 520521,
	"center": [105.609254, 27.143521]
}, {
	"name": "黔西市",
	"adcode": 520522,
	"center": [106.038299, 27.024923]
}, {
	"name": "金沙县",
	"adcode": 520523,
	"center": [106.222103, 27.459693]
}, {
	"name": "织金县",
	"adcode": 520524,
	"center": [105.768997, 26.668497]
}, {
	"name": "纳雍县",
	"adcode": 520525,
	"center": [105.375322, 26.769875]
}, {
	"name": "威宁彝族回族苗族自治县",
	"adcode": 520526,
	"center": [104.286523, 26.859099]
}, {
	"name": "赫章县",
	"adcode": 520527,
	"center": [104.726438, 27.119243]
}, {
	"name": "碧江区",
	"adcode": 520602,
	"center": [109.192117, 27.718745]
}, {
	"name": "万山区",
	"adcode": 520603,
	"center": [109.21199, 27.51903]
}, {
	"name": "江口县",
	"adcode": 520621,
	"center": [108.848427, 27.691904]
}, {
	"name": "玉屏侗族自治县",
	"adcode": 520622,
	"center": [108.917882, 27.238024]
}, {
	"name": "石阡县",
	"adcode": 520623,
	"center": [108.229854, 27.519386]
}, {
	"name": "思南县",
	"adcode": 520624,
	"center": [108.255827, 27.941331]
}, {
	"name": "印江土家族苗族自治县",
	"adcode": 520625,
	"center": [108.405517, 27.997976]
}, {
	"name": "德江县",
	"adcode": 520626,
	"center": [108.117317, 28.26094]
}, {
	"name": "沿河土家族自治县",
	"adcode": 520627,
	"center": [108.495746, 28.560487]
}, {
	"name": "松桃苗族自治县",
	"adcode": 520628,
	"center": [109.202627, 28.165419]
}, {
	"name": "兴义市",
	"adcode": 522301,
	"center": [104.897982, 25.088599]
}, {
	"name": "兴仁市",
	"adcode": 522302,
	"center": [105.192778, 25.431378]
}, {
	"name": "普安县",
	"adcode": 522323,
	"center": [104.955347, 25.786404]
}, {
	"name": "晴隆县",
	"adcode": 522324,
	"center": [105.218773, 25.832881]
}, {
	"name": "贞丰县",
	"adcode": 522325,
	"center": [105.650133, 25.385752]
}, {
	"name": "望谟县",
	"adcode": 522326,
	"center": [106.091563, 25.166667]
}, {
	"name": "册亨县",
	"adcode": 522327,
	"center": [105.81241, 24.983338]
}, {
	"name": "安龙县",
	"adcode": 522328,
	"center": [105.471498, 25.108959]
}, {
	"name": "凯里市",
	"adcode": 522601,
	"center": [107.977541, 26.582964]
}, {
	"name": "黄平县",
	"adcode": 522622,
	"center": [107.901337, 26.896973]
}, {
	"name": "施秉县",
	"adcode": 522623,
	"center": [108.12678, 27.034657]
}, {
	"name": "三穗县",
	"adcode": 522624,
	"center": [108.681121, 26.959884]
}, {
	"name": "镇远县",
	"adcode": 522625,
	"center": [108.423656, 27.050233]
}, {
	"name": "岑巩县",
	"adcode": 522626,
	"center": [108.816459, 27.173244]
}, {
	"name": "天柱县",
	"adcode": 522627,
	"center": [109.212798, 26.909684]
}, {
	"name": "锦屏县",
	"adcode": 522628,
	"center": [109.20252, 26.680625]
}, {
	"name": "剑河县",
	"adcode": 522629,
	"center": [108.440499, 26.727349]
}, {
	"name": "台江县",
	"adcode": 522630,
	"center": [108.314637, 26.669138]
}, {
	"name": "黎平县",
	"adcode": 522631,
	"center": [109.136504, 26.230636]
}, {
	"name": "榕江县",
	"adcode": 522632,
	"center": [108.521026, 25.931085]
}, {
	"name": "从江县",
	"adcode": 522633,
	"center": [108.912648, 25.747058]
}, {
	"name": "雷山县",
	"adcode": 522634,
	"center": [108.079613, 26.381027]
}, {
	"name": "麻江县",
	"adcode": 522635,
	"center": [107.593172, 26.494803]
}, {
	"name": "丹寨县",
	"adcode": 522636,
	"center": [107.794808, 26.199497]
}, {
	"name": "都匀市",
	"adcode": 522701,
	"center": [107.517021, 26.258205]
}, {
	"name": "福泉市",
	"adcode": 522702,
	"center": [107.513508, 26.702508]
}, {
	"name": "荔波县",
	"adcode": 522722,
	"center": [107.8838, 25.412239]
}, {
	"name": "贵定县",
	"adcode": 522723,
	"center": [107.233588, 26.580807]
}, {
	"name": "瓮安县",
	"adcode": 522725,
	"center": [107.478417, 27.066339]
}, {
	"name": "独山县",
	"adcode": 522726,
	"center": [107.542757, 25.826283]
}, {
	"name": "平塘县",
	"adcode": 522727,
	"center": [107.32405, 25.831803]
}, {
	"name": "罗甸县",
	"adcode": 522728,
	"center": [106.750006, 25.429894]
}, {
	"name": "长顺县",
	"adcode": 522729,
	"center": [106.447376, 26.022116]
}, {
	"name": "龙里县",
	"adcode": 522730,
	"center": [106.977733, 26.448809]
}, {
	"name": "惠水县",
	"adcode": 522731,
	"center": [106.657848, 26.128637]
}, {
	"name": "三都水族自治县",
	"adcode": 522732,
	"center": [107.87747, 25.985183]
}, {
	"name": "五华区",
	"adcode": 530102,
	"center": [102.704412, 25.042165]
}, {
	"name": "盘龙区",
	"adcode": 530103,
	"center": [102.729044, 25.070239]
}, {
	"name": "官渡区",
	"adcode": 530111,
	"center": [102.723437, 25.021211]
}, {
	"name": "西山区",
	"adcode": 530112,
	"center": [102.705904, 25.02436]
}, {
	"name": "东川区",
	"adcode": 530113,
	"center": [103.182, 26.08349]
}, {
	"name": "呈贡区",
	"adcode": 530114,
	"center": [102.801382, 24.889275]
}, {
	"name": "晋宁区",
	"adcode": 530115,
	"center": [102.594987, 24.666944]
}, {
	"name": "富民县",
	"adcode": 530124,
	"center": [102.497888, 25.219667]
}, {
	"name": "宜良县",
	"adcode": 530125,
	"center": [103.145989, 24.918215]
}, {
	"name": "石林彝族自治县",
	"adcode": 530126,
	"center": [103.271962, 24.754545]
}, {
	"name": "嵩明县",
	"adcode": 530127,
	"center": [103.038777, 25.335087]
}, {
	"name": "禄劝彝族苗族自治县",
	"adcode": 530128,
	"center": [102.46905, 25.556533]
}, {
	"name": "寻甸回族彝族自治县",
	"adcode": 530129,
	"center": [103.257588, 25.559474]
}, {
	"name": "安宁市",
	"adcode": 530181,
	"center": [102.485544, 24.921785]
}, {
	"name": "麒麟区",
	"adcode": 530302,
	"center": [103.798054, 25.501269]
}, {
	"name": "沾益区",
	"adcode": 530303,
	"center": [103.819262, 25.600878]
}, {
	"name": "马龙区",
	"adcode": 530304,
	"center": [103.578755, 25.429451]
}, {
	"name": "陆良县",
	"adcode": 530322,
	"center": [103.655233, 25.022878]
}, {
	"name": "师宗县",
	"adcode": 530323,
	"center": [103.993808, 24.825681]
}, {
	"name": "罗平县",
	"adcode": 530324,
	"center": [104.309263, 24.885708]
}, {
	"name": "富源县",
	"adcode": 530325,
	"center": [104.25692, 25.67064]
}, {
	"name": "会泽县",
	"adcode": 530326,
	"center": [103.300041, 26.412861]
}, {
	"name": "宣威市",
	"adcode": 530381,
	"center": [104.09554, 26.227777]
}, {
	"name": "红塔区",
	"adcode": 530402,
	"center": [102.543468, 24.350753]
}, {
	"name": "江川区",
	"adcode": 530403,
	"center": [102.749839, 24.291006]
}, {
	"name": "通海县",
	"adcode": 530423,
	"center": [102.760039, 24.112205]
}, {
	"name": "华宁县",
	"adcode": 530424,
	"center": [102.928982, 24.189807]
}, {
	"name": "易门县",
	"adcode": 530425,
	"center": [102.16211, 24.669598]
}, {
	"name": "峨山彝族自治县",
	"adcode": 530426,
	"center": [102.404358, 24.173256]
}, {
	"name": "新平彝族傣族自治县",
	"adcode": 530427,
	"center": [101.990903, 24.0664]
}, {
	"name": "元江哈尼族彝族傣族自治县",
	"adcode": 530428,
	"center": [101.999658, 23.597618]
}, {
	"name": "澄江市",
	"adcode": 530481,
	"center": [102.916652, 24.669679]
}, {
	"name": "隆阳区",
	"adcode": 530502,
	"center": [99.165825, 25.112144]
}, {
	"name": "施甸县",
	"adcode": 530521,
	"center": [99.183758, 24.730847]
}, {
	"name": "龙陵县",
	"adcode": 530523,
	"center": [98.693567, 24.591912]
}, {
	"name": "昌宁县",
	"adcode": 530524,
	"center": [99.612344, 24.823662]
}, {
	"name": "腾冲市",
	"adcode": 530581,
	"center": [98.497292, 25.01757]
}, {
	"name": "昭阳区",
	"adcode": 530602,
	"center": [103.717267, 27.336636]
}, {
	"name": "鲁甸县",
	"adcode": 530621,
	"center": [103.549333, 27.191637]
}, {
	"name": "巧家县",
	"adcode": 530622,
	"center": [102.929284, 26.9117]
}, {
	"name": "盐津县",
	"adcode": 530623,
	"center": [104.23506, 28.106923]
}, {
	"name": "大关县",
	"adcode": 530624,
	"center": [103.891608, 27.747114]
}, {
	"name": "永善县",
	"adcode": 530625,
	"center": [103.63732, 28.231526]
}, {
	"name": "绥江县",
	"adcode": 530626,
	"center": [103.961095, 28.599953]
}, {
	"name": "镇雄县",
	"adcode": 530627,
	"center": [104.873055, 27.436267]
}, {
	"name": "彝良县",
	"adcode": 530628,
	"center": [104.048492, 27.627425]
}, {
	"name": "威信县",
	"adcode": 530629,
	"center": [105.04869, 27.843381]
}, {
	"name": "水富市",
	"adcode": 530681,
	"center": [104.415376, 28.629688]
}, {
	"name": "古城区",
	"adcode": 530702,
	"center": [100.234412, 26.872229]
}, {
	"name": "玉龙纳西族自治县",
	"adcode": 530721,
	"center": [100.238312, 26.830593]
}, {
	"name": "永胜县",
	"adcode": 530722,
	"center": [100.750901, 26.685623]
}, {
	"name": "华坪县",
	"adcode": 530723,
	"center": [101.267796, 26.628834]
}, {
	"name": "宁蒗彝族自治县",
	"adcode": 530724,
	"center": [100.852427, 27.281109]
}, {
	"name": "思茅区",
	"adcode": 530802,
	"center": [100.973227, 22.776595]
}, {
	"name": "宁洱哈尼族彝族自治县",
	"adcode": 530821,
	"center": [101.04524, 23.062507]
}, {
	"name": "墨江哈尼族自治县",
	"adcode": 530822,
	"center": [101.687606, 23.428165]
}, {
	"name": "景东彝族自治县",
	"adcode": 530823,
	"center": [100.840011, 24.448523]
}, {
	"name": "景谷傣族彝族自治县",
	"adcode": 530824,
	"center": [100.701425, 23.500278]
}, {
	"name": "镇沅彝族哈尼族拉祜族自治县",
	"adcode": 530825,
	"center": [101.108512, 24.005712]
}, {
	"name": "江城哈尼族彝族自治县",
	"adcode": 530826,
	"center": [101.859144, 22.58336]
}, {
	"name": "孟连傣族拉祜族佤族自治县",
	"adcode": 530827,
	"center": [99.585406, 22.325924]
}, {
	"name": "澜沧拉祜族自治县",
	"adcode": 530828,
	"center": [99.931201, 22.553083]
}, {
	"name": "西盟佤族自治县",
	"adcode": 530829,
	"center": [99.594372, 22.644423]
}, {
	"name": "临翔区",
	"adcode": 530902,
	"center": [100.086486, 23.886562]
}, {
	"name": "凤庆县",
	"adcode": 530921,
	"center": [99.91871, 24.592738]
}, {
	"name": "云县",
	"adcode": 530922,
	"center": [100.125637, 24.439026]
}, {
	"name": "永德县",
	"adcode": 530923,
	"center": [99.253679, 24.028159]
}, {
	"name": "镇康县",
	"adcode": 530924,
	"center": [98.82743, 23.761415]
}, {
	"name": "双江拉祜族佤族布朗族傣族自治县",
	"adcode": 530925,
	"center": [99.824419, 23.477476]
}, {
	"name": "耿马傣族佤族自治县",
	"adcode": 530926,
	"center": [99.402495, 23.534579]
}, {
	"name": "沧源佤族自治县",
	"adcode": 530927,
	"center": [99.2474, 23.146887]
}, {
	"name": "楚雄市",
	"adcode": 532301,
	"center": [101.546145, 25.040912]
}, {
	"name": "双柏县",
	"adcode": 532322,
	"center": [101.63824, 24.685094]
}, {
	"name": "牟定县",
	"adcode": 532323,
	"center": [101.543044, 25.312111]
}, {
	"name": "南华县",
	"adcode": 532324,
	"center": [101.274991, 25.192408]
}, {
	"name": "姚安县",
	"adcode": 532325,
	"center": [101.238399, 25.505403]
}, {
	"name": "大姚县",
	"adcode": 532326,
	"center": [101.323602, 25.722348]
}, {
	"name": "永仁县",
	"adcode": 532327,
	"center": [101.671175, 26.056316]
}, {
	"name": "元谋县",
	"adcode": 532328,
	"center": [101.870837, 25.703313]
}, {
	"name": "武定县",
	"adcode": 532329,
	"center": [102.406785, 25.5301]
}, {
	"name": "禄丰市",
	"adcode": 532331,
	"center": [102.075694, 25.14327]
}, {
	"name": "个旧市",
	"adcode": 532501,
	"center": [103.154752, 23.360383]
}, {
	"name": "开远市",
	"adcode": 532502,
	"center": [103.258679, 23.713832]
}, {
	"name": "蒙自市",
	"adcode": 532503,
	"center": [103.385005, 23.366843]
}, {
	"name": "弥勒市",
	"adcode": 532504,
	"center": [103.436988, 24.40837]
}, {
	"name": "屏边苗族自治县",
	"adcode": 532523,
	"center": [103.687229, 22.987013]
}, {
	"name": "建水县",
	"adcode": 532524,
	"center": [102.820493, 23.618387]
}, {
	"name": "石屏县",
	"adcode": 532525,
	"center": [102.484469, 23.712569]
}, {
	"name": "泸西县",
	"adcode": 532527,
	"center": [103.759622, 24.532368]
}, {
	"name": "元阳县",
	"adcode": 532528,
	"center": [102.837056, 23.219773]
}, {
	"name": "红河县",
	"adcode": 532529,
	"center": [102.42121, 23.369191]
}, {
	"name": "金平苗族瑶族傣族自治县",
	"adcode": 532530,
	"center": [103.228359, 22.779982]
}, {
	"name": "绿春县",
	"adcode": 532531,
	"center": [102.39286, 22.99352]
}, {
	"name": "河口瑶族自治县",
	"adcode": 532532,
	"center": [103.961593, 22.507563]
}, {
	"name": "文山市",
	"adcode": 532601,
	"center": [104.244277, 23.369216]
}, {
	"name": "砚山县",
	"adcode": 532622,
	"center": [104.343989, 23.612301]
}, {
	"name": "西畴县",
	"adcode": 532623,
	"center": [104.675711, 23.437439]
}, {
	"name": "麻栗坡县",
	"adcode": 532624,
	"center": [104.701899, 23.124202]
}, {
	"name": "马关县",
	"adcode": 532625,
	"center": [104.398619, 23.011723]
}, {
	"name": "丘北县",
	"adcode": 532626,
	"center": [104.194366, 24.040982]
}, {
	"name": "广南县",
	"adcode": 532627,
	"center": [105.056684, 24.050272]
}, {
	"name": "富宁县",
	"adcode": 532628,
	"center": [105.62856, 23.626494]
}, {
	"name": "景洪市",
	"adcode": 532801,
	"center": [100.797947, 22.002087]
}, {
	"name": "勐海县",
	"adcode": 532822,
	"center": [100.448288, 21.955866]
}, {
	"name": "勐腊县",
	"adcode": 532823,
	"center": [101.567051, 21.479449]
}, {
	"name": "大理市",
	"adcode": 532901,
	"center": [100.241369, 25.593067]
}, {
	"name": "漾濞彝族自治县",
	"adcode": 532922,
	"center": [99.95797, 25.669543]
}, {
	"name": "祥云县",
	"adcode": 532923,
	"center": [100.554025, 25.477072]
}, {
	"name": "宾川县",
	"adcode": 532924,
	"center": [100.578957, 25.825904]
}, {
	"name": "弥渡县",
	"adcode": 532925,
	"center": [100.490669, 25.342594]
}, {
	"name": "南涧彝族自治县",
	"adcode": 532926,
	"center": [100.518683, 25.041279]
}, {
	"name": "巍山彝族回族自治县",
	"adcode": 532927,
	"center": [100.30793, 25.230909]
}, {
	"name": "永平县",
	"adcode": 532928,
	"center": [99.533536, 25.461281]
}, {
	"name": "云龙县",
	"adcode": 532929,
	"center": [99.369402, 25.884955]
}, {
	"name": "洱源县",
	"adcode": 532930,
	"center": [99.951708, 26.111184]
}, {
	"name": "剑川县",
	"adcode": 532931,
	"center": [99.905887, 26.530066]
}, {
	"name": "鹤庆县",
	"adcode": 532932,
	"center": [100.173375, 26.55839]
}, {
	"name": "瑞丽市",
	"adcode": 533102,
	"center": [97.855883, 24.010734]
}, {
	"name": "芒市",
	"adcode": 533103,
	"center": [98.577608, 24.436699]
}, {
	"name": "梁河县",
	"adcode": 533122,
	"center": [98.298196, 24.80742]
}, {
	"name": "盈江县",
	"adcode": 533123,
	"center": [97.93393, 24.709541]
}, {
	"name": "陇川县",
	"adcode": 533124,
	"center": [97.794441, 24.184065]
}, {
	"name": "泸水市",
	"adcode": 533301,
	"center": [98.854063, 25.851142]
}, {
	"name": "福贡县",
	"adcode": 533323,
	"center": [98.867413, 26.902738]
}, {
	"name": "贡山独龙族怒族自治县",
	"adcode": 533324,
	"center": [98.666141, 27.738054]
}, {
	"name": "兰坪白族普米族自治县",
	"adcode": 533325,
	"center": [99.421378, 26.453839]
}, {
	"name": "香格里拉市",
	"adcode": 533401,
	"center": [99.708667, 27.825804]
}, {
	"name": "德钦县",
	"adcode": 533422,
	"center": [98.91506, 28.483272]
}, {
	"name": "维西傈僳族自治县",
	"adcode": 533423,
	"center": [99.286355, 27.180948]
}, {
	"name": "城关区",
	"adcode": 540102,
	"center": [91.132911, 29.659472]
}, {
	"name": "堆龙德庆区",
	"adcode": 540103,
	"center": [91.002823, 29.647347]
}, {
	"name": "达孜区",
	"adcode": 540104,
	"center": [91.350976, 29.670314]
}, {
	"name": "林周县",
	"adcode": 540121,
	"center": [91.261842, 29.895754]
}, {
	"name": "当雄县",
	"adcode": 540122,
	"center": [91.103551, 30.474819]
}, {
	"name": "尼木县",
	"adcode": 540123,
	"center": [90.165545, 29.431346]
}, {
	"name": "曲水县",
	"adcode": 540124,
	"center": [90.738051, 29.349895]
}, {
	"name": "墨竹工卡县",
	"adcode": 540127,
	"center": [91.731158, 29.834657]
}, {
	"name": "桑珠孜区",
	"adcode": 540202,
	"center": [88.88667, 29.267003]
}, {
	"name": "南木林县",
	"adcode": 540221,
	"center": [89.099434, 29.680459]
}, {
	"name": "江孜县",
	"adcode": 540222,
	"center": [89.605044, 28.908845]
}, {
	"name": "定日县",
	"adcode": 540223,
	"center": [87.123887, 28.656667]
}, {
	"name": "萨迦县",
	"adcode": 540224,
	"center": [88.023007, 28.901077]
}, {
	"name": "拉孜县",
	"adcode": 540225,
	"center": [87.63743, 29.085136]
}, {
	"name": "昂仁县",
	"adcode": 540226,
	"center": [87.23578, 29.294758]
}, {
	"name": "谢通门县",
	"adcode": 540227,
	"center": [88.260517, 29.431597]
}, {
	"name": "白朗县",
	"adcode": 540228,
	"center": [89.263618, 29.106627]
}, {
	"name": "仁布县",
	"adcode": 540229,
	"center": [89.843207, 29.230299]
}, {
	"name": "康马县",
	"adcode": 540230,
	"center": [89.683406, 28.554719]
}, {
	"name": "定结县",
	"adcode": 540231,
	"center": [87.767723, 28.36409]
}, {
	"name": "仲巴县",
	"adcode": 540232,
	"center": [84.032826, 29.768336]
}, {
	"name": "亚东县",
	"adcode": 540233,
	"center": [88.906806, 27.482772]
}, {
	"name": "吉隆县",
	"adcode": 540234,
	"center": [85.298349, 28.852416]
}, {
	"name": "聂拉木县",
	"adcode": 540235,
	"center": [85.981953, 28.15595]
}, {
	"name": "萨嘎县",
	"adcode": 540236,
	"center": [85.234622, 29.328194]
}, {
	"name": "岗巴县",
	"adcode": 540237,
	"center": [88.518903, 28.274371]
}, {
	"name": "卡若区",
	"adcode": 540302,
	"center": [97.178255, 31.137035]
}, {
	"name": "江达县",
	"adcode": 540321,
	"center": [98.218351, 31.499534]
}, {
	"name": "贡觉县",
	"adcode": 540322,
	"center": [98.271191, 30.859206]
}, {
	"name": "类乌齐县",
	"adcode": 540323,
	"center": [96.601259, 31.213048]
}, {
	"name": "丁青县",
	"adcode": 540324,
	"center": [95.597748, 31.410681]
}, {
	"name": "察雅县",
	"adcode": 540325,
	"center": [97.565701, 30.653038]
}, {
	"name": "八宿县",
	"adcode": 540326,
	"center": [96.917893, 30.053408]
}, {
	"name": "左贡县",
	"adcode": 540327,
	"center": [97.840532, 29.671335]
}, {
	"name": "芒康县",
	"adcode": 540328,
	"center": [98.596444, 29.686615]
}, {
	"name": "洛隆县",
	"adcode": 540329,
	"center": [95.823418, 30.741947]
}, {
	"name": "边坝县",
	"adcode": 540330,
	"center": [94.707504, 30.933849]
}, {
	"name": "巴宜区",
	"adcode": 540402,
	"center": [94.360987, 29.653732]
}, {
	"name": "工布江达县",
	"adcode": 540421,
	"center": [93.246515, 29.88447]
}, {
	"name": "米林县",
	"adcode": 540422,
	"center": [94.213679, 29.213811]
}, {
	"name": "墨脱县",
	"adcode": 540423,
	"center": [95.332245, 29.32573]
}, {
	"name": "波密县",
	"adcode": 540424,
	"center": [95.768151, 29.858771]
}, {
	"name": "察隅县",
	"adcode": 540425,
	"center": [97.465002, 28.660244]
}, {
	"name": "朗县",
	"adcode": 540426,
	"center": [93.073429, 29.0446]
}, {
	"name": "乃东区",
	"adcode": 540502,
	"center": [91.76525, 29.236106]
}, {
	"name": "扎囊县",
	"adcode": 540521,
	"center": [91.338, 29.246476]
}, {
	"name": "贡嘎县",
	"adcode": 540522,
	"center": [90.985271, 29.289078]
}, {
	"name": "桑日县",
	"adcode": 540523,
	"center": [92.015732, 29.259774]
}, {
	"name": "琼结县",
	"adcode": 540524,
	"center": [91.683753, 29.025242]
}, {
	"name": "曲松县",
	"adcode": 540525,
	"center": [92.201066, 29.063656]
}, {
	"name": "措美县",
	"adcode": 540526,
	"center": [91.432347, 28.437353]
}, {
	"name": "洛扎县",
	"adcode": 540527,
	"center": [90.858243, 28.385765]
}, {
	"name": "加查县",
	"adcode": 540528,
	"center": [92.591043, 29.140921]
}, {
	"name": "隆子县",
	"adcode": 540529,
	"center": [92.463309, 28.408548]
}, {
	"name": "错那县",
	"adcode": 540530,
	"center": [91.960132, 27.991707]
}, {
	"name": "浪卡子县",
	"adcode": 540531,
	"center": [90.398747, 28.96836]
}, {
	"name": "色尼区",
	"adcode": 540602,
	"center": [92.061862, 31.475756]
}, {
	"name": "嘉黎县",
	"adcode": 540621,
	"center": [93.232907, 30.640846]
}, {
	"name": "比如县",
	"adcode": 540622,
	"center": [93.68044, 31.479917]
}, {
	"name": "聂荣县",
	"adcode": 540623,
	"center": [92.303659, 32.107855]
}, {
	"name": "安多县",
	"adcode": 540624,
	"center": [91.681879, 32.260299]
}, {
	"name": "申扎县",
	"adcode": 540625,
	"center": [88.709777, 30.929056]
}, {
	"name": "索县",
	"adcode": 540626,
	"center": [93.784964, 31.886173]
}, {
	"name": "班戈县",
	"adcode": 540627,
	"center": [90.011822, 31.394578]
}, {
	"name": "巴青县",
	"adcode": 540628,
	"center": [94.054049, 31.918691]
}, {
	"name": "尼玛县",
	"adcode": 540629,
	"center": [87.236646, 31.784979]
}, {
	"name": "双湖县",
	"adcode": 540630,
	"center": [88.838578, 33.18698]
}, {
	"name": "普兰县",
	"adcode": 542521,
	"center": [81.177588, 30.291896]
}, {
	"name": "札达县",
	"adcode": 542522,
	"center": [79.803191, 31.478587]
}, {
	"name": "噶尔县",
	"adcode": 542523,
	"center": [80.105005, 32.503373]
}, {
	"name": "日土县",
	"adcode": 542524,
	"center": [79.731937, 33.382454]
}, {
	"name": "革吉县",
	"adcode": 542525,
	"center": [81.142896, 32.389192]
}, {
	"name": "改则县",
	"adcode": 542526,
	"center": [84.062384, 32.302076]
}, {
	"name": "措勤县",
	"adcode": 542527,
	"center": [85.159254, 31.016774]
}, {
	"name": "新城区",
	"adcode": 610102,
	"center": [108.959903, 34.26927]
}, {
	"name": "碑林区",
	"adcode": 610103,
	"center": [108.946994, 34.251061]
}, {
	"name": "莲湖区",
	"adcode": 610104,
	"center": [108.933194, 34.2656]
}, {
	"name": "灞桥区",
	"adcode": 610111,
	"center": [109.067261, 34.267453]
}, {
	"name": "未央区",
	"adcode": 610112,
	"center": [108.946022, 34.30823]
}, {
	"name": "雁塔区",
	"adcode": 610113,
	"center": [108.926593, 34.213389]
}, {
	"name": "阎良区",
	"adcode": 610114,
	"center": [109.22802, 34.662141]
}, {
	"name": "临潼区",
	"adcode": 610115,
	"center": [109.213986, 34.372065]
}, {
	"name": "长安区",
	"adcode": 610116,
	"center": [108.941579, 34.157097]
}, {
	"name": "高陵区",
	"adcode": 610117,
	"center": [109.088896, 34.535065]
}, {
	"name": "鄠邑区",
	"adcode": 610118,
	"center": [108.607385, 34.108668]
}, {
	"name": "蓝田县",
	"adcode": 610122,
	"center": [109.317634, 34.156189]
}, {
	"name": "周至县",
	"adcode": 610124,
	"center": [108.216465, 34.161532]
}, {
	"name": "王益区",
	"adcode": 610202,
	"center": [109.075862, 35.069098]
}, {
	"name": "印台区",
	"adcode": 610203,
	"center": [109.100814, 35.111927]
}, {
	"name": "耀州区",
	"adcode": 610204,
	"center": [108.962538, 34.910206]
}, {
	"name": "宜君县",
	"adcode": 610222,
	"center": [109.118278, 35.398766]
}, {
	"name": "渭滨区",
	"adcode": 610302,
	"center": [107.144467, 34.371008]
}, {
	"name": "金台区",
	"adcode": 610303,
	"center": [107.149943, 34.375192]
}, {
	"name": "陈仓区",
	"adcode": 610304,
	"center": [107.383645, 34.352747]
}, {
	"name": "凤翔区",
	"adcode": 610322,
	"center": [107.400577, 34.521668]
}, {
	"name": "岐山县",
	"adcode": 610323,
	"center": [107.624464, 34.44296]
}, {
	"name": "扶风县",
	"adcode": 610324,
	"center": [107.891419, 34.375497]
}, {
	"name": "眉县",
	"adcode": 610326,
	"center": [107.752371, 34.272137]
}, {
	"name": "陇县",
	"adcode": 610327,
	"center": [106.857066, 34.893262]
}, {
	"name": "千阳县",
	"adcode": 610328,
	"center": [107.132987, 34.642584]
}, {
	"name": "麟游县",
	"adcode": 610329,
	"center": [107.796608, 34.677714]
}, {
	"name": "凤县",
	"adcode": 610330,
	"center": [106.525212, 33.912464]
}, {
	"name": "太白县",
	"adcode": 610331,
	"center": [107.316533, 34.059215]
}, {
	"name": "秦都区",
	"adcode": 610402,
	"center": [108.698636, 34.329801]
}, {
	"name": "杨陵区",
	"adcode": 610403,
	"center": [108.086348, 34.27135]
}, {
	"name": "渭城区",
	"adcode": 610404,
	"center": [108.730957, 34.336847]
}, {
	"name": "三原县",
	"adcode": 610422,
	"center": [108.943481, 34.613996]
}, {
	"name": "泾阳县",
	"adcode": 610423,
	"center": [108.83784, 34.528493]
}, {
	"name": "乾县",
	"adcode": 610424,
	"center": [108.247406, 34.527261]
}, {
	"name": "礼泉县",
	"adcode": 610425,
	"center": [108.428317, 34.482583]
}, {
	"name": "永寿县",
	"adcode": 610426,
	"center": [108.143129, 34.692619]
}, {
	"name": "长武县",
	"adcode": 610428,
	"center": [107.795835, 35.206122]
}, {
	"name": "旬邑县",
	"adcode": 610429,
	"center": [108.337231, 35.112234]
}, {
	"name": "淳化县",
	"adcode": 610430,
	"center": [108.581173, 34.79797]
}, {
	"name": "武功县",
	"adcode": 610431,
	"center": [108.212857, 34.259732]
}, {
	"name": "兴平市",
	"adcode": 610481,
	"center": [108.488493, 34.297134]
}, {
	"name": "彬州市",
	"adcode": 610482,
	"center": [108.083674, 35.034233]
}, {
	"name": "临渭区",
	"adcode": 610502,
	"center": [109.503299, 34.501271]
}, {
	"name": "华州区",
	"adcode": 610503,
	"center": [109.76141, 34.511958]
}, {
	"name": "潼关县",
	"adcode": 610522,
	"center": [110.24726, 34.544515]
}, {
	"name": "大荔县",
	"adcode": 610523,
	"center": [109.943123, 34.795011]
}, {
	"name": "合阳县",
	"adcode": 610524,
	"center": [110.147979, 35.237098]
}, {
	"name": "澄城县",
	"adcode": 610525,
	"center": [109.937609, 35.184]
}, {
	"name": "蒲城县",
	"adcode": 610526,
	"center": [109.589653, 34.956034]
}, {
	"name": "白水县",
	"adcode": 610527,
	"center": [109.594309, 35.177291]
}, {
	"name": "富平县",
	"adcode": 610528,
	"center": [109.187174, 34.746679]
}, {
	"name": "韩城市",
	"adcode": 610581,
	"center": [110.452391, 35.475238]
}, {
	"name": "华阴市",
	"adcode": 610582,
	"center": [110.08952, 34.565359]
}, {
	"name": "宝塔区",
	"adcode": 610602,
	"center": [109.49069, 36.596291]
}, {
	"name": "安塞区",
	"adcode": 610603,
	"center": [109.325341, 36.86441]
}, {
	"name": "延长县",
	"adcode": 610621,
	"center": [110.012961, 36.578306]
}, {
	"name": "延川县",
	"adcode": 610622,
	"center": [110.190314, 36.882066]
}, {
	"name": "志丹县",
	"adcode": 610625,
	"center": [108.768898, 36.823031]
}, {
	"name": "吴起县",
	"adcode": 610626,
	"center": [108.176976, 36.924852]
}, {
	"name": "甘泉县",
	"adcode": 610627,
	"center": [109.34961, 36.277729]
}, {
	"name": "富县",
	"adcode": 610628,
	"center": [109.384136, 35.996495]
}, {
	"name": "洛川县",
	"adcode": 610629,
	"center": [109.435712, 35.762133]
}, {
	"name": "宜川县",
	"adcode": 610630,
	"center": [110.175537, 36.050391]
}, {
	"name": "黄龙县",
	"adcode": 610631,
	"center": [109.83502, 35.583276]
}, {
	"name": "黄陵县",
	"adcode": 610632,
	"center": [109.262469, 35.580165]
}, {
	"name": "子长市",
	"adcode": 610681,
	"center": [109.675968, 37.14207]
}, {
	"name": "汉台区",
	"adcode": 610702,
	"center": [107.028233, 33.077674]
}, {
	"name": "南郑区",
	"adcode": 610703,
	"center": [106.942393, 33.003341]
}, {
	"name": "城固县",
	"adcode": 610722,
	"center": [107.329887, 33.153098]
}, {
	"name": "洋县",
	"adcode": 610723,
	"center": [107.549962, 33.223283]
}, {
	"name": "西乡县",
	"adcode": 610724,
	"center": [107.765858, 32.987961]
}, {
	"name": "勉县",
	"adcode": 610725,
	"center": [106.680175, 33.155618]
}, {
	"name": "宁强县",
	"adcode": 610726,
	"center": [106.25739, 32.830806]
}, {
	"name": "略阳县",
	"adcode": 610727,
	"center": [106.153899, 33.329638]
}, {
	"name": "镇巴县",
	"adcode": 610728,
	"center": [107.89531, 32.535854]
}, {
	"name": "留坝县",
	"adcode": 610729,
	"center": [106.924377, 33.61334]
}, {
	"name": "佛坪县",
	"adcode": 610730,
	"center": [107.988582, 33.520745]
}, {
	"name": "榆阳区",
	"adcode": 610802,
	"center": [109.74791, 38.299267]
}, {
	"name": "横山区",
	"adcode": 610803,
	"center": [109.292596, 37.964048]
}, {
	"name": "府谷县",
	"adcode": 610822,
	"center": [111.069645, 39.029243]
}, {
	"name": "靖边县",
	"adcode": 610824,
	"center": [108.80567, 37.596084]
}, {
	"name": "定边县",
	"adcode": 610825,
	"center": [107.601284, 37.59523]
}, {
	"name": "绥德县",
	"adcode": 610826,
	"center": [110.265377, 37.507701]
}, {
	"name": "米脂县",
	"adcode": 610827,
	"center": [110.178683, 37.759081]
}, {
	"name": "佳县",
	"adcode": 610828,
	"center": [110.493367, 38.021597]
}, {
	"name": "吴堡县",
	"adcode": 610829,
	"center": [110.739315, 37.451925]
}, {
	"name": "清涧县",
	"adcode": 610830,
	"center": [110.12146, 37.087702]
}, {
	"name": "子洲县",
	"adcode": 610831,
	"center": [110.03457, 37.611573]
}, {
	"name": "神木市",
	"adcode": 610881,
	"center": [110.497005, 38.835641]
}, {
	"name": "汉滨区",
	"adcode": 610902,
	"center": [109.029098, 32.690817]
}, {
	"name": "汉阴县",
	"adcode": 610921,
	"center": [108.510946, 32.891121]
}, {
	"name": "石泉县",
	"adcode": 610922,
	"center": [108.250512, 33.038512]
}, {
	"name": "宁陕县",
	"adcode": 610923,
	"center": [108.313714, 33.312184]
}, {
	"name": "紫阳县",
	"adcode": 610924,
	"center": [108.537788, 32.520176]
}, {
	"name": "岚皋县",
	"adcode": 610925,
	"center": [108.900663, 32.31069]
}, {
	"name": "平利县",
	"adcode": 610926,
	"center": [109.361865, 32.387933]
}, {
	"name": "镇坪县",
	"adcode": 610927,
	"center": [109.526437, 31.883395]
}, {
	"name": "旬阳市",
	"adcode": 610928,
	"center": [109.368149, 32.833567]
}, {
	"name": "白河县",
	"adcode": 610929,
	"center": [110.114186, 32.809484]
}, {
	"name": "商州区",
	"adcode": 611002,
	"center": [109.937685, 33.869208]
}, {
	"name": "洛南县",
	"adcode": 611021,
	"center": [110.145716, 34.088502]
}, {
	"name": "丹凤县",
	"adcode": 611022,
	"center": [110.33191, 33.694711]
}, {
	"name": "商南县",
	"adcode": 611023,
	"center": [110.885437, 33.526367]
}, {
	"name": "山阳县",
	"adcode": 611024,
	"center": [109.880435, 33.530411]
}, {
	"name": "镇安县",
	"adcode": 611025,
	"center": [109.151075, 33.423981]
}, {
	"name": "柞水县",
	"adcode": 611026,
	"center": [109.111249, 33.682773]
}, {
	"name": "城关区",
	"adcode": 620102,
	"center": [103.841032, 36.049115]
}, {
	"name": "七里河区",
	"adcode": 620103,
	"center": [103.784326, 36.06673]
}, {
	"name": "西固区",
	"adcode": 620104,
	"center": [103.622331, 36.100369]
}, {
	"name": "安宁区",
	"adcode": 620105,
	"center": [103.724038, 36.10329]
}, {
	"name": "红古区",
	"adcode": 620111,
	"center": [102.861814, 36.344177]
}, {
	"name": "永登县",
	"adcode": 620121,
	"center": [103.262203, 36.734428]
}, {
	"name": "皋兰县",
	"adcode": 620122,
	"center": [103.94933, 36.331254]
}, {
	"name": "榆中县",
	"adcode": 620123,
	"center": [104.114975, 35.84443]
}, {
	"name": "金川区",
	"adcode": 620302,
	"center": [102.187683, 38.513793]
}, {
	"name": "永昌县",
	"adcode": 620321,
	"center": [101.971957, 38.247354]
}, {
	"name": "白银区",
	"adcode": 620402,
	"center": [104.17425, 36.545649]
}, {
	"name": "平川区",
	"adcode": 620403,
	"center": [104.819207, 36.72921]
}, {
	"name": "靖远县",
	"adcode": 620421,
	"center": [104.686972, 36.561424]
}, {
	"name": "会宁县",
	"adcode": 620422,
	"center": [105.054337, 35.692486]
}, {
	"name": "景泰县",
	"adcode": 620423,
	"center": [104.066394, 37.193519]
}, {
	"name": "秦州区",
	"adcode": 620502,
	"center": [105.724477, 34.578645]
}, {
	"name": "麦积区",
	"adcode": 620503,
	"center": [105.897631, 34.563504]
}, {
	"name": "清水县",
	"adcode": 620521,
	"center": [106.139878, 34.75287]
}, {
	"name": "秦安县",
	"adcode": 620522,
	"center": [105.6733, 34.862354]
}, {
	"name": "甘谷县",
	"adcode": 620523,
	"center": [105.332347, 34.747327]
}, {
	"name": "武山县",
	"adcode": 620524,
	"center": [104.891696, 34.721955]
}, {
	"name": "张家川回族自治县",
	"adcode": 620525,
	"center": [106.212416, 34.993237]
}, {
	"name": "凉州区",
	"adcode": 620602,
	"center": [102.634492, 37.93025]
}, {
	"name": "民勤县",
	"adcode": 620621,
	"center": [103.090654, 38.624621]
}, {
	"name": "古浪县",
	"adcode": 620622,
	"center": [102.898047, 37.470571]
}, {
	"name": "天祝藏族自治县",
	"adcode": 620623,
	"center": [103.142034, 36.971678]
}, {
	"name": "甘州区",
	"adcode": 620702,
	"center": [100.454862, 38.931774]
}, {
	"name": "肃南裕固族自治县",
	"adcode": 620721,
	"center": [99.617086, 38.837269]
}, {
	"name": "民乐县",
	"adcode": 620722,
	"center": [100.816623, 38.434454]
}, {
	"name": "临泽县",
	"adcode": 620723,
	"center": [100.166333, 39.152151]
}, {
	"name": "高台县",
	"adcode": 620724,
	"center": [99.81665, 39.376308]
}, {
	"name": "山丹县",
	"adcode": 620725,
	"center": [101.088442, 38.784839]
}, {
	"name": "崆峒区",
	"adcode": 620802,
	"center": [106.684223, 35.54173]
}, {
	"name": "泾川县",
	"adcode": 620821,
	"center": [107.365218, 35.335283]
}, {
	"name": "灵台县",
	"adcode": 620822,
	"center": [107.620587, 35.064009]
}, {
	"name": "崇信县",
	"adcode": 620823,
	"center": [107.031253, 35.304533]
}, {
	"name": "庄浪县",
	"adcode": 620825,
	"center": [106.041979, 35.203428]
}, {
	"name": "静宁县",
	"adcode": 620826,
	"center": [105.733489, 35.525243]
}, {
	"name": "华亭市",
	"adcode": 620881,
	"center": [106.649308, 35.215341]
}, {
	"name": "肃州区",
	"adcode": 620902,
	"center": [98.511155, 39.743858]
}, {
	"name": "金塔县",
	"adcode": 620921,
	"center": [98.902959, 39.983036]
}, {
	"name": "瓜州县",
	"adcode": 620922,
	"center": [95.780591, 40.516525]
}, {
	"name": "肃北蒙古族自治县",
	"adcode": 620923,
	"center": [94.87728, 39.51224]
}, {
	"name": "阿克塞哈萨克族自治县",
	"adcode": 620924,
	"center": [94.337642, 39.631642]
}, {
	"name": "玉门市",
	"adcode": 620981,
	"center": [97.037206, 40.28682]
}, {
	"name": "敦煌市",
	"adcode": 620982,
	"center": [94.664279, 40.141119]
}, {
	"name": "西峰区",
	"adcode": 621002,
	"center": [107.638824, 35.733713]
}, {
	"name": "庆城县",
	"adcode": 621021,
	"center": [107.885664, 36.013504]
}, {
	"name": "环县",
	"adcode": 621022,
	"center": [107.308754, 36.569322]
}, {
	"name": "华池县",
	"adcode": 621023,
	"center": [107.986288, 36.457304]
}, {
	"name": "合水县",
	"adcode": 621024,
	"center": [108.019865, 35.819005]
}, {
	"name": "正宁县",
	"adcode": 621025,
	"center": [108.361068, 35.490642]
}, {
	"name": "宁县",
	"adcode": 621026,
	"center": [107.921182, 35.50201]
}, {
	"name": "镇原县",
	"adcode": 621027,
	"center": [107.195706, 35.677806]
}, {
	"name": "安定区",
	"adcode": 621102,
	"center": [104.62577, 35.579764]
}, {
	"name": "通渭县",
	"adcode": 621121,
	"center": [105.250102, 35.208922]
}, {
	"name": "陇西县",
	"adcode": 621122,
	"center": [104.637554, 35.003409]
}, {
	"name": "渭源县",
	"adcode": 621123,
	"center": [104.211742, 35.133023]
}, {
	"name": "临洮县",
	"adcode": 621124,
	"center": [103.862186, 35.376233]
}, {
	"name": "漳县",
	"adcode": 621125,
	"center": [104.466756, 34.848642]
}, {
	"name": "岷县",
	"adcode": 621126,
	"center": [104.039882, 34.439105]
}, {
	"name": "武都区",
	"adcode": 621202,
	"center": [104.929866, 33.388155]
}, {
	"name": "成县",
	"adcode": 621221,
	"center": [105.734434, 33.739863]
}, {
	"name": "文县",
	"adcode": 621222,
	"center": [104.682448, 32.942171]
}, {
	"name": "宕昌县",
	"adcode": 621223,
	"center": [104.394475, 34.042655]
}, {
	"name": "康县",
	"adcode": 621224,
	"center": [105.609534, 33.328266]
}, {
	"name": "西和县",
	"adcode": 621225,
	"center": [105.299737, 34.013718]
}, {
	"name": "礼县",
	"adcode": 621226,
	"center": [105.181616, 34.189387]
}, {
	"name": "徽县",
	"adcode": 621227,
	"center": [106.085632, 33.767785]
}, {
	"name": "两当县",
	"adcode": 621228,
	"center": [106.306959, 33.910729]
}, {
	"name": "临夏市",
	"adcode": 622901,
	"center": [103.211634, 35.59941]
}, {
	"name": "临夏县",
	"adcode": 622921,
	"center": [102.993873, 35.49236]
}, {
	"name": "康乐县",
	"adcode": 622922,
	"center": [103.709852, 35.371906]
}, {
	"name": "永靖县",
	"adcode": 622923,
	"center": [103.319871, 35.938933]
}, {
	"name": "广河县",
	"adcode": 622924,
	"center": [103.576188, 35.481688]
}, {
	"name": "和政县",
	"adcode": 622925,
	"center": [103.350357, 35.425971]
}, {
	"name": "东乡族自治县",
	"adcode": 622926,
	"center": [103.389568, 35.66383]
}, {
	"name": "积石山保安族东乡族撒拉族自治县",
	"adcode": 622927,
	"center": [102.877473, 35.712906]
}, {
	"name": "合作市",
	"adcode": 623001,
	"center": [102.91149, 34.985973]
}, {
	"name": "临潭县",
	"adcode": 623021,
	"center": [103.353054, 34.69164]
}, {
	"name": "卓尼县",
	"adcode": 623022,
	"center": [103.508508, 34.588165]
}, {
	"name": "舟曲县",
	"adcode": 623023,
	"center": [104.370271, 33.782964]
}, {
	"name": "迭部县",
	"adcode": 623024,
	"center": [103.221009, 34.055348]
}, {
	"name": "玛曲县",
	"adcode": 623025,
	"center": [102.075767, 33.998068]
}, {
	"name": "碌曲县",
	"adcode": 623026,
	"center": [102.488495, 34.589591]
}, {
	"name": "夏河县",
	"adcode": 623027,
	"center": [102.520743, 35.200853]
}, {
	"name": "城东区",
	"adcode": 630102,
	"center": [101.796095, 36.616043]
}, {
	"name": "城中区",
	"adcode": 630103,
	"center": [101.784554, 36.621181]
}, {
	"name": "城西区",
	"adcode": 630104,
	"center": [101.763649, 36.628323]
}, {
	"name": "城北区",
	"adcode": 630105,
	"center": [101.761297, 36.648448]
}, {
	"name": "湟中区",
	"adcode": 630106,
	"center": [101.569475, 36.500419]
}, {
	"name": "大通回族土族自治县",
	"adcode": 630121,
	"center": [101.684183, 36.931343]
}, {
	"name": "湟源县",
	"adcode": 630123,
	"center": [101.263435, 36.684818]
}, {
	"name": "乐都区",
	"adcode": 630202,
	"center": [102.402431, 36.480291]
}, {
	"name": "平安区",
	"adcode": 630203,
	"center": [102.104295, 36.502714]
}, {
	"name": "民和回族土族自治县",
	"adcode": 630222,
	"center": [102.804209, 36.329451]
}, {
	"name": "互助土族自治县",
	"adcode": 630223,
	"center": [101.956734, 36.83994]
}, {
	"name": "化隆回族自治县",
	"adcode": 630224,
	"center": [102.262329, 36.098322]
}, {
	"name": "循化撒拉族自治县",
	"adcode": 630225,
	"center": [102.486534, 35.847247]
}, {
	"name": "门源回族自治县",
	"adcode": 632221,
	"center": [101.618461, 37.376627]
}, {
	"name": "祁连县",
	"adcode": 632222,
	"center": [100.249778, 38.175409]
}, {
	"name": "海晏县",
	"adcode": 632223,
	"center": [100.90049, 36.959542]
}, {
	"name": "刚察县",
	"adcode": 632224,
	"center": [100.138417, 37.326263]
}, {
	"name": "同仁市",
	"adcode": 632301,
	"center": [102.017604, 35.516337]
}, {
	"name": "尖扎县",
	"adcode": 632322,
	"center": [102.031953, 35.938205]
}, {
	"name": "泽库县",
	"adcode": 632323,
	"center": [101.469343, 35.036842]
}, {
	"name": "河南蒙古族自治县",
	"adcode": 632324,
	"center": [101.611877, 34.734522]
}, {
	"name": "共和县",
	"adcode": 632521,
	"center": [100.619597, 36.280286]
}, {
	"name": "同德县",
	"adcode": 632522,
	"center": [100.579465, 35.254492]
}, {
	"name": "贵德县",
	"adcode": 632523,
	"center": [101.431856, 36.040456]
}, {
	"name": "兴海县",
	"adcode": 632524,
	"center": [99.986963, 35.58909]
}, {
	"name": "贵南县",
	"adcode": 632525,
	"center": [100.74792, 35.587085]
}, {
	"name": "玛沁县",
	"adcode": 632621,
	"center": [100.243531, 34.473386]
}, {
	"name": "班玛县",
	"adcode": 632622,
	"center": [100.737955, 32.931589]
}, {
	"name": "甘德县",
	"adcode": 632623,
	"center": [99.902589, 33.966987]
}, {
	"name": "达日县",
	"adcode": 632624,
	"center": [99.651715, 33.753259]
}, {
	"name": "久治县",
	"adcode": 632625,
	"center": [101.484884, 33.430217]
}, {
	"name": "玛多县",
	"adcode": 632626,
	"center": [98.211343, 34.91528]
}, {
	"name": "玉树市",
	"adcode": 632701,
	"center": [97.008762, 33.00393]
}, {
	"name": "杂多县",
	"adcode": 632722,
	"center": [95.293423, 32.891886]
}, {
	"name": "称多县",
	"adcode": 632723,
	"center": [97.110893, 33.367884]
}, {
	"name": "治多县",
	"adcode": 632724,
	"center": [95.616843, 33.852322]
}, {
	"name": "囊谦县",
	"adcode": 632725,
	"center": [96.479797, 32.203206]
}, {
	"name": "曲麻莱县",
	"adcode": 632726,
	"center": [95.800674, 34.12654]
}, {
	"name": "格尔木市",
	"adcode": 632801,
	"center": [94.905777, 36.401541]
}, {
	"name": "德令哈市",
	"adcode": 632802,
	"center": [97.370143, 37.374555]
}, {
	"name": "茫崖市",
	"adcode": 632803,
	"center": [90.855955, 38.247117]
}, {
	"name": "乌兰县",
	"adcode": 632821,
	"center": [98.479852, 36.930389]
}, {
	"name": "都兰县",
	"adcode": 632822,
	"center": [98.089161, 36.298553]
}, {
	"name": "天峻县",
	"adcode": 632823,
	"center": [99.02078, 37.29906]
}, {
	"name": "海西蒙古族藏族自治州直辖",
	"adcode": 632825,
	"center": [95.357233, 37.853631]
}, {
	"name": "兴庆区",
	"adcode": 640104,
	"center": [106.278393, 38.46747]
}, {
	"name": "西夏区",
	"adcode": 640105,
	"center": [106.132116, 38.492424]
}, {
	"name": "金凤区",
	"adcode": 640106,
	"center": [106.228486, 38.477353]
}, {
	"name": "永宁县",
	"adcode": 640121,
	"center": [106.253781, 38.28043]
}, {
	"name": "贺兰县",
	"adcode": 640122,
	"center": [106.345904, 38.554563]
}, {
	"name": "灵武市",
	"adcode": 640181,
	"center": [106.334701, 38.094058]
}, {
	"name": "大武口区",
	"adcode": 640202,
	"center": [106.376651, 39.014158]
}, {
	"name": "惠农区",
	"adcode": 640205,
	"center": [106.775513, 39.230094]
}, {
	"name": "平罗县",
	"adcode": 640221,
	"center": [106.54489, 38.90674]
}, {
	"name": "利通区",
	"adcode": 640302,
	"center": [106.199419, 37.985967]
}, {
	"name": "红寺堡区",
	"adcode": 640303,
	"center": [106.067315, 37.421616]
}, {
	"name": "盐池县",
	"adcode": 640323,
	"center": [107.40541, 37.784222]
}, {
	"name": "同心县",
	"adcode": 640324,
	"center": [105.914764, 36.9829]
}, {
	"name": "青铜峡市",
	"adcode": 640381,
	"center": [106.075395, 38.021509]
}, {
	"name": "原州区",
	"adcode": 640402,
	"center": [106.28477, 36.005337]
}, {
	"name": "西吉县",
	"adcode": 640422,
	"center": [105.731801, 35.965384]
}, {
	"name": "隆德县",
	"adcode": 640423,
	"center": [106.12344, 35.618234]
}, {
	"name": "泾源县",
	"adcode": 640424,
	"center": [106.338674, 35.49344]
}, {
	"name": "彭阳县",
	"adcode": 640425,
	"center": [106.641512, 35.849975]
}, {
	"name": "沙坡头区",
	"adcode": 640502,
	"center": [105.190536, 37.514564]
}, {
	"name": "中宁县",
	"adcode": 640521,
	"center": [105.675784, 37.489736]
}, {
	"name": "海原县",
	"adcode": 640522,
	"center": [105.647323, 36.562007]
}, {
	"name": "天山区",
	"adcode": 650102,
	"center": [87.620116, 43.796428]
}, {
	"name": "沙依巴克区",
	"adcode": 650103,
	"center": [87.596639, 43.788872]
}, {
	"name": "新市区",
	"adcode": 650104,
	"center": [87.560653, 43.870882]
}, {
	"name": "水磨沟区",
	"adcode": 650105,
	"center": [87.613093, 43.816747]
}, {
	"name": "头屯河区",
	"adcode": 650106,
	"center": [87.425823, 43.876053]
}, {
	"name": "达坂城区",
	"adcode": 650107,
	"center": [88.30994, 43.36181]
}, {
	"name": "米东区",
	"adcode": 650109,
	"center": [87.691801, 43.960982]
}, {
	"name": "乌鲁木齐县",
	"adcode": 650121,
	"center": [87.505603, 43.982546]
}, {
	"name": "独山子区",
	"adcode": 650202,
	"center": [84.882267, 44.327207]
}, {
	"name": "克拉玛依区",
	"adcode": 650203,
	"center": [84.868918, 45.600477]
}, {
	"name": "白碱滩区",
	"adcode": 650204,
	"center": [85.129882, 45.689021]
}, {
	"name": "乌尔禾区",
	"adcode": 650205,
	"center": [85.697767, 46.08776]
}, {
	"name": "高昌区",
	"adcode": 650402,
	"center": [89.182324, 42.947627]
}, {
	"name": "鄯善县",
	"adcode": 650421,
	"center": [90.212692, 42.865503]
}, {
	"name": "托克逊县",
	"adcode": 650422,
	"center": [88.655771, 42.793536]
}, {
	"name": "伊州区",
	"adcode": 650502,
	"center": [93.509174, 42.833888]
}, {
	"name": "巴里坤哈萨克自治县",
	"adcode": 650521,
	"center": [93.021795, 43.599032]
}, {
	"name": "伊吾县",
	"adcode": 650522,
	"center": [94.692773, 43.252012]
}, {
	"name": "昌吉市",
	"adcode": 652301,
	"center": [87.304112, 44.013183]
}, {
	"name": "阜康市",
	"adcode": 652302,
	"center": [87.98384, 44.152153]
}, {
	"name": "呼图壁县",
	"adcode": 652323,
	"center": [86.888613, 44.189342]
}, {
	"name": "玛纳斯县",
	"adcode": 652324,
	"center": [86.217687, 44.305625]
}, {
	"name": "奇台县",
	"adcode": 652325,
	"center": [89.591437, 44.021996]
}, {
	"name": "吉木萨尔县",
	"adcode": 652327,
	"center": [89.181288, 43.997162]
}, {
	"name": "木垒哈萨克自治县",
	"adcode": 652328,
	"center": [90.282833, 43.832442]
}, {
	"name": "博乐市",
	"adcode": 652701,
	"center": [82.072237, 44.903087]
}, {
	"name": "阿拉山口市",
	"adcode": 652702,
	"center": [82.569389, 45.16777]
}, {
	"name": "精河县",
	"adcode": 652722,
	"center": [82.892938, 44.605645]
}, {
	"name": "温泉县",
	"adcode": 652723,
	"center": [81.03099, 44.973751]
}, {
	"name": "库尔勒市",
	"adcode": 652801,
	"center": [86.145948, 41.763122]
}, {
	"name": "轮台县",
	"adcode": 652822,
	"center": [84.248542, 41.781266]
}, {
	"name": "尉犁县",
	"adcode": 652823,
	"center": [86.263412, 41.337428]
}, {
	"name": "若羌县",
	"adcode": 652824,
	"center": [88.168807, 39.023807]
}, {
	"name": "且末县",
	"adcode": 652825,
	"center": [85.532629, 38.138562]
}, {
	"name": "焉耆回族自治县",
	"adcode": 652826,
	"center": [86.5698, 42.064349]
}, {
	"name": "和静县",
	"adcode": 652827,
	"center": [86.391067, 42.31716]
}, {
	"name": "和硕县",
	"adcode": 652828,
	"center": [86.864947, 42.268863]
}, {
	"name": "博湖县",
	"adcode": 652829,
	"center": [86.631576, 41.980166]
}, {
	"name": "阿克苏市",
	"adcode": 652901,
	"center": [80.2629, 41.171272]
}, {
	"name": "库车市",
	"adcode": 652902,
	"center": [82.96304, 41.717141]
}, {
	"name": "温宿县",
	"adcode": 652922,
	"center": [80.243273, 41.272995]
}, {
	"name": "沙雅县",
	"adcode": 652924,
	"center": [82.78077, 41.226268]
}, {
	"name": "新和县",
	"adcode": 652925,
	"center": [82.610828, 41.551176]
}, {
	"name": "拜城县",
	"adcode": 652926,
	"center": [81.869881, 41.796101]
}, {
	"name": "乌什县",
	"adcode": 652927,
	"center": [79.230805, 41.21587]
}, {
	"name": "阿瓦提县",
	"adcode": 652928,
	"center": [80.378426, 40.638422]
}, {
	"name": "柯坪县",
	"adcode": 652929,
	"center": [79.04785, 40.50624]
}, {
	"name": "阿图什市",
	"adcode": 653001,
	"center": [76.173939, 39.712898]
}, {
	"name": "阿克陶县",
	"adcode": 653022,
	"center": [75.945159, 39.147079]
}, {
	"name": "阿合奇县",
	"adcode": 653023,
	"center": [78.450164, 40.937567]
}, {
	"name": "乌恰县",
	"adcode": 653024,
	"center": [75.25969, 39.716633]
}, {
	"name": "喀什市",
	"adcode": 653101,
	"center": [75.98838, 39.467861]
}, {
	"name": "疏附县",
	"adcode": 653121,
	"center": [75.863075, 39.378306]
}, {
	"name": "疏勒县",
	"adcode": 653122,
	"center": [76.053653, 39.399461]
}, {
	"name": "英吉沙县",
	"adcode": 653123,
	"center": [76.174292, 38.929839]
}, {
	"name": "泽普县",
	"adcode": 653124,
	"center": [77.273593, 38.191217]
}, {
	"name": "莎车县",
	"adcode": 653125,
	"center": [77.248884, 38.414499]
}, {
	"name": "叶城县",
	"adcode": 653126,
	"center": [77.420353, 37.884679]
}, {
	"name": "麦盖提县",
	"adcode": 653127,
	"center": [77.651538, 38.903384]
}, {
	"name": "岳普湖县",
	"adcode": 653128,
	"center": [76.7724, 39.235248]
}, {
	"name": "伽师县",
	"adcode": 653129,
	"center": [76.741982, 39.494325]
}, {
	"name": "巴楚县",
	"adcode": 653130,
	"center": [78.55041, 39.783479]
}, {
	"name": "塔什库尔干塔吉克自治县",
	"adcode": 653131,
	"center": [75.228068, 37.775437]
}, {
	"name": "和田市",
	"adcode": 653201,
	"center": [79.927542, 37.108944]
}, {
	"name": "和田县",
	"adcode": 653221,
	"center": [79.81907, 37.120031]
}, {
	"name": "墨玉县",
	"adcode": 653222,
	"center": [79.736629, 37.271511]
}, {
	"name": "皮山县",
	"adcode": 653223,
	"center": [78.282301, 37.616332]
}, {
	"name": "洛浦县",
	"adcode": 653224,
	"center": [80.184038, 37.074377]
}, {
	"name": "策勒县",
	"adcode": 653225,
	"center": [80.803572, 37.001672]
}, {
	"name": "于田县",
	"adcode": 653226,
	"center": [81.667845, 36.854628]
}, {
	"name": "民丰县",
	"adcode": 653227,
	"center": [82.692354, 37.064909]
}, {
	"name": "伊宁市",
	"adcode": 654002,
	"center": [81.316343, 43.922209]
}, {
	"name": "奎屯市",
	"adcode": 654003,
	"center": [84.901602, 44.423445]
}, {
	"name": "霍尔果斯市",
	"adcode": 654004,
	"center": [80.420759, 44.201669]
}, {
	"name": "伊宁县",
	"adcode": 654021,
	"center": [81.524671, 43.977876]
}, {
	"name": "察布查尔锡伯自治县",
	"adcode": 654022,
	"center": [81.150874, 43.838883]
}, {
	"name": "霍城县",
	"adcode": 654023,
	"center": [80.872508, 44.049912]
}, {
	"name": "巩留县",
	"adcode": 654024,
	"center": [82.227044, 43.481618]
}, {
	"name": "新源县",
	"adcode": 654025,
	"center": [83.258493, 43.434249]
}, {
	"name": "昭苏县",
	"adcode": 654026,
	"center": [81.126029, 43.157765]
}, {
	"name": "特克斯县",
	"adcode": 654027,
	"center": [81.840058, 43.214861]
}, {
	"name": "尼勒克县",
	"adcode": 654028,
	"center": [82.504119, 43.789737]
}, {
	"name": "塔城市",
	"adcode": 654201,
	"center": [82.983988, 46.746281]
}, {
	"name": "乌苏市",
	"adcode": 654202,
	"center": [84.677624, 44.430115]
}, {
	"name": "额敏县",
	"adcode": 654221,
	"center": [83.622118, 46.522555]
}, {
	"name": "沙湾市",
	"adcode": 654223,
	"center": [85.622508, 44.329544]
}, {
	"name": "托里县",
	"adcode": 654224,
	"center": [83.60469, 45.935863]
}, {
	"name": "裕民县",
	"adcode": 654225,
	"center": [82.982157, 46.202781]
}, {
	"name": "和布克赛尔蒙古自治县",
	"adcode": 654226,
	"center": [85.733551, 46.793001]
}, {
	"name": "阿勒泰市",
	"adcode": 654301,
	"center": [88.138743, 47.848911]
}, {
	"name": "布尔津县",
	"adcode": 654321,
	"center": [86.86186, 47.70453]
}, {
	"name": "富蕴县",
	"adcode": 654322,
	"center": [89.524993, 46.993106]
}, {
	"name": "福海县",
	"adcode": 654323,
	"center": [87.494569, 47.113128]
}, {
	"name": "哈巴河县",
	"adcode": 654324,
	"center": [86.418964, 48.059284]
}, {
	"name": "青河县",
	"adcode": 654325,
	"center": [90.381561, 46.672446]
}, {
	"name": "吉木乃县",
	"adcode": 654326,
	"center": [85.876064, 47.434633]
}, {
	"name": "中西区",
	"adcode": 810001,
	"center": [114.1543731, 22.28198083]
}, {
	"name": "湾仔区",
	"adcode": 810002,
	"center": [114.1829153, 22.27638889]
}, {
	"name": "东区",
	"adcode": 810003,
	"center": [114.2260031, 22.27969306]
}, {
	"name": "南区",
	"adcode": 810004,
	"center": [114.1600117, 22.24589667]
}, {
	"name": "油尖旺区",
	"adcode": 810005,
	"center": [114.1733317, 22.31170389]
}, {
	"name": "深水埗区",
	"adcode": 810006,
	"center": [114.1632417, 22.33385417]
}, {
	"name": "九龙城区",
	"adcode": 810007,
	"center": [114.1928467, 22.31251]
}, {
	"name": "黄大仙区",
	"adcode": 810008,
	"center": [114.2038856, 22.33632056]
}, {
	"name": "观塘区",
	"adcode": 810009,
	"center": [114.2140542, 22.32083778]
}, {
	"name": "荃湾区",
	"adcode": 810010,
	"center": [114.1210792, 22.36830667]
}, {
	"name": "屯门区",
	"adcode": 810011,
	"center": [113.9765742, 22.39384417]
}, {
	"name": "元朗区",
	"adcode": 810012,
	"center": [114.0324381, 22.44142833]
}, {
	"name": "北区",
	"adcode": 810013,
	"center": [114.1473639, 22.49610389]
}, {
	"name": "大埔区",
	"adcode": 810014,
	"center": [114.1717431, 22.44565306]
}, {
	"name": "西贡区",
	"adcode": 810015,
	"center": [114.264645, 22.31421306]
}, {
	"name": "沙田区",
	"adcode": 810016,
	"center": [114.1953653, 22.37953167]
}, {
	"name": "葵青区",
	"adcode": 810017,
	"center": [114.1393194, 22.36387667]
}, {
	"name": "离岛区",
	"adcode": 810018,
	"center": [113.94612, 22.28640778]
}, {
	"name": "花地玛堂区",
	"adcode": 820001,
	"center": [113.5528956, 22.20787]
}, {
	"name": "花王堂区",
	"adcode": 820002,
	"center": [113.5489608, 22.1992075]
}, {
	"name": "望德堂区",
	"adcode": 820003,
	"center": [113.5501828, 22.19372083]
}, {
	"name": "大堂区",
	"adcode": 820004,
	"center": [113.5536475, 22.18853944]
}, {
	"name": "风顺堂区",
	"adcode": 820005,
	"center": [113.5419278, 22.18736806]
}, {
	"name": "嘉模堂区",
	"adcode": 820006,
	"center": [113.5587044, 22.15375944]
}, {
	"name": "路凼填海区",
	"adcode": 820007,
	"center": [113.5695992, 22.13663]
}, {
	"name": "圣方济各堂区",
	"adcode": 820008,
	"center": [113.5599542, 22.12348639]
}]